(function() {
  function initBundleProduct(root) {
    if (!root || root._cfBundleProductInitialized) return;
    root._cfBundleProductInitialized = true;
    var openCustomizerOnLoad = root.getAttribute('data-cf-open-customizer-on-load') === 'true';
    var openPackRailOnLoad = root.getAttribute('data-cf-pack-rail-expanded-on-load') === 'true';
    var selectedSizeOnLoad = root.getAttribute('data-cf-selected-size-on-load') || selectedSizeFromUrl();
    var cleanupCallbacks = [];
    var navigatingBundle = false;
    root.removeAttribute('data-cf-open-customizer-on-load');
    root.removeAttribute('data-cf-pack-rail-expanded-on-load');
    root.removeAttribute('data-cf-selected-size-on-load');

    function addCleanup(callback) {
      if (typeof callback === 'function') cleanupCallbacks.push(callback);
    }

    function cleanupBundleProduct() {
      cleanupCallbacks.forEach(function(callback) {
        try {
          callback();
        } catch (error) {}
      });
      cleanupCallbacks = [];
    }

    root._cfBundleProductCleanup = cleanupBundleProduct;

	    var dataEl = root.querySelector('[data-cf-bundle-config]');
	    var fallbackEl = root.querySelector('[data-cf-product-fallback]');
	    var cartEl = root.querySelector('[data-cf-bundle-cart]');
	    var packCollectionOptionsEl = root.querySelector('[data-cf-pack-collection-options]');
	    var componentFallbacksEl = root.querySelector('[data-cf-component-fallbacks]');
	    var componentProductsEl = root.querySelector('[data-cf-component-products]');
	    var config = {};
	    var fallback = {};
	    var cartOnLoad = [];
	    var collectionPackOptions = [];
	    var componentFallbacks = [];
	    var componentProducts = [];
    function componentFallbackSku(value) {
      return String(
        value && typeof value === 'object'
          ? (value.sku || value.SKU || value.variantSku || value.variant_sku || value.componentSku || value.component_sku || value.sourceSku || value.source_sku || '')
          : value || ''
      ).trim();
    }

    function normaliseComponentFallbacks(value) {
      var entries = [];
      var seen = {};

      function addEntry(entry) {
        var sku = componentFallbackSku(entry);
        if (!sku) return;
        var normalized = entry && typeof entry === 'object' && !Array.isArray(entry)
          ? Object.assign({}, entry, { sku: sku })
          : { sku: sku };
        var key = String(sku).trim().toUpperCase();
        if (seen[key]) return;
        seen[key] = true;
        entries.push(normalized);
      }

      function visit(item) {
        if (!item) return;
        if (Array.isArray(item)) {
          item.forEach(visit);
          return;
        }
        if (typeof item === 'string') {
          var trimmed = item.trim();
          if (/^[\[{]/.test(trimmed)) {
            try {
              visit(JSON.parse(trimmed));
              return;
            } catch (error) {}
          }
          trimmed.split(/[,|\n]/).forEach(function(part) {
            addEntry(part);
          });
          return;
        }
        if (typeof item === 'object') {
          visit(item.componentQuantities || item.component_quantities || item.bundleComponentQuantities || item.bundle_component_quantities);
          visit(item.components || item.bundleComponents || item.bundle_components);
          addEntry(item);
        }
      }

      visit(value);
      return entries;
    }

    try {
      config = JSON.parse(dataEl ? dataEl.textContent : '{}') || {};
    } catch (error) {
      config = {};
    }
	    try {
	      fallback = JSON.parse(fallbackEl ? fallbackEl.textContent : '{}') || {};
	    } catch (error) {
	      fallback = {};
	    }
	    try {
	      cartOnLoad = JSON.parse(cartEl ? cartEl.textContent : '[]') || [];
	    } catch (error) {
	      cartOnLoad = [];
	    }
	    try {
	      collectionPackOptions = JSON.parse(packCollectionOptionsEl ? packCollectionOptionsEl.textContent : '[]') || [];
	    } catch (error) {
	      collectionPackOptions = [];
	    }
	    try {
	      componentFallbacks = JSON.parse(componentFallbacksEl ? componentFallbacksEl.textContent : '[]') || [];
	    } catch (error) {
      componentFallbacks = [];
    }
    componentFallbacks = normaliseComponentFallbacks(componentFallbacks);
    var explicitComponentFallbacks = componentFallbacks.slice();
    try {
      componentProducts = JSON.parse(componentProductsEl ? componentProductsEl.textContent : '[]') || [];
    } catch (error) {
      componentProducts = [];
    }

    function appendConfiguredComponentFallbacks(bundleConfig) {
      bundleConfig = bundleConfig || {};
      var seen = {};
      componentFallbacks.forEach(function(item) {
        if (item && item.sku) seen[String(item.sku).trim().toUpperCase()] = true;
      });
      (Array.isArray(bundleConfig.sizes) ? bundleConfig.sizes : []).forEach(function(size) {
        ['components', 'componentQuantities', 'slots', 'options'].forEach(function(key) {
          (Array.isArray(size && size[key]) ? size[key] : []).forEach(function(entry) {
            if (!entry || !entry.sku) return;
            var sku = String(entry.sku).trim().toUpperCase();
            if (!sku || seen[sku]) return;
            seen[sku] = true;
            componentFallbacks.push(entry);
          });
        });
      });
    }

    appendConfiguredComponentFallbacks(config);

    var defaultDiscountTiers = [
      { quantity: 3, percent: 50 },
      { quantity: 6, percent: 60 },
      { quantity: 10, percent: 68 }
    ];
    var themeDiscountTierText = fallback.discountTiers || '3:25,6:35,9:45';

    function parseDiscountTierString(value) {
      return String(value || '')
        .split(/[\n,;]+/)
        .map(function(part) {
          var pieces = part.split(':');
          if (pieces.length < 2) pieces = part.split('=');
          return normaliseDiscountTier({
            quantity: pieces[0],
            percent: pieces[1]
          });
        })
        .filter(Boolean);
    }

    var themeDiscountTiers = parseDiscountTierString(themeDiscountTierText);
    var syncedDiscountTiers = Array.isArray(config.discountTiers)
      ? config.discountTiers
      : (Array.isArray(config.bundleDiscountTiers) ? config.bundleDiscountTiers : []);
    var configuredDiscountTiers = themeDiscountTiers.length
      ? themeDiscountTiers
      : syncedDiscountTiers;

    function normaliseDiscountTier(tier) {
      if (!tier) return null;
      var quantity = parseFloat(String(tier.quantity || tier.minQuantity || tier.minimumQuantity || tier.qty || tier.count || '').replace(/[^0-9.]/g, ''));
      var percent = parseFloat(String(tier.percent || tier.discountPercent || tier.percentage || tier.discount || '').replace(/[^0-9.]/g, ''));
      if (!Number.isFinite(quantity) || quantity <= 0 || !Number.isFinite(percent) || percent <= 0) return null;
      return { quantity: Math.floor(quantity), percent: Math.min(95, Math.max(0, percent)) };
    }

    var bundleDiscountTiers = (configuredDiscountTiers.length ? configuredDiscountTiers : defaultDiscountTiers)
      .map(normaliseDiscountTier)
      .filter(Boolean)
      .sort(function(a, b) { return a.quantity - b.quantity; });
    var activeCartItemCount = cartItemCount(cartOnLoad);
    var currentProduct = {
      id: fallback.id || '',
      handle: fallback.handle || '',
      url: fallback.url || productPageUrl(fallback.handle),
      title: fallback.title || '',
      imageUrl: usableImageUrl(fallback.imageUrl)
    };

    var componentFallbackBySku = {};

    function rebuildComponentFallbackIndex() {
      componentFallbackBySku = {};
      componentFallbacks.forEach(function(item) {
        if (!item || !item.sku) return;
        componentFallbackBySku[normalKey(item.sku)] = item;
      });
    }

    rebuildComponentFallbackIndex();
    var componentProductByHandle = {};
    var componentProductBySku = {};
    var componentProductBySkuStem = {};
    var componentProductByFamilyKey = {};
    componentProducts.forEach(function(item) {
      if (!item || !item.handle) return;
      componentProductByHandle[String(item.handle)] = item;
      (Array.isArray(item.variants) ? item.variants : []).forEach(function(variant) {
        if (!variant || !variant.sku) return;
        var skuKey = normalKey(variant.sku);
        var stemKey = skuProductStem(variant.sku);
        var familyKey = componentFamilyKey(variant);
        if (skuKey && !componentProductBySku[skuKey]) componentProductBySku[skuKey] = item;
        if (stemKey && !componentProductBySkuStem[stemKey]) componentProductBySkuStem[stemKey] = item;
        if (familyKey && !componentProductByFamilyKey[familyKey]) componentProductByFamilyKey[familyKey] = item;
      });
    });
    var productJsonByHandle = {};
    var variantJsonById = {};
    var componentVariantAvailabilityById = {};

    function buildComponentDetailsIndex(bundleConfig) {
      var index = {};
      if (!Array.isArray(bundleConfig && bundleConfig.componentDetails)) return index;
      bundleConfig.componentDetails.forEach(function(detail) {
        if (!detail) return;
        [detail.productId, detail.productHandle, detail.productTitle, detail.title].forEach(function(key) {
          if (key && !index[String(key)]) index[String(key)] = detail;
        });
      });
      return index;
    }

    var componentDetailsByKey = buildComponentDetailsIndex(config);

    function normalKey(value) {
      return String(value || '').trim().toUpperCase();
    }

    function looseKey(value) {
      return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
    }

    function normalId(value) {
      return String(value || '').trim().split('/').pop();
    }

    function normalSize(value) {
      return String(value || '').trim().toUpperCase().replace(/[\s_-]+/g, '');
    }

    function selectedSizeFromUrl() {
      try {
        return new URL(window.location.href).searchParams.get('cf_size') || '';
      } catch (error) {
        return '';
      }
    }

    function sizeOptionForValue(sizeList, value) {
      var cleanSize = sizeToken(value);
      return cleanSize ? ((Array.isArray(sizeList) ? sizeList : []).find(function(size) { return size && size.available !== false && sizeToken(size.size || size.title || size.name || size) === cleanSize; }) || null) : null;
    }

    function sizeToken(value) {
      var key = normalSize(value), m = {SMALL:'S',MEDIUM:'M',LARGE:'L',XLARGE:'XL',XXL:'2XL',XXLARGE:'2XL',XXXL:'3XL',XXXLARGE:'3XL',XXXXL:'4XL',XXXXXL:'5XL'};
      return m[key] || key;
    }

    function isGymtierSupportedSize(value) {
      var key = sizeToken(value && (value.size || value.title || value.name || value));
      return key === 'S' || key === 'M' || key === 'L' || key === 'XL' || key === '2XL' || key === '3XL' || key === '4XL' || key === '5XL';
    }

    function cartSize(value, sizeList) {
      var key = sizeToken(value), list = Array.isArray(sizeList) ? sizeList : [], i, label;
      if (!key) return '';
      for (i = 0; i < list.length; i += 1) { label = String(list[i] && (list[i].size || list[i].title || list[i].name || list[i]) || '').trim(); if (label && sizeToken(label) === key) return label; }
      return '';
    }

    function firstSize(values, sizeList) {
      for (var i = 0, size; i < values.length; i += 1) { size = cartSize(values[i], sizeList); if (size) return size; }
      return '';
    }

    function sizeFromCartItem(item, sizeList) {
      item = item || [];
      return firstSize((Array.isArray(item[3]) ? item[3] : []), sizeList)
        || firstSize(String(item[1] || '').split(/[-_\s/]+/).filter(Boolean).reverse(), sizeList)
        || firstSize(String(item[2] || '').split(/[-_\s/,|]+/).filter(Boolean).reverse(), sizeList);
    }

    function cartPreferredSize(cart, sizeList) {
      var scores = {}, bestSize = '', bestScore = 0;
      (Array.isArray(cart) ? cart : []).forEach(function(item) { var size = sizeFromCartItem(item, sizeList); if (!size) return; scores[size] = (scores[size] || 0) + (Number(item[0]) || 1); if (scores[size] > bestScore) { bestScore = scores[size]; bestSize = size; } });
      return bestSize;
    }

    function sizeRank(size) {
      var value = normalSize(size && (size.size || size.title || size.name || size));
      var ranks = {
        S: 1,
        M: 2,
        L: 3,
        XL: 4,
        XXL: 5,
        '2XL': 5,
        XXXL: 6,
        '3XL': 6,
        XXXXL: 7,
        '4XL': 7,
        XXXXXL: 8,
        '5XL': 8,
        '6XL': 9,
        '7XL': 10,
        '8XL': 11
      };
      return ranks[value] != null ? ranks[value] : 1000;
    }

    function sortSizesByFitOrder(sizeList) {
      return (Array.isArray(sizeList) ? sizeList.slice() : []).filter(isGymtierSupportedSize).sort(function(first, second) {
        var firstRank = sizeRank(first);
        var secondRank = sizeRank(second);
        if (firstRank !== secondRank) return firstRank - secondRank;
        return String(first && (first.size || first.title || first.name) || '').localeCompare(String(second && (second.size || second.title || second.name) || ''));
      });
    }

    function usableImageUrl(value) {
      var url = String(value || '').trim();
      if (!url) return '';
      if (/^(https?:)?\/\//i.test(url) || url.charAt(0) === '/') return url;
      return '';
    }

    function shopifyRootPath() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function productJsonUrl(handle) {
      var cleanHandle = cleanProductHandle(handle);
      return cleanHandle ? shopifyRootPath() + 'products/' + encodeURIComponent(cleanHandle) + '.js' : '';
    }

    function productPageUrl(handle) {
      var cleanHandle = cleanProductHandle(handle);
      return cleanHandle ? shopifyRootPath() + 'products/' + encodeURIComponent(cleanHandle) : '';
    }

    function activePreviewThemeId() {
      try {
        var params = new URL(window.location.href).searchParams;
        return params.get('preview_theme_id') || '';
      } catch (error) {
        return '';
      }
    }

    function bundleDataUrl(handle, view) {
      var url = productPageUrl(handle);
      if (!url) return '';
      try {
        var parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('view', view || 'ajax_bundle_data');
        var previewThemeId = activePreviewThemeId();
        if (previewThemeId) parsed.searchParams.set('preview_theme_id', previewThemeId);
        return parsed.pathname + parsed.search + parsed.hash;
      } catch (error) {
        return url + '?view=' + encodeURIComponent(view || 'ajax_bundle_data');
      }
    }

    function packPageUrl(handle) {
      var url = productPageUrl(handle);
      if (!url) return '';
      try {
        var parsed = new URL(url, window.location.origin);
        var previewThemeId = activePreviewThemeId();
        if (previewThemeId) parsed.searchParams.set('preview_theme_id', previewThemeId);
        return parsed.pathname + parsed.search + parsed.hash;
      } catch (error) {
        return url;
      }
    }

    function cleanProductHandle(value) {
      var text = String(value || '').trim();
      if (!text) return '';
      var productMatch = text.match(/\/products\/([^?#]+)/);
      return decodeURIComponent(productMatch ? productMatch[1] : text.replace(/^\/products\//, '').split('?')[0]);
    }

    function familySearchUrl(familyKey) {
      var query = normalKey(familyKey);
      if (!query) return '';
      return shopifyRootPath() + 'search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=8&resources%5Boptions%5D%5Bfields%5D=title,variants.sku,tag';
    }

    function variantJsonUrl(id) {
      var cleanId = normalId(id);
      return cleanId ? shopifyRootPath() + 'variants/' + encodeURIComponent(cleanId) + '.js' : '';
    }

    function fetchVariantJson(id) {
      var cleanId = normalId(id);
      if (!cleanId) return Promise.resolve(null);
      if (!variantJsonById[cleanId]) {
        variantJsonById[cleanId] = fetch(variantJsonUrl(cleanId), {
          headers: { 'Accept': 'application/json' }
        })
          .then(function(response) {
            return response.ok ? response.json() : null;
          })
          .catch(function() {
            return null;
          });
      }
      return variantJsonById[cleanId];
    }

    function componentVariantAvailabilityKey(option) {
      return normalId(option && (
        option.shopifyVariantId ||
        option.variantId ||
        option.id
      ));
    }

    function hydrateSelectionAvailability(option) {
      var variantKey = componentVariantAvailabilityKey(option);
      if (!variantKey || componentVariantAvailabilityById[variantKey] != null) {
        return Promise.resolve(null);
      }
      return fetchVariantJson(variantKey).then(function(variantData) {
        if (variantData && variantData.available != null) {
          componentVariantAvailabilityById[variantKey] = variantData.available !== false;
        }
        return variantData;
      });
    }

    function fetchProductJson(handle, familyKey) {
      var cleanHandle = cleanProductHandle(handle);
      if (!cleanHandle) return Promise.resolve(null);
      if (!productJsonByHandle['json:' + cleanHandle]) {
        productJsonByHandle['json:' + cleanHandle] = fetch(productJsonUrl(cleanHandle), {
          headers: { 'Accept': 'application/json' }
        })
          .then(function(response) {
            return response.ok ? response.json() : null;
          })
          .then(function(productData) {
            return rememberComponentProduct(normalizeProductData(productData, cleanHandle), familyKey);
          })
          .catch(function() {
            return null;
          });
      }
      return productJsonByHandle['json:' + cleanHandle];
    }

    function normalizeProductImage(image) {
      if (!image) return null;
      if (typeof image === 'string') {
        var imageUrl = usableImageUrl(image);
        return imageUrl ? {
          url: imageUrl,
          src: imageUrl,
          thumbUrl: imageUrl,
          alt: ''
        } : null;
      }
      var preview = image.preview_image || {};
      return {
        url: usableImageUrl(image.url || image.src || preview.url || preview.src),
        src: usableImageUrl(image.src || image.url || preview.src || preview.url),
        thumbUrl: usableImageUrl(preview.src || preview.url || image.src || image.url),
        alt: image.alt || ''
      };
    }

	    function normalizeProductVariant(variant) {
	      if (!variant) return null;
      var options = Array.isArray(variant.options) ? variant.options : [];
      var titleParts = String(variant.title || variant.public_title || '').split('/').map(function(part) {
        return part.trim();
      }).filter(Boolean);
      var imageUrl = imageFromVariantData(variant);
      return {
        id: variant.id || variant.admin_graphql_api_id || null,
        sku: variant.sku || '',
        option1: variant.option1 || options[0] || titleParts[0] || '',
        option2: variant.option2 || options[1] || titleParts[1] || '',
        option3: variant.option3 || options[2] || titleParts[2] || '',
        available: variant.available !== false,
        price: variant.price,
        compare_at_price: variant.compare_at_price,
        imageUrl: imageUrl,
        thumbUrl: imageUrl
	      };
	    }

	    function parseMaybeJson(value) {
	      if (!value) return value;
	      if (typeof value !== 'string') return value;
	      var text = value.trim();
	      if (!text) return null;
	      try {
	        return JSON.parse(text);
	      } catch (error) {
	        return value;
	      }
	    }

	    function normalizeRawSizeGuide(rawProduct) {
	      if (!rawProduct) return null;
	      var guide = rawProduct.sizeGuide ||
	        rawProduct.size_guide ||
	        rawProduct.sizeguide ||
	        rawProduct.SizeGuide ||
	        rawProduct.metafields && rawProduct.metafields.custom && rawProduct.metafields.custom.size_guide ||
	        rawProduct.metafields && rawProduct.metafields.print_foundry && rawProduct.metafields.print_foundry.size_guide ||
	        null;
	      guide = parseMaybeJson(guide);
	      if (guide && guide.value) guide = parseMaybeJson(guide.value);
	      return guide && typeof guide === 'object' ? guide : null;
	    }

	    function normalizeProductData(rawProduct, handle) {
	      if (!rawProduct) return null;
      var media = Array.isArray(rawProduct.media) ? rawProduct.media : [];
      var rawImages = media.length ? media : (Array.isArray(rawProduct.images) ? rawProduct.images : []);
      var images = rawImages.map(normalizeProductImage).filter(function(image) {
        return image && image.url;
      });
      var variants = (Array.isArray(rawProduct.variants) ? rawProduct.variants : [])
        .map(normalizeProductVariant)
        .filter(function(variant) { return variant && variant.sku; });
      if (!variants.length) return null;
      return {
        id: rawProduct.id || null,
        handle: cleanProductHandle(rawProduct.handle || handle),
	        title: rawProduct.title || '',
	        featured_image: usableImageUrl(rawProduct.featured_image) || (images[0] && images[0].url) || '',
	        images: images,
	        variants: variants,
	        sizeGuide: normalizeRawSizeGuide(rawProduct)
	      };
	    }

	    function productDataFromHtml(html, handle) {
	      if (!html || typeof DOMParser === 'undefined') return null;
	      var cleanHandle = cleanProductHandle(handle);
	      var doc = new DOMParser().parseFromString(html, 'text/html');
	      var fallbackProducts = Array.prototype.map.call(doc.querySelectorAll('[data-cf-product-fallback]'), function(jsonEl) {
	        try {
	          return JSON.parse(jsonEl.textContent || '{}') || null;
	        } catch (err) {
	          return null;
	        }
	      }).filter(Boolean);
	      var fallbackMatch = fallbackProducts.find(function(productData) {
	        return cleanHandle && cleanProductHandle(productData.handle) === cleanHandle;
	      }) || fallbackProducts[0] || null;
	      var products = Array.prototype.map.call(doc.querySelectorAll('[data-json-product]'), function(jsonEl) {
	        try {
	          return normalizeProductData(JSON.parse(jsonEl.getAttribute('data-json-product') || ''), handle);
	        } catch (err) {
	          return null;
	        }
	      }).filter(Boolean);
	      if (fallbackMatch) {
	        products.forEach(function(productData) {
	          if (!productData) return;
	          var sameHandle = cleanHandle && cleanProductHandle(productData.handle) === cleanHandle;
	          if (sameHandle || !productData.sizeGuide) {
	            productData.sizeGuide = productData.sizeGuide || normalizeRawSizeGuide(fallbackMatch);
	          }
	        });
	      }
	      if (!products.length) return fallbackMatch ? normalizeProductData(fallbackMatch, cleanHandle) : null;
	      return products.find(function(productData) {
	        return cleanHandle && cleanProductHandle(productData.handle) === cleanHandle;
	      }) || (fallbackMatch ? normalizeProductData(fallbackMatch, cleanHandle) : null);
	    }

    function rememberComponentProduct(productData, familyKey) {
      if (!productData) return null;
      var handle = cleanProductHandle(productData.handle);
      if (handle) componentProductByHandle[handle] = productData;
      if (familyKey) componentProductByFamilyKey[familyKey] = productData;
	      (Array.isArray(productData.variants) ? productData.variants : []).forEach(function(variant) {
	        if (!variant || !variant.sku) return;
	        var skuKey = normalKey(variant.sku);
	        var variantFamilyKey = componentFamilyKey(variant) || familyKey;
	        if (skuKey && (!componentProductBySku[skuKey] || (!componentProductBySku[skuKey].sizeGuide && productData.sizeGuide))) componentProductBySku[skuKey] = productData;
	        if (variantFamilyKey && (!componentProductByFamilyKey[variantFamilyKey] || (!componentProductByFamilyKey[variantFamilyKey].sizeGuide && productData.sizeGuide))) componentProductByFamilyKey[variantFamilyKey] = productData;
	        var stemKey = skuProductStem(variant.sku);
	        if (stemKey && (!componentProductBySkuStem[stemKey] || (!componentProductBySkuStem[stemKey].sizeGuide && productData.sizeGuide))) componentProductBySkuStem[stemKey] = productData;
	      });
      return productData;
    }

    function fetchProductPageData(handle, familyKey) {
      var cleanHandle = cleanProductHandle(handle);
      if (!cleanHandle) return Promise.resolve(null);
      if (!productJsonByHandle[cleanHandle]) {
        productJsonByHandle[cleanHandle] = fetch(productPageUrl(cleanHandle), {
          headers: { 'Accept': 'text/html' }
        })
          .then(function(response) {
            return response.ok ? response.text() : '';
          })
          .then(function(html) {
            return rememberComponentProduct(productDataFromHtml(html, cleanHandle), familyKey);
          })
          .catch(function() {
            return null;
          });
      }
      return productJsonByHandle[cleanHandle];
    }

    function searchComponentProductByFamilyKey(familyKey) {
      var cleanFamilyKey = normalKey(familyKey);
      if (!cleanFamilyKey) return Promise.resolve(null);
      if (componentProductByFamilyKey[cleanFamilyKey]) return Promise.resolve(componentProductByFamilyKey[cleanFamilyKey]);
      if (!productJsonByHandle['family:' + cleanFamilyKey]) {
        productJsonByHandle['family:' + cleanFamilyKey] = fetch(familySearchUrl(cleanFamilyKey), {
          headers: { 'Accept': 'application/json' }
        })
          .then(function(response) {
            return response.ok ? response.json() : null;
          })
          .then(function(payload) {
            var products = (((payload || {}).resources || {}).results || {}).products || [];
            var match = products.find(function(product) {
              var tags = Array.isArray(product.tags) ? product.tags.map(normalKey) : [];
              return tags.indexOf(cleanFamilyKey) >= 0 || tags.indexOf('CLASSICFIT-FAMILY-' + cleanFamilyKey) >= 0;
            }) || products[0];
            var handle = cleanProductHandle(match && (match.handle || match.url));
            if (!handle) return null;
            return fetchProductJson(handle, cleanFamilyKey).then(function(productData) {
              return productData || fetchProductPageData(handle, cleanFamilyKey);
            });
          })
          .catch(function() {
            return null;
          });
      }
      return productJsonByHandle['family:' + cleanFamilyKey];
    }

    function fetchComponentProductDataForOption(option) {
      var existing = componentProductForOption(option);
      if (existing) return Promise.resolve(existing);
      var familyKey = componentFamilyKey(option);
      var fallbackItem = option && option.sku ? componentFallbackBySku[normalKey(option.sku)] : null;
      var handle = cleanProductHandle(option && (
        option.productHandle ||
        option.product_handle ||
        option.handle
      ) || fallbackItem && fallbackItem.productHandle);
      if (handle) {
        return fetchProductJson(handle, familyKey).then(function(productData) {
          return productData || fetchProductPageData(handle, familyKey);
        }).then(function(productData) {
          return productData || (familyKey ? searchComponentProductByFamilyKey(familyKey) : null);
        });
      }
      if (familyKey) return searchComponentProductByFamilyKey(familyKey);
      return Promise.resolve(null);
    }

    function imageFromVariantData(variant) {
      if (!variant) return '';
      var normalizedImageUrl = usableImageUrl(
        variant.imageUrl ||
        variant.image_url ||
        variant.thumbUrl ||
        variant.thumb_url
      );
      if (normalizedImageUrl) return normalizedImageUrl;
      if (variant.featured_image) {
        if (typeof variant.featured_image === 'string') return usableImageUrl(variant.featured_image);
        return usableImageUrl(variant.featured_image.src || variant.featured_image.url);
      }
      if (variant.image) {
        if (typeof variant.image === 'string') return usableImageUrl(variant.image);
        return usableImageUrl(variant.image.src || variant.image.url);
      }
      return '';
    }

    function imageFromProductData(productData, selection) {
      if (!productData) return '';
      var selectedVariantId = normalId(selection && selection.shopifyVariantId);
      var selectedSku = normalKey(selection && selection.sku);
      var variants = Array.isArray(productData.variants) ? productData.variants : [];
      var images = Array.isArray(productData.images) ? productData.images : [];
      var colorImages = images.filter(function(image) {
        return image && colorAltMatchesOption(image.alt, selection);
      });
      var preferredModelImage = colorImages.find(function(image) {
        var metadata = taggedGalleryMetadata(image.alt);
        return metadata.model && metadata.primary;
      }) || colorImages.find(function(image) {
        return taggedGalleryMetadata(image.alt).model;
      });
      var preferredModelImageUrl = usableImageUrl(preferredModelImage && (
        preferredModelImage.thumbUrl ||
        preferredModelImage.url ||
        preferredModelImage.src
      ));
      if (preferredModelImageUrl) return preferredModelImageUrl;

      var variant = variants.find(function(candidate) {
        return selectedVariantId && normalId(candidate.id) === selectedVariantId;
      }) || variants.find(function(candidate) {
        return selectedSku && normalKey(candidate.sku) === selectedSku;
      });
      var imageUrl = imageFromVariantData(variant);
      if (imageUrl) return imageUrl;

      var preferredColorImage = colorImages.find(function(image) {
        return taggedGalleryMetadata(image.alt).primary;
      }) || colorImages[0];
      imageUrl = usableImageUrl(preferredColorImage && (
        preferredColorImage.thumbUrl ||
        preferredColorImage.url ||
        preferredColorImage.src
      ));
      if (imageUrl) return imageUrl;

      if (looseKey(optionColorName(selection))) return '';
      imageUrl = usableImageUrl(productData.featured_image);
      if (imageUrl) return imageUrl;
      if (images.length) {
        var firstImage = images[0];
        return usableImageUrl(typeof firstImage === 'string' ? firstImage : firstImage && (firstImage.src || firstImage.url));
      }
      return '';
    }

    function applySlotImage(selection, image, imageWrap, imageUrl) {
      if (!image || !imageWrap) return;
      image.onerror = function() {
        selection._brokenImageUrl = image.src || imageUrl || selection.imageUrl || '';
        selection.imageUrl = '';
        image.hidden = true;
        image.removeAttribute('src');
        hydrateSelectionImage(selection, image, imageWrap, true);
      };
      if (!imageUrl) {
        image.hidden = true;
        image.removeAttribute('src');
        return;
      }
      image.alt = optionLabel(selection);
      image.src = imageUrl;
      image.hidden = false;
    }

    function hydrateSelectionImage(selection, image, imageWrap, force) {
      if (!selection || (selection._imageRequestStarted && !force)) return;
      if (!componentFamilyKey(selection) && !selection.shopifyVariantId) return;
      selection._imageRequestStarted = true;
      fetchComponentProductDataForOption(selection).then(function(productData) {
        var productImageUrl = imageFromProductData(productData, selection);
        if (productImageUrl && !(selection._brokenImageUrl && sameImageUrl(selection._brokenImageUrl, productImageUrl))) return productImageUrl;
        return fetchVariantJson(selection.shopifyVariantId).then(function(variantData) {
          return imageFromVariantData(variantData);
        });
      }).then(function(imageUrl) {
        if (!imageUrl) return;
        if (selection._brokenImageUrl && sameImageUrl(selection._brokenImageUrl, imageUrl)) return;
        selection.imageUrl = imageUrl;
        if (image && imageWrap && imageWrap.isConnected) {
          applySlotImage(selection, image, imageWrap, imageUrl);
        }
      });
    }

    function imageKey(value) {
      return usableImageUrl(value)
        .split('?')[0]
        .replace(/_(?:[0-9]+x[0-9]*|[0-9]+x|x[0-9]+)(?=\.[a-z0-9]+$)/i, '')
        .toLowerCase();
    }

    function sameImageUrl(first, second) {
      var firstKey = imageKey(first);
      var secondKey = imageKey(second);
      return Boolean(firstKey && secondKey && firstKey === secondKey);
    }

    function packQuantity(option) {
      var quantity = Number(option && (option.quantity || option.qty || option.count));
      return Number.isFinite(quantity) && quantity > 0 ? Math.floor(quantity) : null;
    }

    function packTitle(option) {
      var quantity = packQuantity(option);
      if (quantity === 1) return 'Singles';
      if (quantity) return quantity + '-Pack';
      return String(option && (option.displayName || option.title) || 'Pack');
    }

    function packUrl(option) {
      if (!option) return '';
      if (option.url) return String(option.url);
      if (option.handle) return '/products/' + String(option.handle).replace(/^\/products\//, '');
      return '';
    }

    function packOptionHandle(option) {
      if (!option) return '';
      return cleanProductHandle(option.handle || option.url || option.productHandle || option.product_handle);
    }

    function mergePackBundleData(option, data) {
      option = option || {};
      data = data || {};
      var fallbackData = data.fallback || {};
      var packConfig = data.config && typeof data.config === 'object' ? data.config : null;
      if (packConfig) option.config = packConfig;
      if (fallbackData.handle) option.handle = cleanProductHandle(fallbackData.handle);
      if (fallbackData.url) option.url = fallbackData.url;
      if (fallbackData.title && !option.title) option.title = fallbackData.title;
      if (fallbackData.title && !option.displayName) option.displayName = fallbackData.title;
      if (usableImageUrl(fallbackData.imageUrl) && !usableImageUrl(option.imageUrl)) option.imageUrl = fallbackData.imageUrl;
      if (Array.isArray(fallbackData.images) && fallbackData.images.length && !(Array.isArray(option.images) && option.images.length)) option.images = fallbackData.images;

      var nextFallbacks = normaliseComponentFallbacks(data.componentFallbacks);
      if (nextFallbacks.length) {
        componentFallbacks = normaliseComponentFallbacks(componentFallbacks.concat(nextFallbacks));
        rebuildComponentFallbackIndex();
      }

      (Array.isArray(data.componentProducts) ? data.componentProducts : []).forEach(function(productData) {
        rememberComponentProduct(normalizeProductData(productData, productData && productData.handle), null);
      });

      return normalizePackOption(option) || option;
    }

    function fetchPackBundleData(option) {
      var handle = packOptionHandle(option);
      if (!handle) return Promise.resolve(null);
      if (!productJsonByHandle['bundle-data:' + handle]) {
        function fetchBundlePayload(view) {
          return fetch(bundleDataUrl(handle, view), {
            credentials: 'same-origin',
            headers: { 'Accept': view === 'ajax_bundle_data' ? 'application/json, text/plain' : 'text/plain' }
          })
            .then(function(response) {
              return response.ok ? response.text() : '';
            })
            .then(function(text) {
              var payload = parseQuickshopBundleData(text);
              return payload && payload.config ? payload : null;
            })
            .catch(function() {
              return null;
            });
        }

        function fetchBundlePagePayload() {
          return fetch(packPageUrl(handle), {
            credentials: 'same-origin',
            headers: { 'Accept': 'text/html' }
          })
            .then(function(response) {
              return response.ok ? response.text() : '';
            })
            .then(function(html) {
              return parseBundlePageData(html);
            })
            .catch(function() {
              return null;
            });
        }

        productJsonByHandle['bundle-data:' + handle] = fetchBundlePayload('ajax_bundle_data')
          .then(function(data) {
            return data || fetchBundlePayload('gymtier_bundle_data');
          })
          .then(function(data) {
            return data || fetchBundlePayload('ajax_quick_shop_data');
          })
          .then(function(data) {
            return data || fetchBundlePagePayload();
          })
          .then(function(data) {
            return data ? mergePackBundleData(option, data) : null;
          })
          .catch(function() {
            return null;
          });
      }
      return productJsonByHandle['bundle-data:' + handle];
    }

    function readBundlePageJson(rootNode, selector, fallbackValue) {
      if (!rootNode || !rootNode.querySelector) return fallbackValue;
      var jsonEl = rootNode.querySelector(selector);
      if (!jsonEl) return fallbackValue;
      try {
        return JSON.parse(jsonEl.textContent || '') || fallbackValue;
      } catch (error) {
        return fallbackValue;
      }
    }

    function parseBundlePageData(html) {
      if (!html || typeof DOMParser === 'undefined') return null;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nextRoot = doc.querySelector('[data-cf-bundle-product]');
      if (!nextRoot) return null;
      var nextConfig = readBundlePageJson(nextRoot, '[data-cf-bundle-config]', {});
      if (!nextConfig || !Array.isArray(nextConfig.sizes) || !nextConfig.sizes.length) return null;
      return {
        config: nextConfig,
        fallback: readBundlePageJson(nextRoot, '[data-cf-product-fallback]', {}),
        componentFallbacks: readBundlePageJson(nextRoot, '[data-cf-component-fallbacks]', []),
        componentProducts: readBundlePageJson(nextRoot, '[data-cf-component-products]', [])
      };
    }

    function parseQuickshopBundleData(text) {
      var raw = String(text || '').trim();
      if (!raw) return null;
      try {
        if (raw.charAt(0) === '{') {
          return JSON.parse(raw);
        }
      } catch (error) {}
      var match = raw.match(/quick_view_inven_array_\d+\s*=\s*({[\s\S]*})\s*;?\s*$/);
      if (!match) return null;
      try {
        var inventoryPayload = JSON.parse(match[1]);
        if (inventoryPayload && inventoryPayload._bundleData) return inventoryPayload._bundleData;
        if (inventoryPayload && inventoryPayload._bundleDataEncoded) {
          return JSON.parse(decodeShopifyEncodedJson(inventoryPayload._bundleDataEncoded));
        }
        return null;
      } catch (error) {
        return null;
      }
    }

    function decodeShopifyEncodedJson(value) {
      return decodeURIComponent(String(value || '').replace(/\+/g, '%20'));
    }

    function isCurrentPackOption(option) {
      if (!option) return false;
      var url = packUrl(option);
      var handle = cleanProductHandle(option.handle || url);
      return handle === currentProduct.handle ||
        String(option.handle || '') === currentProduct.handle ||
        url === currentProduct.url ||
        url === '/products/' + currentProduct.handle;
    }

    function isCurrentProductUrl(url) {
      var cleanUrl = bundleNavigationUrl(url);
      if (!cleanUrl) return false;
      return cleanProductHandle(cleanUrl) === currentProduct.handle ||
        cleanUrl === currentProduct.url ||
        cleanUrl === '/products/' + currentProduct.handle;
    }

    function normalizePackOption(option) {
      if (!option) return null;
      var quantity = packQuantity(option);
      if (!quantity) return null;
      var normalized = Object.assign({}, option);
      normalized.quantity = quantity;
      normalized.title = packTitle(normalized);
      normalized.url = packUrl(normalized);
      normalized.imageUrl = normalized.imageUrl || null;
      normalized.images = Array.isArray(normalized.images) ? normalized.images : [];
      normalized.config = normalized.config && typeof normalized.config === 'object' ? normalized.config : null;
      normalized.collectionIndex = Number.isFinite(Number(normalized.collectionIndex)) ? Number(normalized.collectionIndex) : null;
      normalized.active = isCurrentPackOption(normalized);
      return normalized;
    }

    function packOptionIsBundlePack(option) {
      return packQuantity(option) > 1;
    }

    function dedupePackOptions(options) {
      var seen = {};
      return options.filter(function(option) {
        var key = packOptionKey(option);
        if (!key || seen[key]) return false;
        seen[key] = true;
        return true;
      });
    }

    function packOptionKey(option) {
      if (!option) return '';
      return String(option.productId || option.url || option.handle || option.title || '') + ':' + option.quantity;
    }

    function packOptionSortLabel(option) {
      if (!option) return '';
      var handle = cleanProductHandle(option.handle || option.url);
      return String(handle || option.url || option.productId || option.displayName || option.title || '');
    }

    function packOptionCollectionIndex(option) {
      if (!option) return null;
      var index = Number(option.collectionIndex);
      return Number.isFinite(index) ? index : null;
    }

    function comparePackMerchandising(first, second, hasPriority) {
      var firstPriority = first && first.priority != null ? Number(first.priority) : null;
      var secondPriority = second && second.priority != null ? Number(second.priority) : null;
      if (hasPriority) {
        if (Number.isFinite(firstPriority) && Number.isFinite(secondPriority) && firstPriority !== secondPriority) return firstPriority - secondPriority;
        if (Number.isFinite(firstPriority) && !Number.isFinite(secondPriority)) return -1;
        if (!Number.isFinite(firstPriority) && Number.isFinite(secondPriority)) return 1;
      }
      var firstCollectionIndex = packOptionCollectionIndex(first);
      var secondCollectionIndex = packOptionCollectionIndex(second);
      if (firstCollectionIndex !== null && secondCollectionIndex !== null && firstCollectionIndex !== secondCollectionIndex) return firstCollectionIndex - secondCollectionIndex;
      if (firstCollectionIndex !== null && secondCollectionIndex === null) return -1;
      if (firstCollectionIndex === null && secondCollectionIndex !== null) return 1;
      return 0;
    }

	    function sortRailPackOptions(options) {
	      var optionList = Array.isArray(options) ? options.slice() : [];
	      var hasPriority = optionList.some(function(option) {
	        return option && option.priority != null && Number.isFinite(Number(option.priority));
	      });
	      var sortedOptions = optionList.sort(function(first, second) {
	        var merchandisingSort = comparePackMerchandising(first, second, hasPriority);
	        if (merchandisingSort !== 0) return merchandisingSort;
	        return packOptionSortLabel(first).localeCompare(packOptionSortLabel(second));
	      });
	      return sortedOptions;
	    }

    function detailsForEntry(entry) {
      if (!entry) return null;
      if (entry.details) return entry.details;
      return componentDetailsByKey[String(entry.productId || '')] ||
        componentDetailsByKey[String(entry.productHandle || '')] ||
        componentDetailsByKey[String(entry.productTitle || '')] ||
        null;
    }

    function productDetailText(value) {
      return String(value || '').trim();
    }

    function productDetailFeatures(value) {
      if (Array.isArray(value)) {
        return value.map(productDetailText).filter(Boolean);
      }
      return productDetailText(value).split(/\r?\n/).map(productDetailText).filter(Boolean);
    }

    function normaliseProductDetails(details) {
      if (!details || typeof details !== 'object') return null;
      var normalized = {
        title: productDetailText(details.title || details.baseTitle || details.productTitle),
        descriptionHtml: productDetailText(details.descriptionHtml || details.description || details.shortDescription),
        features: productDetailFeatures(details.features),
        fabricComposition: productDetailText(details.fabricComposition || details.fabric),
        fit: productDetailText(details.fit),
        care: productDetailText(details.care)
      };
      return normalized.title ||
        normalized.descriptionHtml ||
        normalized.features.length ||
        normalized.fabricComposition ||
        normalized.fit ||
        normalized.care
        ? normalized
        : null;
    }

    var themeProductDetails = normaliseProductDetails(fallback.themeDetails);

    function sameComponentProduct(option, selection) {
      if (!selection) return true;
      var optionFamilyKey = componentFamilyKey(option);
      var selectionFamilyKey = componentFamilyKey(selection);
      if (optionFamilyKey && selectionFamilyKey) return optionFamilyKey === selectionFamilyKey;
      if (option.productId && selection.productId) return String(option.productId) === String(selection.productId);
      if (option.productHandle && selection.productHandle) return String(option.productHandle) === String(selection.productHandle);
      if (option.productTitle && selection.productTitle) return String(option.productTitle) === String(selection.productTitle);
      return true;
    }

    function optionMatchesComponent(fallbackItem, component, size) {
      if (!fallbackItem || !component) return false;
      if (normalSize(fallbackItem.size) !== normalSize(size && size.size)) return false;
      if (fallbackItem.productHandle && component.productHandle) {
        return String(fallbackItem.productHandle) === String(component.productHandle);
      }
      if (fallbackItem.productTitle && component.productTitle) {
        return String(fallbackItem.productTitle) === String(component.productTitle);
      }
      return normalKey(fallbackItem.sku).indexOf(normalKey(component.sku).split('-').slice(0, -2).join('-')) === 0;
    }

    function dedupeOptions(options) {
      var seen = {};
      return options.filter(function(option) {
        if (!option || !option.sku) return false;
        var key = normalKey(option.sku);
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });
    }

    function patchComponentEntry(entry) {
      if (!entry || !entry.sku) return entry;
      var fallbackItem = componentFallbackBySku[normalKey(entry.sku)];
      if (fallbackItem) {
        if (!entry.shopifyVariantId && fallbackItem.variantId) entry.shopifyVariantId = fallbackItem.variantId;
        if (usableImageUrl(fallbackItem.imageUrl) && (!usableImageUrl(entry.imageUrl) || sameImageUrl(entry.imageUrl, currentProduct.imageUrl))) {
          entry.imageUrl = fallbackItem.imageUrl;
        }
        if (!entry.productTitle && fallbackItem.productTitle) entry.productTitle = fallbackItem.productTitle;
        if (!entry.productHandle && fallbackItem.productHandle) entry.productHandle = fallbackItem.productHandle;
        if (!entry.variantTitle && fallbackItem.variantTitle) entry.variantTitle = fallbackItem.variantTitle;
        if (!entry.colorName && fallbackItem.colorName) entry.colorName = fallbackItem.colorName;
        if (!entry.colorHex && fallbackItem.colorHex) entry.colorHex = fallbackItem.colorHex;
        if (!entry.colourHex && fallbackItem.colorHex) entry.colourHex = fallbackItem.colorHex;
        if (!entry.hex && fallbackItem.colorHex) entry.hex = fallbackItem.colorHex;
        if (!entry.size && fallbackItem.size) entry.size = fallbackItem.size;
        if (fallbackItem.price != null) {
          entry.price = fallbackItem.price;
          entry.pricePence = fallbackItem.price;
        }
        if (fallbackItem.compareAtPrice != null) {
          entry.compareAtPrice = fallbackItem.compareAtPrice;
          entry.compareAtPricePence = fallbackItem.compareAtPrice;
        }
        if (!entry.details && fallbackItem.details) entry.details = fallbackItem.details;
        if (entry.available == null && fallbackItem.available != null) entry.available = fallbackItem.available;
      }
      var familyKey = componentFamilyKey(entry) || componentFamilyKey(fallbackItem);
      if (familyKey) {
        entry.componentFamilyKey = familyKey;
        entry.component_family_key = familyKey;
        if (!entry.componentFamilyTag) entry.componentFamilyTag = 'classicfit-family-' + familyKey;
      }
      var quantity = Number(entry.quantity || entry.qty || entry.count || entry.componentQuantity || entry.componentQty || entry.quantityInBundle);
      if (Number.isFinite(quantity) && quantity > 0) {
        entry.quantity = Math.floor(quantity);
        entry.qty = entry.quantity;
      }
      if (!entry.details) entry.details = detailsForEntry(entry);
      return entry;
    }

    function expandSizeOptions(size) {
      var components = Array.isArray(size && size.components) ? size.components : [];
      var options = Array.isArray(size && size.options) ? size.options.slice() : [];
      components.forEach(function(component) {
        componentFallbacks.forEach(function(fallbackItem) {
          if (optionMatchesComponent(fallbackItem, component, size)) {
            options.push(Object.assign({ quantity: 1 }, fallbackItem));
          }
        });
      });
      return dedupeOptions(options.map(function(option) {
        return patchComponentEntry(Object.assign({ quantity: 1 }, option));
      }));
    }

    function prepareBundleConfig(bundleConfig) {
      if (!bundleConfig || !Array.isArray(bundleConfig.sizes)) return;
      appendConfiguredComponentFallbacks(bundleConfig);
      rebuildComponentFallbackIndex();
      componentDetailsByKey = buildComponentDetailsIndex(bundleConfig);
      bundleConfig.sizes.forEach(function(size) {
        ['components', 'slots', 'options'].forEach(function(key) {
          if (!Array.isArray(size[key])) return;
          size[key] = size[key].map(function(entry) {
            return patchComponentEntry(Object.assign({}, entry));
          });
        });
        size.options = expandSizeOptions(size);
      });
    }

    prepareBundleConfig(config);

    var isMysteryBoxProduct = fallback.mode === 'mystery';

    function fallbackOptionDefinitions() {
      return Array.isArray(fallback.options) ? fallback.options : [];
    }

    function fallbackOptionPosition(pattern) {
      var match = fallbackOptionDefinitions().find(function(option) {
        return pattern.test(String(option && option.name || ''));
      });
      return match ? Number(match.position) : 0;
    }

    function singleRawOptionValue(variant, position) {
      if (!variant || !position) return '';
      return String(variant['option' + position] || '').trim();
    }

    function looksLikeSizeValue(value) {
      var normalized = normalSize(value);
      return Boolean(normalized && isGymtierSupportedSize(normalized) && (sizeRank(normalized) < 1000 || /^(?:[2-9]?XL|X{2,5}L|S|M|L)$/i.test(normalized)));
    }

    function inferSingleSizePosition() {
      var variants = Array.isArray(fallback.variants) ? fallback.variants : [];
      var best = { position: 0, matches: 0 };
      [1, 2, 3].forEach(function(position) {
        var matches = variants.filter(function(variant) {
          return looksLikeSizeValue(singleRawOptionValue(variant, position));
        }).length;
        if (matches > best.matches) best = { position: position, matches: matches };
      });
      return best.matches ? best.position : 0;
    }

    function inferSingleColorPosition(sizePosition) {
      var variants = Array.isArray(fallback.variants) ? fallback.variants : [];
      var best = { position: 0, count: 0 };
      [1, 2, 3].forEach(function(position) {
        if (position === sizePosition) return;
        var seen = {};
        variants.forEach(function(variant) {
          var value = singleRawOptionValue(variant, position);
          if (value) seen[looseKey(value)] = true;
        });
        var count = Object.keys(seen).length;
        if (count > best.count) best = { position: position, count: count };
      });
      return best.count ? best.position : 0;
    }

    function singleProductOptionRoles() {
      var sizePosition = fallbackOptionPosition(/size/i);
      if (!sizePosition) sizePosition = inferSingleSizePosition();
      if (isMysteryBoxProduct) {
        return {
          color: 0,
          size: sizePosition || 1
        };
      }
      var colorPosition = fallbackOptionPosition(/colou?r/i);
      if (!colorPosition) colorPosition = inferSingleColorPosition(sizePosition);
      if (!colorPosition && sizePosition !== 1) colorPosition = 1;
      if (!sizePosition && colorPosition !== 2) sizePosition = 2;
      return {
        color: colorPosition || 1,
        size: sizePosition || 2
      };
    }

    function normalizeSingleProductVariants(roles) {
      return (Array.isArray(fallback.variants) ? fallback.variants : []).map(function(variant) {
        if (!variant || !variant.id) return null;
        var colorName = isMysteryBoxProduct
          ? currentProduct.title
          : singleRawOptionValue(variant, roles.color);
        var sizeValue = singleRawOptionValue(variant, roles.size);
        return Object.assign({}, variant, {
          id: variant.id,
          shopifyVariantId: variant.id,
          variantId: variant.id,
          colorName: colorName || variant.option1 || variant.title || '',
          size: sizeValue || variant.option2 || variant.option1 || variant.title || '',
          option1: variant.option1 || '',
          option2: variant.option2 || '',
          option3: variant.option3 || '',
          imageUrl: usableImageUrl(variant.imageUrl),
          thumbUrl: usableImageUrl(variant.thumbUrl || variant.imageUrl),
          price: variant.price,
          compareAtPrice: variant.compareAtPrice != null ? variant.compareAtPrice : variant.compare_at_price,
          compare_at_price: variant.compare_at_price != null ? variant.compare_at_price : variant.compareAtPrice
        });
      }).filter(Boolean);
    }

    function singleProductSizeOptionsFromVariants(variants) {
      var bySize = {};
      (Array.isArray(variants) ? variants : []).forEach(function(variant) {
        var label = String(variant && variant.size || '').trim();
        var key = normalSize(label);
        if (!key) return;
        if (!bySize[key]) bySize[key] = { size: label, available: false };
        if (variant.available !== false) bySize[key].available = true;
      });
      return Object.keys(bySize).map(function(key) {
        return bySize[key];
      });
    }

    function singleProductColorOptionsFromVariants(variants) {
      var byColor = {};
      var colors = [];
      (Array.isArray(variants) ? variants : []).forEach(function(variant) {
        var label = String(variant && variant.colorName || '').trim();
        var key = looseKey(label || variant && variant.sku);
        if (!key) return;
        var current = byColor[key];
        if (!current) {
          current = {
            key: key,
            label: label || 'Colour',
            option: variant,
            available: variant.available !== false
          };
          byColor[key] = current;
          colors.push(current);
          return;
        }
        if (variant.available !== false && current.option.available === false) {
          current.option = variant;
          current.available = true;
        }
      });
      return colors;
    }

    function bundleSingleSeedOption() {
      var activeComponent = activeBundleSingleComponent();
      if (activeComponent && activeComponent.seed) return activeComponent.seed;
      if (selections && selections[0]) return selections[0];
      var size = previewSize();
      var defaults = size ? defaultSelections(size) : [];
      if (defaults[0]) return defaults[0];
      for (var sizeIndex = 0; sizeIndex < sizes.length; sizeIndex += 1) {
        var options = uniqueOptions(sizes[sizeIndex]);
        if (options[0]) return options[0];
      }
      return componentFallbacks[0] || null;
    }

    function bundleSingleComponentKey(option) {
      if (!option) return '';
      return cleanProductHandle(option.productHandle || option.product_handle || option.handle) ||
        componentFamilyKey(option) ||
        skuProductStem(option.sku) ||
        looseKey(option.productTitle || option.title || option.sku);
    }

    function bundleSingleComponentTitle(option) {
      var details = normaliseProductDetails(detailsForEntry(option));
      return option && (option.productTitle || option.title) ||
        details && details.title ||
        optionLabel(option);
    }

    function bundleSingleComponentImage(option) {
      var variantImage = componentVariantImageForOption(option);
      var productData = componentProductForOption(option);
      return usableImageUrl(variantImage && (variantImage.thumbUrl || variantImage.url)) ||
        usableImageUrl(option && (option.thumbUrl || option.imageUrl)) ||
        productImageFromProductData(productData) ||
        currentProduct.imageUrl;
    }

    function bundleSingleVariantOptionsForSeed(seed) {
      var collected = [];
      var productData = seed ? componentProductForOption(seed) : null;

      if (productData) {
        componentVariantOptionsForProduct(productData, seed || {}).forEach(function(option) {
          collected.push(option);
        });
      }

      sizes.forEach(function(size) {
        ['options', 'components', 'componentQuantities', 'slots'].forEach(function(key) {
          (Array.isArray(size && size[key]) ? size[key] : []).forEach(function(entry) {
            if (seed && !sameComponentProduct(entry, seed)) return;
            collected.push(patchComponentEntry(Object.assign({ quantity: 1 }, entry)));
          });
        });
      });

      componentFallbacks.forEach(function(entry) {
        if (seed && !sameComponentProduct(entry, seed)) return;
        collected.push(patchComponentEntry(Object.assign({ quantity: 1 }, entry)));
      });

      return dedupeOptions(collected);
    }

    function bundleSingleComponentOptions() {
      if (!hasComponentConfig) return [];
      var size = previewSize();
      var source = selections && selections.length ? selections : (size ? defaultSelections(size) : []);
      if (!source.length) {
        sizes.some(function(sizeOption) {
          source = defaultSelections(sizeOption);
          return source.length > 0;
        });
      }
      if (!source.length) source = componentFallbacks;

      var seen = {};
      return source.map(function(entry) {
        return patchComponentEntry(Object.assign({}, entry));
      }).filter(function(seed) {
        var key = bundleSingleComponentKey(seed);
        if (!key || seen[key]) return false;
        seen[key] = true;
        return true;
      }).map(function(seed) {
        var key = bundleSingleComponentKey(seed);
        return {
          key: key,
          seed: seed,
          title: bundleSingleComponentTitle(seed),
          imageUrl: bundleSingleComponentImage(seed),
          variants: bundleSingleVariantOptionsForSeed(seed)
        };
      }).filter(function(component) {
        return component.variants.length > 0;
      });
    }

    function activeBundleSingleComponent() {
      if (!Array.isArray(bundleSingleComponents) || !bundleSingleComponents.length) return null;
      var activeKey = selectedBundleSingleComponentKey;
      return bundleSingleComponents.find(function(component) {
        return component.key === activeKey;
      }) || bundleSingleComponents[0] || null;
    }

    function selectBundleSingleThumbnailColor() {
      var activeComponent = activeBundleSingleComponent();
      var seed = activeComponent && activeComponent.seed;
      if (!seed || !bundleSingleColors.length) return;
      var seedColorKeys = optionColourKeys(seed);
      var preferredColor = bundleSingleColors.find(function(color) {
        return color && color.option && sameColorOption(color.option, seed);
      }) || bundleSingleColors.find(function(color) {
        return color && seedColorKeys.indexOf(color.key) > -1;
      });
      if (preferredColor) selectedBundleSingleColorKey = preferredColor.key;
    }

    function selectBundleSingleComponent(componentKey) {
      var sizeToKeep = selectedSizeForNavigation();
      selectedBundleSingleComponentKey = componentKey || '';
      refreshBundleSingleOptions();
      selectBundleSingleThumbnailColor();
      selectedSize = sizeOptionForValue(activeSingleSizeOptions(), sizeToKeep) ||
        activeSingleSizeOptions().find(function(size) { return size && size.available !== false; }) ||
        activeSingleSizeOptions()[0] ||
        null;
      refresh();
      hydrateBundleSingles();
    }

    function bundleSingleVariantOptions() {
      var activeComponent = activeBundleSingleComponent();
      return activeComponent ? activeComponent.variants : [];
    }

    function refreshBundleSingleOptions() {
      bundleSingleComponents = bundleSingleComponentOptions();
      if (!bundleSingleComponents.some(function(component) { return component.key === selectedBundleSingleComponentKey; })) {
        selectedBundleSingleComponentKey = bundleSingleComponents[0] ? bundleSingleComponents[0].key : '';
      }
      bundleSingleVariants = bundleSingleVariantOptions();
      bundleSingleColors = singleProductColorOptionsFromVariants(bundleSingleVariants);
      if (!bundleSingleColors.length) {
        selectedBundleSingleColorKey = '';
        return;
      }
      if (!bundleSingleColors.some(function(color) { return color.key === selectedBundleSingleColorKey; })) {
        selectedBundleSingleColorKey = bundleSingleColors[0].key;
      }
    }

    function hydrateBundleSingles() {
      if (bundleSinglesHydrating || isSingleProduct || !hasComponentConfig) return;
      var seed = bundleSingleSeedOption();
      if (!seed) return;
      bundleSinglesHydrating = true;
      fetchComponentProductDataForOption(seed).then(function() {
        bundleSinglesHydrating = false;
        refreshBundleSingleOptions();
        if (singlesMode) refresh();
      }).catch(function() {
        bundleSinglesHydrating = false;
      });
    }

    function singleModeActive() {
      return isSingleProduct ? !inlineBundleActive : singlesMode;
    }

    function activeSingleVariants() {
      return isSingleProduct ? singleProductVariants : bundleSingleVariants;
    }

    function activeSingleColors() {
      return isSingleProduct ? singleProductColors : bundleSingleColors;
    }

    function activeSingleColorKey() {
      return isSingleProduct ? selectedSingleColorKey : selectedBundleSingleColorKey;
    }

    function setActiveSingleColorKey(colorKey) {
      if (isSingleProduct) {
        selectedSingleColorKey = colorKey;
      } else {
        selectedBundleSingleColorKey = colorKey;
      }
    }

    function activeSingleSizeOptions() {
      return sortSizesByFitOrder(singleProductSizeOptionsFromVariants(activeSingleVariants()));
    }

    function singleProductColorByKey(colorKey) {
      var cleanKey = looseKey(colorKey);
      var colors = activeSingleColors();
      return colors.find(function(color) {
        return color.key === cleanKey;
      }) || colors[0] || null;
    }

    function singleVariantForColorAndSize(colorKey, sizeValue) {
      var cleanColor = looseKey(colorKey);
      var cleanSize = normalSize(sizeValue);
      var variants = activeSingleVariants();
      return variants.find(function(variant) {
        return (!cleanColor || looseKey(variant.colorName) === cleanColor) &&
          (!cleanSize || normalSize(variant.size) === cleanSize) &&
          variant.available !== false;
      }) || variants.find(function(variant) {
        return (!cleanColor || looseKey(variant.colorName) === cleanColor) &&
          (!cleanSize || normalSize(variant.size) === cleanSize);
      }) || null;
    }

    function singleProductPreviewVariant() {
      var color = singleProductColorByKey(activeSingleColorKey());
      var sizeValue = selectedSize && selectedSize.size;
      return singleVariantForColorAndSize(color && color.key, sizeValue) ||
        singleVariantForColorAndSize(color && color.key, '') ||
        activeSingleVariants().find(function(variant) { return variant.available !== false; }) ||
        activeSingleVariants()[0] ||
        null;
    }

    function selectedSingleProductVariant() {
      if (!singleModeActive() || !selectedSize) return null;
      var color = singleProductColorByKey(activeSingleColorKey());
      return singleVariantForColorAndSize(color && color.key, selectedSize.size);
    }

    function singleImageForColor(color) {
      if (!color) return '';
      var variant = singleVariantForColorAndSize(color.key, selectedSize && selectedSize.size) ||
        singleVariantForColorAndSize(color.key, '') ||
        color.option;
      var variantImage = usableImageUrl(variant && (variant.thumbUrl || variant.imageUrl));
      if (variantImage) return variantImage;
      var productData = isSingleProduct ? null : componentProductForOption(variant || color.option);
      var images = isSingleProduct
        ? (Array.isArray(fallback.images) ? fallback.images : [])
        : (Array.isArray(productData && productData.images) ? productData.images : []);
      var matchedImage = images.find(function(image) {
        return colorAltMatchesOption(image && image.alt, { colorName: color.label });
      });
      return usableImageUrl(matchedImage && (matchedImage.thumbUrl || matchedImage.url)) || (isSingleProduct ? currentProduct.imageUrl : '') || '';
    }

    var hasComponentConfig = Array.isArray(config.sizes) && config.sizes.length > 0;
    var singleOptionRoles = singleProductOptionRoles();
    var singleProductVariants = normalizeSingleProductVariants(singleOptionRoles);
    var isSingleProduct = (fallback.mode === 'single' || isMysteryBoxProduct) && !hasComponentConfig && singleProductVariants.length > 0;
	    var singleProductColors = singleProductColorOptionsFromVariants(singleProductVariants);
	    var sizes = sortSizesByFitOrder(hasComponentConfig ? config.sizes : (isSingleProduct ? singleProductSizeOptionsFromVariants(singleProductVariants) : fallback.sizes));
    var bundleSizeAvailabilityHydrating = false;
    var bundleSizeAvailabilityReady = !hasComponentConfig;
	    recalculateBundleSizeAvailability();
	    var currentQuantity = Number(config.quantity || fallback.quantity || 0) || 0;
	    var collectionPackOptionList = (Array.isArray(collectionPackOptions) ? collectionPackOptions : []).filter(packOptionIsBundlePack);
	    var configuredPackOptions = dedupePackOptions(collectionPackOptionList
	      .map(normalizePackOption)
	      .filter(Boolean));
	    var configuredRailPackOptions = dedupePackOptions(collectionPackOptionList
	      .map(normalizePackOption)
	      .filter(Boolean));
    var currentPackOption = null;
    if (!configuredPackOptions.some(isCurrentPackOption) && currentQuantity > 1) {
      currentPackOption = {
        handle: currentProduct.handle,
        url: currentProduct.url,
        title: currentQuantity + '-Pack',
        displayName: currentQuantity + '-Pack',
        quantity: currentQuantity,
        imageUrl: currentProduct.imageUrl,
        active: true
      };
      configuredPackOptions.unshift(currentPackOption);
      if (!configuredRailPackOptions.some(isCurrentPackOption)) configuredRailPackOptions.unshift(currentPackOption);
    }
    var packOptions = configuredPackOptions.slice();
    var railPackOptions = configuredRailPackOptions.slice();
    if (!packOptions.length && currentPackOption) packOptions.unshift(currentPackOption);
    if (!railPackOptions.length && currentPackOption) railPackOptions.unshift(currentPackOption);
    var activePack = packOptions.find(isCurrentPackOption) || packOptions[0] || null;
    if (!currentQuantity && activePack) currentQuantity = activePack.quantity;
    var packRailExpanded = openPackRailOnLoad;
    if (!selectedSizeOnLoad) selectedSizeOnLoad = cartPreferredSize(cartOnLoad, sizes);
    var selectedSize = sizeOptionForValue(sizes, selectedSizeOnLoad);
    var primaryLifestyle = (Array.isArray(fallback.images) ? fallback.images : []).map(function(imageData) {
      return primaryLifestyleMetadata(imageData && imageData.alt);
    }).find(Boolean);
    var preferredSingleColorKey = looseKey(primaryLifestyle && primaryLifestyle.colour || fallback.primaryColour);
    var preferredSingleColor = singleProductColors.find(function(color) {
      return color && color.key === preferredSingleColorKey;
    });
    var selectedSingleColorKey = preferredSingleColor
      ? preferredSingleColor.key
      : (singleProductColors[0] ? singleProductColors[0].key : '');
    var initialPreviewSize = selectedSize || sizes.find(function(size) { return size && size.available !== false; }) || sizes[0] || null;
    var selections = hasComponentConfig && initialPreviewSize
      ? (selectedSize ? remapSelectionsForSize(initialPreviewSize, []).map(markSelectionSizeChosen) : defaultSelections(initialPreviewSize))
      : [];
    var inlineBundleActive = false;
    var activeInlinePackOption = null;
    var baseSingleProductState = {
      config: config,
      currentProduct: Object.assign({}, currentProduct),
      hasComponentConfig: hasComponentConfig,
      sizes: sizes.slice(),
      currentQuantity: currentQuantity,
      activePack: activePack
    };
    var singlesMode = isSingleProduct;
    var bundleSingleComponents = hasComponentConfig ? bundleSingleComponentOptions() : [];
    var selectedBundleSingleComponentKey = bundleSingleComponents[0] ? bundleSingleComponents[0].key : '';
    var bundleSingleVariants = hasComponentConfig ? bundleSingleVariantOptions() : [];
    var bundleSingleColors = singleProductColorOptionsFromVariants(bundleSingleVariants);
    var selectedBundleSingleColorKey = bundleSingleColors[0] ? bundleSingleColors[0].key : '';
    var bundleSinglesHydrating = false;
    var customMode = openCustomizerOnLoad;

    var galleryEl = root.querySelector('.cf-bundle-product__gallery');
    var mainMediaEl = root.querySelector('.cf-bundle-product__main-media');
    var mainImage = root.querySelector('[data-cf-main-image]');
    var thumbsEl = root.querySelector('[data-cf-thumbs]');
    var sizeOptions = root.querySelector('[data-cf-size-options]');
    var sizeLabel = root.querySelector('[data-cf-size-label]');
    var quantityEl = root.querySelector('[data-cf-quantity]');
    var packOptionsEl = root.querySelector('[data-cf-pack-options]');
    var packRailEl = root.querySelector('[data-cf-pack-rail]');
    var bundleSelectorEl = root.querySelector('[data-cf-bundle-selector]');
    var bundleSelectorLoadingEl = root.querySelector('[data-cf-bundle-selector-loading]');
    var stackSave = root.querySelector('[data-cf-stack-save]');
    var stackSaveFill = root.querySelector('[data-cf-stack-save-fill]');
    var stackSaveSegments = root.querySelector('[data-cf-stack-save-segments]');
    var stackSaveInvertedSegments = root.querySelector('[data-cf-stack-save-inverted-segments]');
    var stackSaveMessage = root.querySelector('[data-cf-stack-save-message]');
    var colorSummary = root.querySelector('[data-cf-color-summary]');
    var colorSummaryLabel = root.querySelector('[data-cf-color-summary-label]');
    var customizer = root.querySelector('[data-cf-customizer]');
    var customizerCount = root.querySelector('[data-cf-customizer-count]');
    var slotsEl = root.querySelector('[data-cf-slots]');
	    var addButton = root.querySelector('[data-cf-add]');
	    var statusEl = root.querySelector('[data-cf-status]');
	    var priceEl = root.querySelector('[data-cf-price]');
    var comparePriceEl = root.querySelector('[data-cf-compare-price]');
    var unitEl = root.querySelector('[data-cf-unit-price]');
    var productDetailsEl = root.querySelector('[data-cf-product-details]');
    var reviewDebugEl = root.querySelector('[data-cf-review-debug]');
    var colorModal = root.querySelector('[data-cf-color-modal]');
    var colorModalPreview = root.querySelector('[data-cf-color-modal-preview]');
    var colorModalSwatches = root.querySelector('[data-cf-color-modal-swatches]');
    var colorModalSizes = root.querySelector('[data-cf-color-modal-sizes]');
    var colorModalColorLabel = root.querySelector('[data-cf-color-modal-color-label]');
    var colorModalSizeLabel = root.querySelector('[data-cf-color-modal-size-label]');
    var colorModalApply = root.querySelector('[data-cf-color-modal-apply]');
    var colorModalPrev = root.querySelector('[data-cf-color-modal-prev]');
	    var colorModalNext = root.querySelector('[data-cf-color-modal-next]');
	    var activeColorModalSlot = null;
	    var activeColorModalOptions = [];
	    var activeColorModalProductOptions = [];
	    var activeColorModalDraft = null;
	    var activeColorModalColorKey = '';
	    var colorModalSwatchesExpanded = false;
	    var sizeGuideModal = root.querySelector('[data-cf-size-guide-modal]');
	    var sizeGuideGrid = root.querySelector('[data-cf-size-guide-grid]');
	    var sizeGuideNote = root.querySelector('[data-cf-size-guide-note]');
	    var sizeGuideUnitButtons = root.querySelectorAll('[data-cf-size-guide-unit]');
	    var sizeGuideTriggers = root.querySelectorAll('[data-cf-size-guide-open]');
	    var activeSizeGuideUnit = 'metric';
	    var activeSizeGuideData = null;
	    var sizeGuideLastFocus = null;
	    var detailsModal = root.querySelector('[data-cf-details-modal]');
	    var detailsTriggers = root.querySelectorAll('[data-cf-details-open]');
	    var detailsLastFocus = null;
	    var reviewsModal = root.querySelector('[data-cf-reviews-modal]');
	    var reviewsTriggers = root.querySelectorAll('[data-cf-reviews-open]');
	    var reviewList = root.querySelector('[data-cf-review-list]');
	    var reviewCountEl = root.querySelector('[data-cf-review-count]');
	    var reviewAverageEl = root.querySelector('[data-cf-review-average]');
	    var reviewStarsEl = root.querySelector('[data-cf-review-stars]');
	    var reviewModalAverageEl = root.querySelector('[data-cf-review-modal-average]');
	    var reviewModalStarsEl = root.querySelector('[data-cf-review-modal-stars]');
	    var reviewModalCountEl = root.querySelector('[data-cf-review-modal-count]');
	    var reviewsSummaryLoaded = false;
	    var reviewsSummaryLoading = false;
	    var reviewsLoaded = false;
	    var reviewsLoading = false;
	    var reviewsLastFocus = null;
	    var defaultMainGallery = dedupeGalleryImages(
	      Array.isArray(fallback.images) && fallback.images.length ? fallback.images : readDefaultMainGallery()
	    );
	    var activeMainGalleryMode = 'uninitialized';

    function syncGalleryThumbHeight() {
      if (!galleryEl || !mainMediaEl || !thumbsEl) return;
      if (galleryEl.dataset.cfGalleryLayout === 'horizontal') {
        thumbsEl.style.height = '';
        thumbsEl.style.maxHeight = '';
        return;
      }
      var mainMediaHeight = Math.round(mainMediaEl.getBoundingClientRect().height);
      if (mainMediaHeight <= 0) return;
      thumbsEl.style.height = mainMediaHeight + 'px';
      thumbsEl.style.maxHeight = mainMediaHeight + 'px';
    }

    if (galleryEl && mainMediaEl && thumbsEl) {
      window.requestAnimationFrame(syncGalleryThumbHeight);
      if (typeof window.ResizeObserver === 'function') {
        var galleryResizeObserver = new window.ResizeObserver(syncGalleryThumbHeight);
        galleryResizeObserver.observe(mainMediaEl);
        addCleanup(function() {
          galleryResizeObserver.disconnect();
        });
      } else {
        window.addEventListener('resize', syncGalleryThumbHeight);
        addCleanup(function() {
          window.removeEventListener('resize', syncGalleryThumbHeight);
        });
      }
    }

    function money(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.money_format || fallback.moneyFormat || ('£' + '{' + '{amount}' + '}' + '}'));
      }
      return (Number(cents || 0) / 100).toLocaleString('en-GB', {
        style: 'currency',
        currency: window.shop_currency || 'GBP'
      });
    }

	    function toCents(value) {
	      var amount = Number(value);
	      if (!Number.isFinite(amount) || amount <= 0) return 0;
	      return Math.round(amount);
	    }

	    function displayGuideSizeLabel(value) {
	      var normalized = normalSize(value);
	      var map = {
	        XXL: '2XL',
	        XXXL: '3XL',
	        XXXXL: '4XL',
	        XXXXXL: '5XL'
	      };
	      return map[normalized] || String(value || '').trim();
	    }

	    function sizeGuideSourceGuide(source) {
	      return normalizeRawSizeGuide(source);
	    }

	    function configuredSizeGuide() {
	      var guide = sizeGuideSourceGuide(config) || sizeGuideSourceGuide(fallback);
	      if (guide) return guide;
	      if (Array.isArray(config.componentDetails)) {
	        for (var index = 0; index < config.componentDetails.length; index += 1) {
	          guide = sizeGuideSourceGuide(config.componentDetails[index]);
	          if (guide) return guide;
	        }
	      }
	      return null;
	    }

	    function activeSizeGuideOption() {
	      if (singleModeActive() && !isSingleProduct) {
	        return selectedSingleProductVariant() || singleProductPreviewVariant() || bundleSingleSeedOption();
	      }
	      if (hasComponentConfig) {
	        var size = activeCustomizerSize();
	        var defaults = size ? defaultSelections(size) : [];
	        return selections[0] || defaults[0] || bundleSingleSeedOption();
	      }
	      return null;
	    }

	    function directActiveSizeGuide() {
	      if (singleModeActive()) return sizeGuideSourceGuide(fallback) || configuredSizeGuide();
	      var option = activeSizeGuideOption();
	      var productData = componentProductForOption(option);
	      return sizeGuideSourceGuide(productData) ||
	        sizeGuideSourceGuide(option) ||
	        sizeGuideSourceGuide(detailsForEntry(option)) ||
	        configuredSizeGuide();
	    }

	    function resolveActiveSizeGuideData() {
	      var option = activeSizeGuideOption();
	      var immediate = directActiveSizeGuide();
	      if (immediate) return Promise.resolve(immediate);
	      if (!option) return Promise.resolve(configuredSizeGuide());
	      return fetchComponentProductDataForOption(option).then(function(productData) {
	        var guide = sizeGuideSourceGuide(productData) || sizeGuideSourceGuide(option) || configuredSizeGuide();
	        var handle = cleanProductHandle(productData && productData.handle || option.productHandle || option.product_handle);
	        if (guide || !handle) return guide || null;
	        return fetchProductPageData(handle, componentFamilyKey(option)).then(function(pageProductData) {
	          return sizeGuideSourceGuide(pageProductData) || guide || configuredSizeGuide();
	        });
	      }).catch(function() {
	        return configuredSizeGuide();
	      });
	    }

	    function sizeGuideMetadataKey(key) {
	      return /^(?:name|size|label|title|measurements|available|sku|id)$/i.test(String(key || '').trim());
	    }

	    function sizeGuideEntriesFromArray(guide) {
	      var list = Array.isArray(guide && guide.sizes) ? guide.sizes : [];
	      return list.map(function(sizeInfo) {
	        if (!sizeInfo) return null;
	        var label = sizeInfo.name || sizeInfo.size || sizeInfo.Size || sizeInfo.label || sizeInfo.title || '';
	        var measurements = Object.assign({}, sizeInfo.measurements || {});
	        Object.keys(sizeInfo).forEach(function(key) {
	          if (sizeGuideMetadataKey(key)) return;
	          if (sizeInfo[key] == null || typeof sizeInfo[key] === 'object') return;
	          measurements[key] = sizeInfo[key];
	        });
	        return label ? {
	          size: displayGuideSizeLabel(label),
	          measurements: measurements
	        } : null;
	      }).filter(Boolean);
	    }

	    function sizeGuideEntriesFromMaps(guide) {
	      if (!guide || typeof guide !== 'object') return [];
	      var bySize = {};
	      var ignored = /^(?:sizes|sizeGuide|size_guide|note|notes|fit|fitNote|footerNote|height|heightGuide|heightText|description)$/i;
	      Object.keys(guide).forEach(function(measurementKey) {
	        if (ignored.test(measurementKey)) return;
	        var map = parseMaybeJson(guide[measurementKey]);
	        if (!map || typeof map !== 'object' || Array.isArray(map)) return;
	        Object.keys(map).forEach(function(sizeName) {
	          if (!looksLikeSizeValue(sizeName)) return;
	          var sizeKey = normalSize(sizeName);
	          if (!bySize[sizeKey]) bySize[sizeKey] = {
	            size: displayGuideSizeLabel(sizeName),
	            measurements: {}
	          };
	          bySize[sizeKey].measurements[measurementKey] = map[sizeName];
	        });
	      });
	      return Object.keys(bySize).map(function(sizeKey) {
	        return bySize[sizeKey];
	      });
	    }

	    function sizeGuideEntries(guide) {
	      var parsedGuide = parseMaybeJson(guide);
	      var entries = sizeGuideEntriesFromArray(parsedGuide);
	      if (!entries.length) entries = sizeGuideEntriesFromMaps(parsedGuide);
	      return sortSizesByFitOrder(entries);
	    }

		    function guideMeasurementKeys(entries) {
		      var counts = {};
		      (Array.isArray(entries) ? entries : []).forEach(function(entry) {
	        Object.keys(entry.measurements || {}).forEach(function(key) {
	          var value = entry.measurements[key];
	          if (value == null || value === '') return;
	          counts[key] = (counts[key] || 0) + 1;
	        });
		      });
		      var keys = Object.keys(counts);
		      var preferred = [
		        /chest|body\s*width|width/i,
		        /waist/i,
		        /weight/i,
		        /body\s*length|length/i,
		        /sleeve|arm/i,
		        /height/i
		      ];
		      var selected = [];
		      for (var index = 0; index < preferred.length; index += 1) {
		        var match = keys.find(function(key) {
		          return selected.indexOf(key) === -1 && preferred[index].test(key);
		        });
		        if (match) selected.push(match);
		        if (selected.length >= 2) return selected;
		      }
		      keys.sort(function(first, second) {
		        return counts[second] - counts[first] || first.localeCompare(second);
		      }).forEach(function(key) {
		        if (selected.indexOf(key) === -1) selected.push(key);
		      });
		      return selected.slice(0, 2);
		    }

	    function cleanGuideMeasurementLabel(key) {
	      return String(key || 'Measurement')
	        .replace(/[_-]+/g, ' ')
	        .replace(/\s*\((?:cm|in|inch|inches|kg|lbs?|pounds?)\)\s*/ig, '')
	        .replace(/([a-z])([A-Z])/g, '$1 $2')
	        .trim() || 'Measurement';
	    }

	    function guideMeasurementKind(key) {
	      return /weight|kg|lbs?|pounds?/i.test(String(key || '')) ? 'weight' : 'length';
	    }

	    function guideMeasurementBase(key, kind, value) {
	      var text = String(key || '');
	      if (kind === 'weight') return /lbs?|pounds?/i.test(text) ? 'imperial' : 'metric';
	      if (/cm|centimet/i.test(text)) return 'metric';
	      if (/inches|\bin\b|"/i.test(text)) return 'imperial';
	      var number = Number(value);
	      if (Number.isFinite(number) && /chest|waist|body|length|sleeve|arm|width|inseam/i.test(text) && number < 80) return 'imperial';
	      return 'metric';
	    }

	    function numericValuesFromGuideValue(value) {
	      if (Array.isArray(value)) return value.map(Number).filter(Number.isFinite);
	      if (value && typeof value === 'object') {
	        var keys = ['min', 'from', 'low', 'minimum', 'value', 'max', 'to', 'high', 'maximum'];
	        var numbers = [];
	        keys.forEach(function(key) {
	          if (value[key] == null) return;
	          var number = Number(value[key]);
	          if (Number.isFinite(number)) numbers.push(number);
	        });
	        return numbers;
	      }
	      if (typeof value === 'number') return Number.isFinite(value) ? [value] : [];
	      return String(value || '').match(/\d+(?:\.\d+)?/g)
	        ? String(value || '').match(/\d+(?:\.\d+)?/g).map(Number).filter(Number.isFinite)
	        : [];
	    }

	    function convertGuideNumber(value, key, unit) {
	      var kind = guideMeasurementKind(key);
	      var base = guideMeasurementBase(key, kind, value);
	      var number = Number(value);
	      if (!Number.isFinite(number)) return number;
	      if (kind === 'weight') {
	        var kg = base === 'imperial' ? number / 2.20462 : number;
	        return unit === 'imperial' ? kg * 2.20462 : kg;
	      }
	      var cm = base === 'imperial' ? number * 2.54 : number;
	      return unit === 'imperial' ? cm / 2.54 : cm;
	    }

	    function updateSizeGuideUnitLabels(primaryKey) {
	      var kind = primaryKey ? guideMeasurementKind(primaryKey) : 'weight';
	      Array.prototype.forEach.call(sizeGuideUnitButtons, function(button) {
	        var isImperial = button.dataset.cfSizeGuideUnit === 'imperial';
	        button.textContent = kind === 'weight'
	          ? (isImperial ? 'LBS' : 'KGS')
	          : (isImperial ? 'IN' : 'CM');
	      });
	    }

	    function formatGuideNumber(value, kind, unit) {
	      if (!Number.isFinite(value)) return '';
	      if (kind === 'weight') return String(Math.round(value));
	      if (unit === 'imperial') return (Math.round(value * 2) / 2).toFixed(value % 1 ? 1 : 0).replace(/\.0$/, '');
	      return String(Math.round(value));
	    }

	    function formatGuideMeasurement(value, key, unit) {
	      var kind = guideMeasurementKind(key);
	      var numbers = numericValuesFromGuideValue(value).slice(0, 2);
	      var unitLabel = kind === 'weight'
	        ? (unit === 'imperial' ? 'lb' : 'kg')
	        : (unit === 'imperial' ? 'in' : 'cm');
	      if (numbers.length) {
	        var formatted = numbers.map(function(number) {
	          return formatGuideNumber(convertGuideNumber(number, key, unit), kind, unit);
	        }).filter(Boolean);
	        return {
	          text: formatted.join(formatted.length > 1 ? '-' : ''),
	          unit: unitLabel
	        };
	      }
	      return {
	        text: String(value || '').trim() || 'See size',
	        unit: ''
	      };
	    }

		    function guideNoteText(guide) {
		      var parsedGuide = parseMaybeJson(guide) || {};
		      var note = parsedGuide.footerNote || parsedGuide.fitNote || parsedGuide.note || parsedGuide.fit || parsedGuide.description;
	      if (note && typeof note === 'object') note = note.default || note.text || '';
	      return String(note || 'True to size - Unisex fit').trim();
	    }

	    function sizeGuideIs3XlOrAbove(sizeLabel) {
	      var normalized = String(sizeLabel || '').trim().toUpperCase().replace(/\s+/g, '');
	      var numbered = normalized.match(/^([3-9]|[1-9][0-9]+)XL$/);
	      if (numbered) return true;
	      return /^X{3,}L$/.test(normalized);
	    }

	    function renderSizeGuideModal() {
	      if (!sizeGuideGrid) return;
		      sizeGuideGrid.innerHTML = '';
		      var guide = parseMaybeJson(activeSizeGuideData) || {};
		      var entries = sizeGuideEntries(guide);
		      var measurementKeys = guideMeasurementKeys(entries);
		      var primaryKey = measurementKeys[0] || '';
		      updateSizeGuideUnitLabels(primaryKey);
		      var paletteStops = [4, 8, 14, 22, 36, 68, 84, 96];
		      if (!entries.length || !measurementKeys.length) {
		        var empty = document.createElement('div');
		        empty.className = 'cf-bundle-product__size-guide-fit-card';
		        empty.innerHTML = '<strong>SIZE GUIDE</strong><span>Size details are not available for this product yet.</span>';
		        sizeGuideGrid.appendChild(empty);
			      } else {
			        entries.forEach(function(entry, index) {
			          var paletteIndex = Math.min(index, paletteStops.length - 1);
			          var useInverseText = sizeGuideIs3XlOrAbove(entry.size) || paletteIndex >= 5;
			          var cardBackground = 'color-mix(in srgb, var(--cf-size-guide-text) ' +
			            paletteStops[paletteIndex] + '%, var(--cf-size-guide-bg))';
			          var cardText = useInverseText
			            ? 'var(--cf-size-guide-bg)'
			            : 'var(--cf-size-guide-text)';
			          var card = document.createElement('article');
			          var size = document.createElement('strong');
			          var measurements = document.createElement('div');
			          card.className = 'cf-bundle-product__size-guide-card';
			          if (useInverseText) card.classList.add('is-dark');
			          card.style.setProperty('--cf-size-card-bg', cardBackground);
			          card.style.setProperty('--cf-size-card-text', cardText);
		          size.className = 'cf-bundle-product__size-guide-card-size';
		          size.textContent = entry.size;
		          measurements.className = 'cf-bundle-product__size-guide-measurements';
		          measurementKeys.forEach(function(key) {
		            var rawValue = entry.measurements && entry.measurements[key];
		            if (rawValue == null || rawValue === '') return;
		            var measurement = formatGuideMeasurement(rawValue, key, activeSizeGuideUnit);
		            var row = document.createElement('div');
		            var label = document.createElement('span');
		            var value = document.createElement('span');
		            var unit = document.createElement('span');
		            row.className = 'cf-bundle-product__size-guide-measurement';
		            label.className = 'cf-bundle-product__size-guide-card-label';
		            label.textContent = cleanGuideMeasurementLabel(key);
		            value.className = 'cf-bundle-product__size-guide-card-value';
		            value.textContent = measurement.text;
		            if (measurement.unit) {
		              unit.className = 'cf-bundle-product__size-guide-card-unit';
		              unit.textContent = measurement.unit;
		              value.appendChild(unit);
		            }
		            row.appendChild(label);
		            row.appendChild(value);
		            measurements.appendChild(row);
		          });
		          card.appendChild(size);
		          card.appendChild(measurements);
		          sizeGuideGrid.appendChild(card);
		        });
		      }
		      if (sizeGuideNote) sizeGuideNote.textContent = guideNoteText(guide);
		    }

	    function setSizeGuideUnit(unit) {
	      activeSizeGuideUnit = unit === 'imperial' ? 'imperial' : 'metric';
	      Array.prototype.forEach.call(sizeGuideUnitButtons, function(button) {
	        var active = button.dataset.cfSizeGuideUnit === activeSizeGuideUnit;
	        button.classList.toggle('is-active', active);
	        button.setAttribute('aria-pressed', active ? 'true' : 'false');
	      });
	      renderSizeGuideModal();
	    }

		    function openSizeGuideModal() {
		      if (!sizeGuideModal) return;
		      sizeGuideLastFocus = document.activeElement;
		      resolveActiveSizeGuideData().then(function(guide) {
		        activeSizeGuideData = guide || configuredSizeGuide() || {};
		        renderSizeGuideModal();
		        sizeGuideModal.hidden = false;
		        document.documentElement.classList.add('cf-size-guide-modal-open');
		        var closeButton = sizeGuideModal.querySelector('[data-cf-size-guide-close].cf-bundle-product__size-guide-close');
		        if (closeButton) {
		          try {
		            closeButton.focus({ preventScroll: true });
		          } catch (error) {
		            closeButton.focus();
		          }
		        }
		      });
		    }

	    function closeSizeGuideModal() {
	      if (!sizeGuideModal) return;
		      sizeGuideModal.hidden = true;
		      document.documentElement.classList.remove('cf-size-guide-modal-open');
		      if (sizeGuideLastFocus && sizeGuideLastFocus.focus) {
		        try {
		          sizeGuideLastFocus.focus({ preventScroll: true });
		        } catch (error) {
		          sizeGuideLastFocus.focus();
		        }
		      }
		    }

	    function handleSizeGuideModalClick(event) {
	      if (!sizeGuideModal || sizeGuideModal.hidden) return;
	      if (event.target.closest('.cf-bundle-product__size-guide-panel')) return;
	      closeSizeGuideModal();
	    }

	    function escapeHtml(value) {
	      return String(value == null ? '' : value)
	        .replace(/&/g, '&amp;')
	        .replace(/</g, '&lt;')
	        .replace(/>/g, '&gt;')
	        .replace(/"/g, '&quot;')
	        .replace(/'/g, '&#039;');
	    }

	    function starText(rating) {
	      var value = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
	      return '\u2605\u2605\u2605\u2605\u2605'.slice(0, value) + '\u2606\u2606\u2606\u2606\u2606'.slice(0, 5 - value);
	    }

	    function reviewDate(value) {
	      if (!value) return '';
	      var date = new Date(value);
	      if (Number.isNaN(date.getTime())) return '';
	      var diff = Math.max(0, Date.now() - date.getTime());
	      var minute = 60 * 1000;
	      var hour = 60 * minute;
	      var day = 24 * hour;
	      if (diff < minute) return 'Just now';
	      if (diff < hour) {
	        var minutes = Math.max(1, Math.floor(diff / minute));
	        return minutes + ' minute' + (minutes === 1 ? '' : 's') + ' ago';
	      }
	      if (diff < day) {
	        var hours = Math.max(1, Math.floor(diff / hour));
	        return hours + ' hour' + (hours === 1 ? '' : 's') + ' ago';
	      }
	      if (diff < day * 7) {
	        var days = Math.max(1, Math.floor(diff / day));
	        return days + ' day' + (days === 1 ? '' : 's') + ' ago';
	      }
	      return date.toLocaleDateString('en-GB', {
	        day: 'numeric',
	        month: 'short',
	        year: 'numeric'
	      });
	    }

	    function addUniqueValue(list, value, cleaner) {
	      var cleaned = cleaner ? cleaner(value) : String(value || '').trim();
	      if (!cleaned || list.indexOf(cleaned) !== -1) return;
	      list.push(cleaned);
	    }

	    function cleanReviewSku(value) {
	      return String(value || '').trim().toUpperCase();
	    }

	    function reviewEntrySku(entry) {
	      if (!entry) return '';
	      return entry.variantSku ||
	        entry.variant_sku ||
	        entry.sku ||
	        entry.SKU ||
	        entry.componentSku ||
	        entry.component_sku ||
	        entry.sourceSku ||
	        entry.source_sku ||
	        '';
	    }

	    function reviewEntryProductHandle(entry) {
	      if (!entry) return '';
	      var details = entry.details && typeof entry.details === 'object' ? entry.details : {};
	      var productData = entry.product && typeof entry.product === 'object' ? entry.product : {};
	      return entry.productHandle ||
	        entry.product_handle ||
	        entry.shopifyProductHandle ||
	        entry.shopify_product_handle ||
	        entry.storefrontHandle ||
	        entry.storefront_handle ||
	        entry.handle ||
	        details.productHandle ||
	        details.product_handle ||
	        details.shopifyProductHandle ||
	        details.shopify_product_handle ||
	        details.storefrontHandle ||
	        details.storefront_handle ||
	        details.handle ||
	        productData.handle ||
	        productData.productHandle ||
	        productData.product_handle ||
	        '';
	    }

	    function reviewProductDataHandle(productData) {
	      if (!productData) return '';
	      return productData.productHandle ||
	        productData.product_handle ||
	        productData.handle ||
	        '';
	    }

	    function collectComponentEntries(callback) {
	      if (Array.isArray(config.componentDetails)) {
	        config.componentDetails.forEach(function(detail) {
	          if (detail) callback(detail);
	        });
	      }
	      (Array.isArray(config.sizes) ? config.sizes : []).forEach(function(size) {
	        ['components', 'componentQuantities', 'slots', 'options'].forEach(function(key) {
	          (Array.isArray(size && size[key]) ? size[key] : []).forEach(function(entry) {
	            if (entry) callback(entry);
	          });
	        });
	      });
	      componentFallbacks.forEach(function(entry) {
	        if (entry) callback(entry);
	      });
	    }

	    function collectReviewComponentEntries(callback) {
	      if (Array.isArray(config.componentDetails)) {
	        config.componentDetails.forEach(function(detail) {
	          if (detail) callback(detail);
	        });
	      }
	      (Array.isArray(config.sizes) ? config.sizes : []).forEach(function(size) {
	        ['components', 'componentQuantities', 'slots'].forEach(function(key) {
	          (Array.isArray(size && size[key]) ? size[key] : []).forEach(function(entry) {
	            if (entry) callback(entry);
	          });
	        });
	      });
	      componentFallbacks.forEach(function(entry) {
	        if (entry) callback(entry);
	      });
	    }

	    function hydrateReviewTargetsFromComponentProducts(componentHandles, componentSkus) {
	      if ((isSingleProduct && !inlineBundleActive) || (!componentHandles.length && !componentSkus.length)) return;
	      var handleLookup = {};
	      var skuLookup = {};
	      var skuStemLookup = {};
	      componentHandles.forEach(function(handle) {
	        var cleanedHandle = cleanProductHandle(handle);
	        if (cleanedHandle) handleLookup[cleanedHandle] = true;
	      });
	      componentSkus.forEach(function(sku) {
	        var cleanedSku = cleanReviewSku(sku);
	        if (!cleanedSku) return;
	        skuLookup[cleanedSku] = true;
	        var stem = skuProductStem(cleanedSku);
	        if (stem) skuStemLookup[stem] = true;
	      });

	      componentProducts.forEach(function(productData) {
	        if (!productData) return;
	        var productHandle = cleanProductHandle(reviewProductDataHandle(productData));
	        var variants = Array.isArray(productData.variants) ? productData.variants : [];
	        var matchesConfiguredHandle = Boolean(productHandle && handleLookup[productHandle]);
	        var matchesConfiguredSku = false;
	        if (!matchesConfiguredHandle) {
	          variants.forEach(function(variant) {
	            if (matchesConfiguredSku) return;
	            var variantSku = cleanReviewSku(reviewEntrySku(variant));
	            var variantStem = skuProductStem(variantSku);
	            matchesConfiguredSku = Boolean(variantSku && (skuLookup[variantSku] || skuStemLookup[variantStem]));
	          });
	        }
	        if (!matchesConfiguredHandle && !matchesConfiguredSku) return;
	        addUniqueValue(componentHandles, productHandle, cleanProductHandle);
	        if (productHandle) handleLookup[productHandle] = true;
	        variants.forEach(function(variant) {
	          var variantSku = cleanReviewSku(reviewEntrySku(variant));
	          if (variantSku) {
	            addUniqueValue(componentSkus, variantSku, cleanReviewSku);
	            skuLookup[variantSku] = true;
	          }
	        });
	      });
	    }

	    function reviewTargets() {
	      var handles = [];
	      if (isSingleProduct && inlineBundleActive && currentProduct && currentProduct.handle) {
	        addUniqueValue(handles, currentProduct.handle, cleanProductHandle);
	      }
	      addUniqueValue(handles, fallback.reviewsProductHandle, cleanProductHandle);
	      addUniqueValue(handles, fallback.handle || currentProduct.handle, cleanProductHandle);
	      return { productHandles: handles, variantSkus: [], debugVariantSkus: [] };
	    }

	    function reviewDebugEnabled() {
	      try {
	        var params = new URL(window.location.href).searchParams;
	        return params.get('review_debug') === '1' || params.get('cf_review_debug') === '1';
	      } catch (error) {
	        return false;
	      }
	    }

	    function updateReviewDebug(targets, params) {
	      var debugSkus = targets.debugVariantSkus || targets.variantSkus || [];
	      root.setAttribute('data-cf-active-review-handles', targets.productHandles.join(','));
	      root.setAttribute('data-cf-active-review-skus', targets.variantSkus.join(','));
	      root.setAttribute('data-cf-discovered-review-skus', debugSkus.join(','));
	      root.setAttribute('data-cf-review-query', params.toString());
	      if (window.console && window.console.info) {
	        window.console.info('[Gymtier review debug]', {
	          storeName: reviewStoreName(),
	          productHandles: targets.productHandles,
	          variantSkusQueried: targets.variantSkus,
	          variantSkusDiscovered: debugSkus,
	          query: params.toString()
	        });
	      }
	      if (!reviewDebugEl || !reviewDebugEnabled()) return;
	      reviewDebugEl.hidden = false;
	      reviewDebugEl.innerHTML =
	        '<strong>Review debug</strong><br>' +
	        'Store: ' + escapeHtml(reviewStoreName()) + '<br>' +
	        'Query productHandles: ' + escapeHtml(targets.productHandles.length ? targets.productHandles.join(', ') : 'none') + '<br>' +
	        'Query variantSkus: none<br>' +
	        'Bundle components: server-side<br>' +
	        'Query string: ' + escapeHtml(params.toString());
	    }

	    function updateReviewFetchError(error) {
	      var message = error && error.message ? error.message : String(error || 'Review request failed.');
	      root.setAttribute('data-cf-review-error', message);
	      if (!reviewDebugEl || !reviewDebugEnabled()) return;
	      reviewDebugEl.hidden = false;
	      reviewDebugEl.innerHTML += '<br>Fetch error: ' + escapeHtml(message);
	    }

	    function appendReviewTargets(params) {
	      var targets = reviewTargets();
	      if (targets.productHandles.length) params.set('productHandles', targets.productHandles.join(','));
	      if (targets.productHandles.length) params.set('includeBundleComponents', '1');
	      updateReviewDebug(targets, params);
	    }

	    function reviewStoreName() {
	      return String(fallback.reviewsStoreName || config.reviewsStoreName || 'gymtier').trim() || 'gymtier';
	    }

	    function reviewSummaryEndpointUrl() {
	      var params = new URLSearchParams({ storeName: reviewStoreName() });
	      appendReviewTargets(params);
	      return 'https://admin.print-foundry.com/api/public/reviews/summary?' + params.toString();
	    }

	    function reviewEndpointUrl() {
	      var params = new URLSearchParams({
	        storeName: reviewStoreName(),
	        limit: '100',
	        includeStats: 'false'
	      });
	      appendReviewTargets(params);
	      return 'https://admin.print-foundry.com/api/public/reviews?' + params.toString();
	    }

	    function updateReviewSummary(stats) {
	      var count = Number(stats && stats.count) || 0;
	      var average = Number(stats && stats.average) || 0;
	      if (reviewCountEl) reviewCountEl.textContent = count ? count.toLocaleString('en-GB') + ' Reviews' : 'Reviews';
	      if (reviewAverageEl) {
	        reviewAverageEl.hidden = !count;
	        reviewAverageEl.textContent = count ? average.toFixed(1) + '/5' : '';
	      }
	      if (reviewStarsEl && count) reviewStarsEl.textContent = starText(average);
	      if (reviewModalAverageEl) reviewModalAverageEl.textContent = count ? average.toFixed(1) : '0.0';
	      if (reviewModalStarsEl) reviewModalStarsEl.textContent = count ? starText(average) : '\u2606\u2606\u2606\u2606\u2606';
	      if (reviewModalCountEl) reviewModalCountEl.textContent = count
	        ? count.toLocaleString('en-GB') + ' customer review' + (count === 1 ? '' : 's')
	        : 'No reviews yet';
	    }

	    function renderReviewPhotos(media) {
	      var photos = (Array.isArray(media) ? media : []).filter(function(item) {
	        return item && item.publicUrl;
	      }).slice(0, 6);
	      if (!photos.length) return '';
	      return '<div class="cf-bundle-product__review-photos">' + photos.map(function(item) {
	        return '<img src="' + escapeHtml(item.publicUrl) + '" alt="' + escapeHtml(item.filename || 'Customer review photo') + '" loading="lazy">';
	      }).join('') + '</div>';
	    }

	    function reviewFitProfile(review) {
	      return review && review.fitProfile && typeof review.fitProfile === 'object' ? review.fitProfile : {};
	    }

	    function reviewSizePurchased(review) {
	      var fit = reviewFitProfile(review);
	      if (fit.sizePurchased) return fit.sizePurchased;
	      var title = String(review && review.variantTitle || '').trim();
	      var parts = title.split(/\s*[-/]\s*/).filter(Boolean);
	      return parts.length ? parts[parts.length - 1] : '';
	    }

	    function renderReviewFitRows(review) {
	      var fit = reviewFitProfile(review);
	      var rows = [
	        ['Weight Range', fit.weightRange],
	        ['Usual Size', fit.usualSize],
	        ['Size Purchased', reviewSizePurchased(review)],
	        ['Height', fit.heightRange]
	      ].filter(function(row) {
	        return row[1];
	      });
	      if (!rows.length) return '';
	      return '<dl class="cf-bundle-product__review-fit">' + rows.map(function(row) {
	        return '<div class="cf-bundle-product__review-fit-row"><dt>' + escapeHtml(row[0]) + '</dt><dd>' + escapeHtml(row[1]) + '</dd></div>';
	      }).join('') + '</dl>';
	    }

	    function publicReviewCustomerName(value) {
	      var name = String(value || '').trim().replace(/\s+/g, ' ');
	      if (!name) return 'Verified customer';
	      if (/^verified\s+customer$/i.test(name)) return 'Verified customer';
	      var parts = name.split(' ').filter(Boolean);
	      if (!parts.length) return 'Verified customer';
	      var first = parts.shift();
	      var initials = parts.map(function(part) {
	        return part.replace(/[^a-z0-9]/gi, '').charAt(0).toUpperCase();
	      }).filter(Boolean).map(function(part) {
	        return part + '.';
	      }).join(' ');
	      return [first, initials].filter(Boolean).join(' ');
	    }

	    function publicReviewCustomerInitials(value) {
	      var name = publicReviewCustomerName(value);
	      if (/^verified\s+customer$/i.test(name)) return 'VC';
	      return name.split(/\s+/).map(function(part) {
	        return part.replace(/[^a-z0-9]/gi, '').charAt(0).toUpperCase();
	      }).filter(Boolean).join('').slice(0, 2) || 'VC';
	    }

	    function renderReviewCustomer(review) {
	      var name = publicReviewCustomerName(review.customerDisplayName || review.customerName);
	      var initials = review.customerInitials || publicReviewCustomerInitials(name);
	      return '<div class="cf-bundle-product__review-customer">' +
	        '<div class="cf-bundle-product__review-avatar" aria-hidden="true">' + escapeHtml(initials) + '</div>' +
	        '<div>' +
	          '<strong class="cf-bundle-product__review-name">' + escapeHtml(name) + '</strong>' +
	          (review.verified ? '<span class="cf-bundle-product__review-verified">Verified Buyer <span aria-hidden="true">&#10003;</span></span>' : '') +
	        '</div>' +
	      '</div>';
	    }

	    function renderReviewRecommend(review) {
	      var fit = reviewFitProfile(review);
	      if (fit.recommendProduct !== true) return '';
	      return '<div class="cf-bundle-product__review-recommend"><span class="cf-bundle-product__review-recommend-icon" aria-hidden="true">&#10003;</span>I recommend this product</div>';
	    }

	    function bindReviewShowMore() {
	      if (!reviewList) return;
	      var button = reviewList.querySelector('[data-cf-review-show-more]');
	      if (!button) return;
	      button.addEventListener('click', function() {
	        reviewList.querySelectorAll('.cf-bundle-product__review-item.is-hidden').forEach(function(item) {
	          item.classList.remove('is-hidden');
	        });
	        button.remove();
	      });
	    }

	    function renderReviews(payload) {
	      var items = Array.isArray(payload && payload.items) ? payload.items : [];
	      if (payload && payload.stats) updateReviewSummary(payload.stats);
	      if (!reviewList) return;
	      if (!items.length) {
	        reviewList.innerHTML = '<p class="cf-bundle-product__review-empty">No reviews yet. Once customers start sharing feedback, it will appear here.</p>';
	        return;
	      }
	      reviewList.innerHTML = items.map(function(review, index) {
	        var dateText = reviewDate(review.reviewedAt);
	        var title = review.title || 'Customer review';
	        var reply = review.merchantReply
	          ? '<div class="cf-bundle-product__review-reply"><strong>Gymtier replied</strong><p>' + escapeHtml(review.merchantReply) + '</p></div>'
	          : '';
	        return '<article class="cf-bundle-product__review-item' + (index > 2 ? ' is-hidden' : '') + '">' +
	          renderReviewCustomer(review) +
	          renderReviewRecommend(review) +
	          renderReviewFitRows(review) +
	          '<div class="cf-bundle-product__review-rating-row">' +
	            '<div class="cf-bundle-product__review-item-stars" aria-label="' + escapeHtml(review.rating || 0) + ' out of 5 stars">' + starText(review.rating) + '</div>' +
	            (dateText ? '<span class="cf-bundle-product__review-date">' + escapeHtml(dateText) + '</span>' : '') +
	          '</div>' +
	          '<h3 class="cf-bundle-product__review-item-title">' + escapeHtml(title) + '</h3>' +
	          '<p class="cf-bundle-product__review-item-body">' + escapeHtml(review.body || '') + '</p>' +
	          renderReviewPhotos(review.media) +
	          reply +
	        '</article>';
	      }).join('') + (items.length > 3 ? '<button class="cf-bundle-product__review-more" type="button" data-cf-review-show-more>Show More</button>' : '');
	      bindReviewShowMore();
	    }

	    function fetchReviews(force) {
	      if (!reviewList || reviewsLoading || (reviewsLoaded && !force)) return Promise.resolve();
	      reviewsLoading = true;
	      if (!reviewsLoaded) {
	        reviewList.innerHTML = '<p class="cf-bundle-product__review-empty">Loading reviews...</p>';
	      }
	      return fetch(reviewEndpointUrl(), {
	        headers: { 'Accept': 'application/json' }
	      })
	        .then(function(response) {
	          if (!response.ok) throw new Error('Could not load reviews.');
	          return response.json();
	        })
	        .then(function(payload) {
	          reviewsLoaded = true;
	          renderReviews(payload || {});
	        })
	        .catch(function(error) {
	          updateReviewFetchError(error);
	          if (reviewList) reviewList.innerHTML = '<p class="cf-bundle-product__review-empty">Reviews are not available right now.</p>';
	        })
	        .finally(function() {
	          reviewsLoading = false;
	        });
	    }

	    function fetchReviewSummary(force) {
	      if (reviewsSummaryLoading || (reviewsSummaryLoaded && !force)) return Promise.resolve();
	      reviewsSummaryLoading = true;
	      return fetch(reviewSummaryEndpointUrl(), {
	        headers: { 'Accept': 'application/json' }
	      })
	        .then(function(response) {
	          if (!response.ok) throw new Error('Could not load review summary.');
	          return response.json();
	        })
	        .then(function(payload) {
	          reviewsSummaryLoaded = true;
	          updateReviewSummary(payload && payload.stats);
	        })
	        .catch(function(error) {
	          updateReviewFetchError(error);
	          updateReviewSummary({ count: 0, average: 0 });
	        })
	        .finally(function() {
	          reviewsSummaryLoading = false;
	        });
	    }

	    function openDetailsModal() {
	      if (!detailsModal) return;
	      detailsLastFocus = document.activeElement;
	      renderProductDetails();
	      detailsModal.hidden = false;
	      document.documentElement.classList.add('cf-details-modal-open');
	      var closeButton = detailsModal.querySelector('[data-cf-details-close].cf-bundle-product__details-close');
	      if (closeButton) {
	        try {
	          closeButton.focus({ preventScroll: true });
	        } catch (error) {
	          closeButton.focus();
	        }
	      }
	    }

	    function closeDetailsModal() {
	      if (!detailsModal) return;
	      detailsModal.hidden = true;
	      document.documentElement.classList.remove('cf-details-modal-open');
	      if (detailsLastFocus && detailsLastFocus.focus) {
	        try {
	          detailsLastFocus.focus({ preventScroll: true });
	        } catch (error) {
	          detailsLastFocus.focus();
	        }
	      }
	    }

	    function handleDetailsModalClick(event) {
	      if (!detailsModal || detailsModal.hidden) return;
	      var target = event.target;
	      if (target === detailsModal || (target && target.classList && target.classList.contains('cf-bundle-product__details-backdrop'))) {
	        closeDetailsModal();
	      }
	    }

	    function openReviewsModal() {
	      if (!reviewsModal) return;
	      reviewsLastFocus = document.activeElement;
	      reviewsModal.hidden = false;
	      document.documentElement.classList.add('cf-reviews-modal-open');
	      fetchReviews(false);
	      var closeButton = reviewsModal.querySelector('[data-cf-reviews-close].cf-bundle-product__review-close');
	      if (closeButton) {
	        try {
	          closeButton.focus({ preventScroll: true });
	        } catch (error) {
	          closeButton.focus();
	        }
	      }
	    }

		    function closeReviewsModal() {
		      if (!reviewsModal) return;
		      reviewsModal.hidden = true;
		      document.documentElement.classList.remove('cf-reviews-modal-open');
		      if (reviewsLastFocus && reviewsLastFocus.focus) {
		        try {
		          reviewsLastFocus.focus({ preventScroll: true });
		        } catch (error) {
		          reviewsLastFocus.focus();
		        }
		      }
		    }

		    function handleReviewsModalClick(event) {
		      if (!reviewsModal || reviewsModal.hidden) return;
		      var target = event.target;
		      if (target === reviewsModal || (target && target.classList && target.classList.contains('cf-bundle-product__review-backdrop'))) {
		        closeReviewsModal();
		      }
		    }

    function cartItemCount(cart) {
      return !cart ? 0 : Array.isArray(cart) ? cart.reduce(function(total, item) { return total + (Array.isArray(item) ? Number(item[0]) || 0 : Number(item && item.quantity) || 0); }, 0) : Number(cart.item_count) || 0;
    }

    function isCartLike(value) {
      return !!value && (Array.isArray(value) || Array.isArray(value.items) || value.item_count != null);
    }

    function cartFromEventDetail(detail) {
      if (!detail) return null;
      if (isCartLike(detail.cart)) return detail.cart;
      if (isCartLike(detail)) return detail;
      return null;
    }

    function projectedCartQuantity(q) { return activeCartItemCount + (Number(q) || 0); }

		    function discountPercentForQuantity(quantity) {
      var percent = 0;
      bundleDiscountTiers.forEach(function(tier) {
        if (quantity >= tier.quantity) percent = tier.percent;
      });
      return percent;
    }

    function discountTierForQuantity(quantity) {
      var currentTier = null;
      bundleDiscountTiers.forEach(function(tier) {
        if (quantity >= tier.quantity) currentTier = tier;
      });
      return currentTier;
    }

    function priceForSelection(selection) {
      if (!selection) return 0;
      var price = selection.price != null ? selection.price : selection.pricePence;
      var compareAt = selection.compareAtPrice != null ? selection.compareAtPrice : selection.compareAtPricePence;
      return toCents(price) || toCents(compareAt);
    }

    function comparePriceForSelection(selection) {
      if (!selection) return 0;
      var compareAt = selection.compareAtPrice != null ? selection.compareAtPrice : selection.compareAtPricePence;
      if (compareAt == null) compareAt = selection.compare_at_price;
      return toCents(compareAt);
    }

    function subtotalForSelections(pricingSelections) {
      return pricingSelections.reduce(function(sum, selection) {
        return sum + priceForSelection(selection);
      }, 0);
    }

    function selectionsForPricing() {
      if (singleModeActive()) {
        var variant = selectedSingleProductVariant() || singleProductPreviewVariant();
        return variant ? [variant] : [];
      }
      if (hasComponentConfig) {
        var size = previewSize();
        var previewSelections = size ? defaultSelections(size) : [];
        return subtotalForSelections(selections) > 0 ? selections : previewSelections;
      }
      if (selections.length) return selections;
      return [];
    }

    function pricingUnitPrice() {
      var pricingSelections = selectionsForPricing();
      var quantity = pricingSelections.length || selectedQuantity();
      var subtotal = subtotalForSelections(pricingSelections);
      if (!subtotal && !hasComponentConfig) subtotal = priceForSelection(previewSize());
      return quantity > 0 && subtotal > 0 ? subtotal / quantity : 0;
    }

    function discountedPriceForAmount(amount, discountPercent) {
      var price = Number(amount) || 0;
      var percent = Number(discountPercent) || 0;
      if (!(price > 0)) return 0;
      return percent > 0 ? Math.ceil(price * (100 - percent) / 100) : Math.round(price);
    }

    function discountedTotalForQuantity(unitPrice, quantity, discountPercent) {
      var count = Number(quantity) || 0;
      if (!(unitPrice > 0) || !(count > 0)) return 0;
      return discountedPriceForAmount(unitPrice, discountPercent) * count;
    }

    function stackSaveQuantity() {
      var activeQuantity = Number(currentQuantity || (activePack && activePack.quantity) || config.quantity || fallback.quantity || 0) || 0;
      if (activeQuantity > 0) return activeQuantity;
      var quantity = selectedQuantity();
      return quantity > 0 ? quantity : 1;
    }

    function stackSaveDiscountLabel(tier) {
      var percent = Number(tier && tier.percent) || 0;
      return Number.isInteger(percent) ? String(percent) : String(Math.round(percent * 10) / 10);
    }

    function stackSaveTierLabel(tier) {
      var count = Number(tier && tier.quantity) || 0;
      return count + ' FOR ' + stackSaveDiscountLabel(tier) + '% OFF';
    }

    function ensureStackSaveInvertedSegments() {
      if (stackSaveInvertedSegments) return stackSaveInvertedSegments;
      if (!stackSaveSegments || !stackSaveSegments.parentNode) return null;
      stackSaveInvertedSegments = document.createElement('div');
      stackSaveInvertedSegments.className = 'cf-bundle-product__stack-save-segments cf-bundle-product__stack-save-segments--inverted';
      stackSaveInvertedSegments.setAttribute('data-cf-stack-save-inverted-segments', '');
      stackSaveInvertedSegments.setAttribute('aria-hidden', 'true');
      stackSaveSegments.parentNode.appendChild(stackSaveInvertedSegments);
      return stackSaveInvertedSegments;
    }

    function renderStackSaveSegments(container, cartCount) {
      if (!container) return;
      container.textContent = '';
      bundleDiscountTiers.forEach(function(tier) {
        var segment = document.createElement('span');
        var label = document.createElement('span');
        segment.className = 'cf-bundle-product__stack-save-segment' + (cartCount >= tier.quantity ? ' is-unlocked' : '');
        label.className = 'cf-bundle-product__stack-save-label';
        label.textContent = stackSaveTierLabel(tier);
        segment.appendChild(label);
        container.appendChild(segment);
      });
    }

    function updateStackSaveWidget() {
      if (!stackSave || !bundleDiscountTiers.length) return;
      var selectedCount = stackSaveQuantity();
      var cartCount = Math.max(0, Number(activeCartItemCount) || 0);
      var afterAddCount = cartCount + selectedCount;
      var maxTarget = Number(bundleDiscountTiers[bundleDiscountTiers.length - 1].quantity) || 0;
      if (!(maxTarget > 0)) {
        stackSave.hidden = true;
        return;
      }

      stackSave.hidden = false;
      var progressPercent = Math.max(0, Math.min(100, (cartCount / maxTarget) * 100));
      if (stackSaveFill) {
        stackSaveFill.style.width = progressPercent <= 0
          ? '0%'
          : progressPercent >= 99.5
            ? '100%'
            : 'calc(' + progressPercent + '% + var(--stack-save-fill-overlap))';
        stackSaveFill.classList.toggle('is-complete', progressPercent >= 99.5);
      }
      var invertedSegments = ensureStackSaveInvertedSegments();
      if (invertedSegments) {
        var invertedClip = progressPercent >= 99.5
          ? 'inset(0 0 0 0)'
          : progressPercent <= 0
            ? 'inset(0 100% 0 0)'
            : 'polygon(0 0, calc(' + progressPercent + '% + var(--stack-save-fill-overlap)) 0, calc(' + progressPercent + '% - var(--stack-save-fill-overlap)) 100%, 0 100%)';
        invertedSegments.style.clipPath = invertedClip;
        invertedSegments.style.webkitClipPath = invertedClip;
      }

      var currentTier = null;
      var nextTier = null;
      bundleDiscountTiers.forEach(function(tier) {
        if (cartCount >= tier.quantity) {
          currentTier = tier;
        } else if (!nextTier) {
          nextTier = tier;
        }
      });
      var afterAddTier = discountTierForQuantity(afterAddCount);

      if (stackSaveSegments) {
        renderStackSaveSegments(stackSaveSegments, cartCount);
        renderStackSaveSegments(invertedSegments, cartCount);
      }

      if (stackSaveMessage) {
        if (afterAddTier && (!currentTier || afterAddTier.quantity > currentTier.quantity)) {
          var unlockPrefix = currentTier
            ? '<strong>' + escapeHtml(stackSaveTierLabel(currentTier)) + ' UNLOCKED!</strong> '
            : '';
          stackSaveMessage.innerHTML = unlockPrefix + 'ADD TO CART TO UNLOCK ' + escapeHtml(stackSaveTierLabel(afterAddTier));
        } else if (currentTier && nextTier) {
          var needed = Math.max(1, nextTier.quantity - cartCount);
          stackSaveMessage.innerHTML = '<strong>' + escapeHtml(stackSaveTierLabel(currentTier)) + ' UNLOCKED!</strong> ADD ' + needed + ' MORE FOR ' + escapeHtml(stackSaveTierLabel(nextTier));
        } else if (currentTier) {
          stackSaveMessage.innerHTML = '<strong>' + escapeHtml(stackSaveTierLabel(currentTier)) + ' UNLOCKED!</strong> YOU&#039;VE UNLOCKED THE MAX DISCOUNT!';
        } else if (nextTier) {
          stackSaveMessage.textContent = 'ADD ' + Math.max(1, nextTier.quantity - cartCount) + ' MORE FOR ' + stackSaveTierLabel(nextTier);
        } else {
          stackSaveMessage.textContent = 'ADD ITEMS TO UNLOCK DISCOUNTS';
        }
      }
    }

    function discountedTotalForSelections(pricingSelections, quantity, subtotal, discountPercent) {
      if (!(discountPercent > 0)) return Math.round(subtotal || 0);
      if (pricingSelections.length) {
        return pricingSelections.reduce(function(sum, selection) {
          return sum + discountedPriceForAmount(priceForSelection(selection), discountPercent);
        }, 0);
      }
      return discountedTotalForQuantity(subtotal / quantity, quantity, discountPercent);
    }

    function savingsForQuantity(quantity) {
      var packQuantityValue = Number(quantity);
      var unitPrice = pricingUnitPrice();
      var discountPercent = discountPercentForQuantity(projectedCartQuantity(packQuantityValue));
      if (!(packQuantityValue > 0) || !(unitPrice > 0) || !(discountPercent > 0)) return 0;
      var subtotal = Math.round(unitPrice * packQuantityValue);
      return Math.max(0, subtotal - discountedTotalForQuantity(unitPrice, packQuantityValue, discountPercent));
    }

    function bundlePricing() {
      if (singleModeActive()) {
        var variant = selectedSingleProductVariant() || singleProductPreviewVariant();
        var price = priceForSelection(variant);
        var compareAt = comparePriceForSelection(variant);
        var subtotal = compareAt > price ? compareAt : price;
        var discountPercent = discountPercentForQuantity(projectedCartQuantity(1));
        return {
          quantity: 1,
          subtotal: subtotal,
          price: discountedPriceForAmount(price, discountPercent),
          discountPercent: discountPercent
        };
      }
      var pricingSelections = selectionsForPricing();
      var quantity = pricingSelections.length || selectedQuantity();
      var subtotal = subtotalForSelections(pricingSelections);
      if (!subtotal && !hasComponentConfig) subtotal = priceForSelection(previewSize());
      var discountPercent = discountPercentForQuantity(projectedCartQuantity(quantity));
      var finalPrice = subtotal > 0 ? discountedTotalForSelections(pricingSelections, quantity, subtotal, discountPercent) : 0;
      return {
        quantity: quantity,
        subtotal: subtotal,
        price: finalPrice,
        discountPercent: discountPercent
      };
    }

    function updatePriceDisplay() {
      var pricing = bundlePricing();
      if (priceEl) priceEl.textContent = money(pricing.price);
      if (comparePriceEl) {
        comparePriceEl.hidden = !(pricing.subtotal > pricing.price);
        comparePriceEl.textContent = pricing.subtotal > pricing.price ? money(pricing.subtotal) : '';
      }
      if (unitEl) {
        unitEl.textContent = !singleModeActive() && pricing.quantity && pricing.price
          ? money(Math.ceil(pricing.price / pricing.quantity)) + '/item'
          : '';
      }
      root.querySelectorAll('[data-cf-pack-option]').forEach(function(card) {
        var saveEl = card.querySelector('[data-cf-pack-save]');
        if (!saveEl) return;
        var packQuantity = Number(card.dataset.cfPackQuantity);
        var saveAmount = savingsForQuantity(packQuantity);
        saveEl.hidden = !(saveAmount > 0);
        saveEl.textContent = saveAmount > 0 ? 'Save ' + money(saveAmount) : '';
      });
    }

    function uniqueOptions(size) {
      var options = Array.isArray(size && size.options) ? size.options : [];
      return dedupeOptions(options);
    }

    function slotOptions(size, selection) {
      var options = uniqueOptions(size);
      var filtered = options.filter(function(option) {
        return sameComponentProduct(option, selection);
      });
      return filtered.length ? filtered : options;
    }

    function enrichedSelection(size, selection) {
      var options = slotOptions(size, selection);
      var matched = options.find(function(option) {
        return option && selection && option.sku && selection.sku && normalKey(option.sku) === normalKey(selection.sku);
      }) || options.find(function(option) {
        return sameChoice(option, selection);
      });
      var nextSelection = Object.assign({}, selection || {}, matched || {});
      delete nextSelection._imageRequestStarted;
      delete nextSelection._brokenImageUrl;
      return nextSelection;
    }

    function slotImageUrl(selection, options) {
      var productImageUrl = imageFromProductData(componentProductForOption(selection), selection);
      if (productImageUrl) return productImageUrl;

      var fallbackItem = selection && selection.sku ? componentFallbackBySku[normalKey(selection.sku)] : null;
      var fallbackImageUrl = usableImageUrl(fallbackItem && fallbackItem.imageUrl);
      var selectedImageUrl = usableImageUrl(selection && selection.imageUrl);
      if (fallbackImageUrl && (!selectedImageUrl || sameImageUrl(selectedImageUrl, currentProduct.imageUrl))) {
        return fallbackImageUrl;
      }

      var exactOption = (options || []).find(function(option) {
        return option && selection && option.sku && selection.sku && normalKey(option.sku) === normalKey(selection.sku);
      });
      var exactImageUrl = usableImageUrl(exactOption && exactOption.imageUrl);
      if (exactImageUrl && (!selectedImageUrl || sameImageUrl(selectedImageUrl, currentProduct.imageUrl))) {
        return exactImageUrl;
      }
      var variantImage = componentVariantImageForOption(selection);
      var variantImageUrl = usableImageUrl(variantImage && (variantImage.thumbUrl || variantImage.url));
      if (variantImageUrl && (!selectedImageUrl || sameImageUrl(selectedImageUrl, currentProduct.imageUrl))) {
        return variantImageUrl;
      }
      if (selectedImageUrl) return selectedImageUrl;
      if (variantImageUrl) return variantImageUrl;
      if (fallbackImageUrl) return fallbackImageUrl;
      if (exactImageUrl) return exactImageUrl;

      var matchedOption = (options || []).find(function(option) {
        return sameChoice(option, selection) && usableImageUrl(option.imageUrl);
      });
      var matchedVariantImage = componentVariantImageForOption(matchedOption);
      return usableImageUrl(matchedVariantImage && (matchedVariantImage.thumbUrl || matchedVariantImage.url)) ||
        usableImageUrl(matchedOption && matchedOption.imageUrl);
    }

    function defaultSelections(size) {
      if (!hasComponentConfig) return [];
      var slots = Array.isArray(size && size.slots) ? size.slots : [];
      if (slots.length) return slots.map(function(slot) {
        return enrichedSelection(size, slot);
      });
      return uniqueOptions(size).map(function(option) { return Object.assign({}, option); });
    }

    function previewSize() {
      return selectedSize || sizes.find(function(size) { return size && size.available !== false; }) || sizes[0] || null;
    }

    function activeCustomizerSize() {
      return previewSize();
    }

    function skuWithoutSize(value) {
      var parts = normalKey(value).split('-').filter(Boolean);
      return parts.length > 1 ? parts.slice(0, -1).join('-') : parts.join('-');
    }

    function skuProductStem(value) {
      var parts = normalKey(value).split('-').filter(Boolean);
      return parts.length > 3 ? parts.slice(0, -2).join('-') : skuWithoutSize(value);
    }

    function componentFamilyKey(option) {
      var explicit = normalKey(option && (
        option.componentFamilyKey ||
        option.component_family_key ||
        option.componentFamily ||
        option.component_family ||
        option.familyKey ||
        option.family_key
      ));
      return explicit || skuProductStem(option && option.sku);
    }

    function sameChoice(option, selection) {
      if (!option || !selection) return false;
      if (option.sku && selection.sku && skuWithoutSize(option.sku) === skuWithoutSize(selection.sku)) return true;
      if (option.colorCode && selection.colorCode && normalKey(option.colorCode) === normalKey(selection.colorCode)) return true;
      if (option.colorName && selection.colorName && normalKey(option.colorName) === normalKey(selection.colorName)) return true;
      return false;
    }

    function sameComponentSkuStem(option, selection) {
      var optionStem = componentFamilyKey(option);
      var selectionStem = componentFamilyKey(selection);
      return Boolean(optionStem && selectionStem && optionStem === selectionStem);
    }

    function sameComponentIdentity(option, selection) {
      if (!option || !selection) return false;
      if (sameComponentSkuStem(option, selection)) return true;
      if (option.productId && selection.productId && String(option.productId) === String(selection.productId)) return true;
      if (option.productHandle && selection.productHandle && String(option.productHandle) === String(selection.productHandle)) return true;
      if (option.productTitle && selection.productTitle && String(option.productTitle) === String(selection.productTitle)) return true;
      return false;
    }

    function optionSizeValue(option) {
      return String(option && (option.size || option.option2 || option.option3) || '').trim();
    }

    function markSelectionSizeChosen(selection) {
      var nextSelection = Object.assign({}, selection || {}, {
        _cfSizeChosen: Boolean(optionSizeValue(selection))
      });
      delete nextSelection._imageRequestStarted;
      delete nextSelection._brokenImageUrl;
      return nextSelection;
    }

    function selectionHasChosenSize(selection) {
      return Boolean(selection && selection._cfSizeChosen && optionSizeValue(selection));
    }

    function optionSkuColorToken(option) {
      var parts = normalKey(option && option.sku).split('-').filter(Boolean);
      return parts.length > 3 ? parts[parts.length - 2] : '';
    }

    function optionVariantTitleColor(option) {
      var title = String(option && option.variantTitle || '').trim();
      return title ? title.split('/')[0].trim() : '';
    }

    function optionColorName(option) {
      return option && (
        option.colorName ||
        option.colourName ||
        option.option1 ||
        optionVariantTitleColor(option)
      ) || '';
    }

    function optionColorValue(option) {
      return optionColorName(option) ||
        (option && (option.colorCode || option.colourCode || option.productTitle || option.sku)) ||
        '';
    }

    function optionColorKey(option) {
      return looseKey(optionColorValue(option));
    }

    function sameColorOption(first, second) {
      var firstToken = optionSkuColorToken(first);
      var secondToken = optionSkuColorToken(second);
      if (firstToken && secondToken) return firstToken === secondToken;
      var firstName = looseKey(optionColorName(first));
      var secondName = looseKey(optionColorName(second));
      if (firstName && secondName) return firstName === secondName;
      var firstCode = looseKey(first && (first.colorCode || first.colourCode));
      var secondCode = looseKey(second && (second.colorCode || second.colourCode));
      if (firstCode && secondCode) return firstCode === secondCode;
      return sameChoice(first, second);
    }

    function sameOptionSize(option, sizeValue) {
      var currentSize = normalSize(optionSizeValue(option));
      var targetSize = normalSize(sizeValue);
      return Boolean(currentSize && targetSize && currentSize === targetSize);
    }

    function remapSelectionsForSize(size, currentSelections) {
      var defaults = defaultSelections(size);
      var source = currentSelections && currentSelections.length ? currentSelections : defaults;
      return source.map(function(selection, index) {
        var defaultSelection = defaults[index] || null;
        return enrichedSelection(size, selection || defaultSelection);
      });
    }

    function ensurePreviewSelections() {
      var size = activeCustomizerSize();
      if (hasComponentConfig && size && !selections.length) {
        selections = defaultSelections(size);
      }
      return size;
    }

    function optionLabel(option) {
      return optionColorName(option) || option && (option.productTitle || option.sku) || 'Tee';
    }

    function optionColourKeys(option) {
      return [
        optionSkuColorToken(option),
        optionColorName(option),
        option && (option.colorCode || option.colourCode)
      ].map(looseKey).filter(Boolean);
    }

    function optionColorHex(option) {
      var hex = String(option && (option.colorHex || option.colourHex || option.hex) || '').trim();
      return /^#?[0-9a-f]{6}$/i.test(hex) ? (hex.charAt(0) === '#' ? hex : '#' + hex) : '';
    }

    function optionSwatchColor(option) {
      var hex = optionColorHex(option);
      if (hex) return hex;
      var name = looseKey(optionColorName(option));
      var map = {
        black: '#111111',
        white: '#ffffff',
        navy: '#14233a',
        heathernavy: '#223145',
        carbon: '#545454',
        charcoal: '#45484a',
        darkheather: '#474b4e',
        sportgrey: '#c8c8c8',
        heathergrey: '#bfc0bd',
        heathergray: '#bfc0bd',
        grey: '#bfc0bd',
        gray: '#bfc0bd',
        militarygreen: '#68694a',
        heathermilitarygreen: '#69745a',
        pistachio: '#b7c9b2',
        maroon: '#5d2733',
        red: '#b82024',
        royalblue: '#1d4f9a',
        stoneblue: '#6d84a1',
        sand: '#d0c5ad',
        yellow: '#eed05a',
        paragon: '#678177',
        green: '#687452',
        royal: '#1d4f9a',
        blue: '#2c5f9d'
      };
      return map[name] || '#d8d8d8';
    }

    function cssUrlValue(url) {
      var cleanUrl = usableImageUrl(url);
      return cleanUrl ? 'url("' + cleanUrl.replace(/["\\]/g, '\\$&') + '")' : '';
    }

    function optionSwatchImage(option) {
      if (optionColorHex(option)) return '';
      var variantImage = componentVariantImageForOption(option);
      return usableImageUrl(variantImage && (variantImage.thumbUrl || variantImage.url)) ||
        usableImageUrl(option && (option.thumbUrl || option.imageUrl));
    }

    function colorAltMatchesOption(alt, option) {
      var colorKey = looseKey(optionColorName(option));
      if (!colorKey) return false;
      var segments = String(alt || '').split(/[|,;/]+/);
      return segments.some(function(segment) {
        var normalizedColor = looseKey(segment);
        if (!normalizedColor) return false;
        if (normalizedColor === colorKey) return true;
        if (normalizedColor.indexOf(colorKey) !== 0) return false;
        var suffix = normalizedColor.slice(colorKey.length);
        return /^(lifestyle|model|front|back|left|right|side|detail|flatlay|shirt|tee|tshirt|image|photo|gallery)/.test(suffix);
      });
    }

    function taggedGalleryMetadata(alt) {
      var segments = String(alt || '').split('|').map(function(segment) {
        return segment.trim();
      }).filter(Boolean);
      var normalizedSegments = segments.map(looseKey);
      var viewPattern = /^(?:amazon)?(?:lifestyle)?(?:front|back|left|right|side|detail|closeup|angle|threequarter|other)(?:lifestyle)?$/;
      var viewIndex = normalizedSegments.findIndex(function(segment) {
        return viewPattern.test(segment) || segment === 'lifestyle';
      });
      var colorIndex = -1;

      if (normalizedSegments[0] === 'lifestyle') {
        colorIndex = segments.length > 2 ? segments.length - 1 : -1;
      } else if (viewIndex === 0) {
        for (var index = segments.length - 1; index > 0; index -= 1) {
          if (normalizedSegments[index] !== 'primary') {
            colorIndex = index;
            break;
          }
        }
      } else if (viewIndex > 0) {
        colorIndex = 0;
      }

      var hasModelKeyword = segments.some(function(segment) {
        return /\b(lifestyle|model|worn|fit|look)\b/i.test(segment);
      });
      var hasModelMetadata = viewIndex > -1 && colorIndex > -1 && segments.some(function(segment, index) {
        if (index === viewIndex || index === colorIndex) return false;
        var normalized = normalizedSegments[index];
        return normalized && normalized !== 'primary' && normalized !== 'image' &&
          normalized !== 'garment' && normalized !== 'product' && normalized !== 'mockup';
      });

      return {
        view: viewIndex > -1 ? segments[viewIndex] : '',
        colour: colorIndex > -1 ? segments[colorIndex] : '',
        primary: normalizedSegments.indexOf('primary') > -1,
        model: hasModelKeyword || hasModelMetadata
      };
    }

    function imageAltLooksLifestyle(alt) {
      return taggedGalleryMetadata(alt).model;
    }

    function primaryLifestyleMetadata(alt) {
      var metadata = taggedGalleryMetadata(alt);
      if (!metadata.model) return null;
      return metadata;
    }

    function imageAltLooksFrontBack(alt) {
      return /(^|[^a-z0-9])(front|back|left|right|side|detail|flatlay)([^a-z0-9]|$)/i.test(String(alt || ''));
    }

    function componentProductForOption(option) {
      var fallbackItem = option && option.sku ? componentFallbackBySku[normalKey(option.sku)] : null;
      var skuKey = normalKey(option && option.sku);
      if (skuKey && componentProductBySku[skuKey]) return componentProductBySku[skuKey];
      var familyKey = componentFamilyKey(option);
      if (familyKey && componentProductByFamilyKey[familyKey]) return componentProductByFamilyKey[familyKey];
      var stemKey = skuProductStem(option && option.sku);
      if (stemKey && componentProductBySkuStem[stemKey]) return componentProductBySkuStem[stemKey];
      var handle = option && (option.productHandle || option.product_handle);
      if (!handle && fallbackItem) handle = fallbackItem.productHandle;
      if (handle && componentProductByHandle[String(handle)]) return componentProductByHandle[String(handle)];
      return null;
    }

    function optionFromComponentVariant(productData, variant, seed) {
      if (!productData || !variant || !variant.sku) return null;
      var fallbackItem = componentFallbackBySku[normalKey(variant.sku)] || null;
      var imageUrl = usableImageUrl(variant.imageUrl);
      var thumbUrl = usableImageUrl(variant.thumbUrl || variant.imageUrl) || imageUrl;
      var variantTitle = [variant.option1, variant.option2, variant.option3].filter(Boolean).join(' / ');
      var familyKey = componentFamilyKey(seed) || componentFamilyKey(fallbackItem) || skuProductStem(variant.sku);
      return patchComponentEntry(Object.assign(
        {},
        seed || {},
        fallbackItem || {},
        {
          sku: variant.sku,
          componentFamilyKey: familyKey,
          component_family_key: familyKey,
          componentFamilyTag: familyKey ? 'classicfit-family-' + familyKey : '',
          shopifyVariantId: variant.id || (fallbackItem && (fallbackItem.shopifyVariantId || fallbackItem.variantId)) || null,
          variantId: variant.id || (fallbackItem && fallbackItem.variantId) || null,
          available: variant.available,
          productTitle: productData.title || (fallbackItem && fallbackItem.productTitle) || '',
          productHandle: productData.handle || (fallbackItem && fallbackItem.productHandle) || '',
          variantTitle: variantTitle || (fallbackItem && fallbackItem.variantTitle) || '',
          colorName: variant.option1 || (fallbackItem && fallbackItem.colorName) || '',
          colorHex: variant.colorHex || (fallbackItem && fallbackItem.colorHex) || '',
          colourHex: variant.colorHex || (fallbackItem && fallbackItem.colourHex) || '',
          size: variant.option2 || variant.option3 || (fallbackItem && fallbackItem.size) || '',
          option1: variant.option1 || '',
          option2: variant.option2 || '',
          option3: variant.option3 || '',
          imageUrl: imageUrl || (fallbackItem && fallbackItem.imageUrl) || '',
          thumbUrl: thumbUrl || (fallbackItem && (fallbackItem.thumbUrl || fallbackItem.imageUrl)) || '',
          details: detailsForEntry(seed) || detailsForEntry(fallbackItem)
        }
      ));
    }

    function componentVariantOptionsForProduct(productData, seed) {
      var variants = Array.isArray(productData && productData.variants) ? productData.variants : [];
      return variants.map(function(variant) {
        return optionFromComponentVariant(productData, variant, seed);
      }).filter(Boolean);
    }

    function componentVariantOptionsForSelection(selection) {
      var productData = componentProductForOption(selection);
      return productData ? componentVariantOptionsForProduct(productData, selection) : [];
    }

    function selectionIsPurchasable(selection) {
      if (!selection) return false;
      var variantAvailabilityKey = componentVariantAvailabilityKey(selection);
      if (variantAvailabilityKey && componentVariantAvailabilityById[variantAvailabilityKey] != null) {
        return componentVariantAvailabilityById[variantAvailabilityKey] !== false;
      }
      var productData = componentProductForOption(selection);
      if (productData) {
        var componentVariant = componentVariantForOption(selection);
        if (componentVariant) return componentVariant.available !== false;
        return variantAvailabilityKey ? true : false;
      }
      return true;
    }

    function availabilitySelectionsForSize(size) {
      var slots = Array.isArray(size && size.slots) ? size.slots : [];
      if (slots.length) {
        return slots.map(function(slot) {
          return enrichedSelection(size, slot);
        });
      }
      var components = Array.isArray(size && size.components) ? size.components : [];
      if (components.length) {
        return components.map(function(component) {
          return enrichedSelection(size, component);
        });
      }
      return defaultSelections(size);
    }

    function sizeComponentsArePurchasable(size) {
      if (!hasComponentConfig) return true;
      var selectionsForSize = availabilitySelectionsForSize(size);
      if (!selectionsForSize.length) return false;
      return selectionsForSize.every(function(selection) {
        return selectionIsPurchasable(selection);
      });
    }

    function bundleAvailabilityPending() {
      return Boolean(hasComponentConfig && !singleModeActive() && !bundleSizeAvailabilityReady);
    }

    function recalculateBundleSizeAvailability(force) {
      if (!hasComponentConfig) return;
      if (!force && !bundleSizeAvailabilityReady) return;
      sizes.forEach(function(size) {
        size.available = sizeComponentsArePurchasable(size);
      });
    }

    function bundleAvailabilitySeeds() {
      var seen = {};
      var seeds = [];
      sizes.forEach(function(size) {
        availabilitySelectionsForSize(size).forEach(function(selection) {
          var key = componentFamilyKey(selection) || normalKey(selection && selection.productHandle) || skuProductStem(selection && selection.sku);
          if (!key || seen[key]) return;
          seen[key] = true;
          seeds.push(selection);
        });
      });
      return seeds;
    }

    function bundleAvailabilityVariantSeeds() {
      var seen = {};
      var seeds = [];
      sizes.forEach(function(size) {
        availabilitySelectionsForSize(size).forEach(function(selection) {
          var key = componentVariantAvailabilityKey(selection);
          if (!key || seen[key]) return;
          seen[key] = true;
          seeds.push(selection);
        });
      });
      return seeds;
    }

    function hydrateBundleSizeAvailability() {
      if (!hasComponentConfig || bundleSizeAvailabilityHydrating || bundleSizeAvailabilityReady) return;
      var seeds = bundleAvailabilitySeeds();
      var variantSeeds = bundleAvailabilityVariantSeeds();
      if (!seeds.length && !variantSeeds.length) {
        bundleSizeAvailabilityReady = true;
        recalculateBundleSizeAvailability(true);
        refresh();
        return;
      }
      bundleSizeAvailabilityHydrating = true;
      Promise.all(seeds.map(fetchComponentProductDataForOption)).then(function() {
        var unresolvedVariantSeeds = variantSeeds.filter(function(selection) {
          var productData = componentProductForOption(selection);
          return !productData || !componentVariantForOption(selection);
        });
        return Promise.all(unresolvedVariantSeeds.map(hydrateSelectionAvailability));
      }).then(function() {
        bundleSizeAvailabilityHydrating = false;
        bundleSizeAvailabilityReady = true;
        recalculateBundleSizeAvailability(true);
        refresh();
      }).catch(function() {
        bundleSizeAvailabilityHydrating = false;
        bundleSizeAvailabilityReady = true;
        refresh();
      });
    }

    function bundleEntriesForSelection(selection) {
      if (!selection || !selection.sku) return [];
      var collected = [];
      sizes.forEach(function(size) {
        ['options', 'components', 'componentQuantities', 'slots'].forEach(function(key) {
          (Array.isArray(size && size[key]) ? size[key] : []).forEach(function(entry) {
            if (!sameComponentIdentity(entry, selection)) return;
            collected.push(patchComponentEntry(Object.assign({}, entry)));
          });
        });
      });
      return dedupeOptions(collected);
    }

    function componentVariantForOption(option) {
      var productData = componentProductForOption(option);
      var variants = Array.isArray(productData && productData.variants) ? productData.variants : [];
      var selectedVariantId = normalId(option && (option.shopifyVariantId || option.variantId));
      var selectedSku = normalKey(option && option.sku);
      var selectedColor = looseKey(option && (option.colorName || option.option1));
      var selectedSize = normalSize(option && (option.size || option.option2 || option.variantTitle));

      return variants.find(function(candidate) {
        return selectedVariantId && normalId(candidate.id) === selectedVariantId;
      }) || variants.find(function(candidate) {
        return selectedSku && normalKey(candidate.sku) === selectedSku;
      }) || variants.find(function(candidate) {
        var candidateColor = looseKey(candidate.option1);
        var candidateSize = normalSize(candidate.option2 || candidate.option3);
        return selectedColor && candidateColor === selectedColor && (!selectedSize || candidateSize === selectedSize);
      }) || null;
    }

    function componentVariantImageForOption(option) {
      var variant = componentVariantForOption(option);
      var fallbackItem = option && option.sku ? componentFallbackBySku[normalKey(option.sku)] : null;
      var variantUrl = usableImageUrl(variant && variant.imageUrl);
      if (variantUrl) {
        return {
          url: variantUrl,
          thumbUrl: usableImageUrl(variant && (variant.thumbUrl || variant.imageUrl)) || variantUrl,
          alt: optionLabel(option),
          kind: 'variant'
        };
      }
      var fallbackUrl = usableImageUrl(fallbackItem && fallbackItem.imageUrl);
      if (fallbackUrl) {
        return {
          url: fallbackUrl,
          thumbUrl: fallbackUrl,
          alt: optionLabel(option),
          kind: 'variant'
        };
      }
      var optionUrl = usableImageUrl(option && option.imageUrl);
      if (optionUrl && !sameImageUrl(optionUrl, currentProduct.imageUrl)) {
        return {
          url: optionUrl,
          thumbUrl: usableImageUrl(option && (option.thumbUrl || option.imageUrl)) || optionUrl,
          alt: optionLabel(option),
          kind: 'variant'
        };
      }
      return null;
    }

    function productGalleryForOption(option) {
      var productData = componentProductForOption(option);
      var images = Array.isArray(productData && productData.images) ? productData.images : [];
      var gallery = [];
      var seen = {};
      var matchedColorImages = 0;
      var lifestyleFallbackImages = [];

      function addImage(url, thumbUrl, alt, kind) {
        var cleanUrl = usableImageUrl(url);
        if (!cleanUrl) return;
        var key = imageKey(cleanUrl);
        if (key && seen[key]) return;
        if (key) seen[key] = true;
        gallery.push({
          url: cleanUrl,
          thumbUrl: usableImageUrl(thumbUrl || cleanUrl) || cleanUrl,
          alt: alt || optionLabel(option),
          kind: kind || 'gallery'
        });
      }

      var variantImage = componentVariantImageForOption(option);
      if (variantImage) addImage(variantImage.url, variantImage.thumbUrl, variantImage.alt, 'variant');
      images.forEach(function(image) {
        if (!image) return;
        if (colorAltMatchesOption(image.alt, option)) {
          matchedColorImages += 1;
          addImage(image.url, image.thumbUrl || image.url, image.alt || optionLabel(option), 'gallery');
        } else if (imageAltLooksLifestyle(image.alt)) {
          lifestyleFallbackImages.push(image);
        }
      });
      if (!matchedColorImages && lifestyleFallbackImages.length) {
        lifestyleFallbackImages.slice(0, 4).forEach(function(image) {
          addImage(image.url, image.thumbUrl || image.url, image.alt || optionLabel(option), 'gallery');
        });
      }
      if (!gallery.length) {
        var optionUrl = usableImageUrl(option && (option.thumbUrl || option.imageUrl));
        if (optionUrl && !sameImageUrl(optionUrl, currentProduct.imageUrl)) {
          addImage(optionUrl, optionUrl, optionLabel(option), 'variant');
        }
      }
      return gallery;
    }

    function lifestyleGalleryFromImages(images, option, fallbackAlt) {
      var gallery = [];
      var seen = {};
      var sourceImages = Array.isArray(images) ? images : [];
      var hasSelectedColor = Boolean(looseKey(optionColorName(option)));

      function addImage(imageData, kind) {
        var normalized = normaliseGalleryImage(imageData, fallbackAlt || optionLabel(option));
        if (!normalized) return;
        var key = imageKey(normalized.url);
        if (key && seen[key]) return;
        if (key) seen[key] = true;
        normalized.kind = kind || 'gallery';
        gallery.push(normalized);
      }

      sourceImages.forEach(function(imageData) {
        if (!imageData) return;
        var matchesSelectedColor = colorAltMatchesOption(imageData.alt, option);
        if (hasSelectedColor && !matchesSelectedColor) return;
        if (!hasSelectedColor && !imageAltLooksLifestyle(imageData.alt) && !imageAltLooksFrontBack(imageData.alt)) return;
        addImage(imageData, imageAltLooksLifestyle(imageData.alt) ? 'lifestyle' : 'gallery');
      });

      return dedupeGalleryImages(gallery);
    }

    function lifestyleGalleryForComponentOption(option) {
      var productData = componentProductForOption(option);
      var images = Array.isArray(productData && productData.images) ? productData.images : [];
      return lifestyleGalleryFromImages(images, option, optionLabel(option));
    }

    function appendModalPreviewFrame(imageData, option) {
      if (!colorModalPreview || !imageData || !imageData.url) return false;
      var frame = document.createElement('span');
      var image = document.createElement('img');
      frame.className = 'cf-bundle-product__modal-preview-frame' + (imageData.kind === 'variant' ? ' is-variant' : '');
      image.src = imageData.url;
      image.alt = imageData.alt || optionLabel(option);
      image.loading = 'lazy';
      frame.appendChild(image);
      colorModalPreview.appendChild(frame);
      return true;
    }

    function modalGalleryForOption(option) {
      var productData = componentProductForOption(option);
      var images = Array.isArray(productData && productData.images) ? productData.images : [];
      var gallery = [];
      var seen = {};
      var lifestyleMatches = [];
      var lifestyleFallbacks = [];

      function addImage(imageData, kind) {
        var normalized = normaliseGalleryImage(imageData, optionLabel(option));
        if (!normalized) return;
        var key = imageKey(normalized.url);
        if (key && seen[key]) return;
        if (key) seen[key] = true;
        normalized.kind = kind || normalized.kind || 'gallery';
        gallery.push(normalized);
      }

      var variantImage = componentVariantImageForOption(option);
      if (variantImage) addImage(variantImage, 'variant');

      images.forEach(function(imageData) {
        if (!imageData) return;
        var modalImage = {
          url: imageData.url,
          thumbUrl: imageData.thumbUrl || imageData.url,
          alt: imageData.alt || optionLabel(option)
        };
        if (imageAltLooksFrontBack(imageData.alt)) {
          if (colorAltMatchesOption(imageData.alt, option) || !optionColorName(option)) {
            addImage(modalImage, 'gallery');
          }
          return;
        }
        if (!imageAltLooksLifestyle(imageData.alt)) return;
        if (colorAltMatchesOption(imageData.alt, option)) {
          lifestyleMatches.push(modalImage);
        } else {
          lifestyleFallbacks.push(modalImage);
        }
      });

      (lifestyleMatches.length ? lifestyleMatches : lifestyleFallbacks).slice(0, 4).forEach(function(imageData) {
        addImage(imageData, 'gallery');
      });

      if (!gallery.length) {
        var optionUrl = usableImageUrl(option && (option.thumbUrl || option.imageUrl));
        if (optionUrl && !sameImageUrl(optionUrl, currentProduct.imageUrl)) {
          addImage({
            url: optionUrl,
            thumbUrl: optionUrl,
            alt: optionLabel(option)
          }, 'variant');
        }
      }

      return gallery;
    }

    function allSlotOptionsForSelection(selection) {
      var collected = [];
      bundleEntriesForSelection(selection).forEach(function(option) {
        collected.push(option);
      });
      componentVariantOptionsForSelection(selection).forEach(function(option) {
        collected.push(option);
      });
      sizes.forEach(function(size) {
        slotOptions(size, selection).forEach(function(option) {
          collected.push(option);
        });
      });
      var seenProductHandles = {};
      collected.slice().forEach(function(option) {
        var productData = componentProductForOption(option);
        var handle = productData && productData.handle;
        if (!handle || seenProductHandles[handle]) return;
        seenProductHandles[handle] = true;
        componentVariantOptionsForProduct(productData, option).forEach(function(variantOption) {
          collected.push(variantOption);
        });
      });
      return dedupeOptions(collected);
    }

    function mergeColorModalOptions(options) {
      if (!Array.isArray(options) || !options.length) return false;
      var nextOptions = dedupeOptions(activeColorModalOptions.concat(options));
      if (nextOptions.length === activeColorModalOptions.length) return false;
      activeColorModalOptions = nextOptions;
      return true;
    }

    function colorModalOptionPool() {
      return activeColorModalProductOptions.length ? activeColorModalProductOptions : activeColorModalOptions;
    }

    function hydrateColorModalOptions(selection, slotIndex) {
      fetchComponentProductDataForOption(selection).then(function(productData) {
        if (activeColorModalSlot !== slotIndex || !productData) return;
        var fetchedOptions = componentVariantOptionsForProduct(productData, selection);
        activeColorModalProductOptions = dedupeOptions(fetchedOptions);
        mergeColorModalOptions(fetchedOptions);
        var draftSku = normalKey(activeColorModalDraft && activeColorModalDraft.sku);
        if (draftSku) {
          activeColorModalDraft = colorModalOptionPool().find(function(option) {
            return option && normalKey(option.sku) === draftSku;
          }) || activeColorModalDraft;
          activeColorModalColorKey = modalColorKey(activeColorModalDraft) || activeColorModalColorKey;
        }
        renderColorModal();
      });
    }

    function findModalOptionForColorAndSize(colorOption, sizeValue) {
      var matching = colorModalOptionPool().filter(function(option) {
        if (!sameColorOption(option, colorOption)) return false;
        return !sizeValue || sameOptionSize(option, sizeValue);
      });
      return matching.find(function(option) {
        return modalOptionIsPurchasable(option);
      }) || matching[0] || null;
    }

    function modalVariantId(option) {
      return option && (option.shopifyVariantId || option.variantId || option.id) || '';
    }

    function modalOptionIsPurchasable(option) {
      return Boolean(option && modalVariantId(option) && selectionIsPurchasable(option));
    }

    function normalizeColorModalOption(option) {
      if (!option) return null;
      var nextOption = Object.assign({}, option);
      var variantId = modalVariantId(nextOption);
      if (variantId) {
        if (!nextOption.shopifyVariantId) nextOption.shopifyVariantId = variantId;
        if (!nextOption.variantId) nextOption.variantId = variantId;
      }
      return nextOption;
    }

    function modalColorKey(option) {
      return looseKey(optionSkuColorToken(option)) || optionColorKey(option);
    }

    function findModalOptionForColorKeyAndSize(colorKey, sizeValue) {
      var cleanColorKey = looseKey(colorKey);
      var matching = colorModalOptionPool().filter(function(option) {
        if (cleanColorKey && modalColorKey(option) !== cleanColorKey) return false;
        return !sizeValue || sameOptionSize(option, sizeValue);
      });
      return matching.find(function(option) {
        return modalOptionIsPurchasable(option);
      }) || matching[0] || null;
    }

    function setColorModalDraft(option, colorKey) {
      if (!option) return;
      activeColorModalDraft = normalizeColorModalOption(option);
      activeColorModalColorKey = looseKey(colorKey) || modalColorKey(activeColorModalDraft) || activeColorModalColorKey;
      renderColorModal();
    }

    function selectColorModalColor(colorOption) {
      if (!colorOption) return;
      var nextColorKey = modalColorKey(colorOption);
      var currentSize = optionSizeValue(activeColorModalDraft);
      var nextOption = findModalOptionForColorKeyAndSize(nextColorKey, currentSize) ||
        findModalOptionForColorKeyAndSize(nextColorKey, '') ||
        colorOption;
      setColorModalDraft(nextOption, nextColorKey);
    }

    function selectColorModalSize(sizeOption, sizeLabel) {
      if (!sizeOption && !sizeLabel) return;
      var currentColorKey = activeColorModalColorKey || modalColorKey(activeColorModalDraft) || modalColorKey(sizeOption);
      var nextOption = findModalOptionForColorKeyAndSize(currentColorKey, sizeLabel);
      if (!nextOption && !currentColorKey) nextOption = findModalOptionForColorAndSize(activeColorModalDraft || sizeOption, sizeLabel);
      if (!nextOption && sizeOption && (!currentColorKey || modalColorKey(sizeOption) === currentColorKey)) nextOption = sizeOption;
      setColorModalDraft(nextOption, currentColorKey);
    }

    function colorOptionsForModal() {
      var preferredSize = optionSizeValue(activeColorModalDraft);
      var byColor = {};
      var swatches = [];
      colorModalOptionPool().forEach(function(option) {
        var key = modalColorKey(option);
        if (!key) return;
        var current = byColor[key];
        var shouldReplace = !current ||
          (preferredSize && sameOptionSize(option, preferredSize) && !sameOptionSize(current, preferredSize)) ||
          (selectionIsPurchasable(option) && !selectionIsPurchasable(current));
        if (!current) swatches.push(option);
        if (shouldReplace) {
          byColor[key] = option;
          var existingIndex = swatches.findIndex(function(item) {
              return modalColorKey(item) === key;
          });
          if (existingIndex >= 0) swatches[existingIndex] = option;
        }
      });
      return swatches;
    }

    function sizeOptionsForModal() {
      var pool = colorModalOptionPool();
      var currentColorKey = activeColorModalColorKey || modalColorKey(activeColorModalDraft);
      var filtered = pool.filter(function(option) {
        return currentColorKey ? modalColorKey(option) === currentColorKey : (!activeColorModalDraft || sameColorOption(option, activeColorModalDraft));
      });
      if (!filtered.length && currentColorKey && activeColorModalDraft) {
        filtered = pool.filter(function(option) {
          return sameColorOption(option, activeColorModalDraft);
        });
      }
      if (!filtered.length && !currentColorKey) filtered = pool.slice();
      var bySize = {};
      var sizeList = [];
      filtered.forEach(function(option) {
        var normalizedOption = normalizeColorModalOption(option);
        var label = optionSizeValue(option);
        var key = normalSize(label);
        if (!key) return;
        var current = bySize[key];
        var shouldReplace = !current || (selectionIsPurchasable(normalizedOption) && !selectionIsPurchasable(current.option));
        if (!current) sizeList.push({ key: key, label: label, option: normalizedOption });
        if (shouldReplace) {
          bySize[key] = { key: key, label: label, option: normalizedOption };
          var existingIndex = sizeList.findIndex(function(item) {
            return item.key === key;
          });
          if (existingIndex >= 0) sizeList[existingIndex] = bySize[key];
        }
      });
      return sizeList.sort(function(first, second) {
        var firstRank = sizeRank(first.label);
        var secondRank = sizeRank(second.label);
        if (firstRank !== secondRank) return firstRank - secondRank;
        return first.label.localeCompare(second.label);
      });
    }

    function chooseSlotOption(slotIndex, option) {
      if (!option) return;
      selections[slotIndex] = markSelectionSizeChosen(option);
      closeColorModal();
      renderCustomizer();
      refresh(false);
    }

    function syncEditingSlotState() {
      root.querySelectorAll('[data-cf-bundle-slot]').forEach(function(slot) {
        slot.classList.toggle('is-editing', String(activeColorModalSlot) === slot.dataset.cfBundleSlot);
      });
    }

    function closeColorModal() {
      if (!colorModal) return;
      colorModal.hidden = true;
      activeColorModalSlot = null;
      activeColorModalOptions = [];
      activeColorModalProductOptions = [];
      activeColorModalDraft = null;
      activeColorModalColorKey = '';
      colorModalSwatchesExpanded = false;
      if (colorModalPreview) colorModalPreview.innerHTML = '';
      if (colorModalSwatches) colorModalSwatches.innerHTML = '';
      if (colorModalSizes) colorModalSizes.innerHTML = '';
      syncEditingSlotState();
      document.documentElement.classList.remove('cf-color-modal-open');
    }

    function openColorModal(slotIndex, options) {
      if (!colorModal || !colorModalPreview || !colorModalSwatches || !colorModalSizes) return;
      activeColorModalSlot = slotIndex;
      var currentSelection = selections[slotIndex] || {};
      var allOptions = [];
      (options || []).forEach(function(option) {
        allOptions.push(option);
      });
      slotOptions(activeCustomizerSize(), currentSelection).forEach(function(option) {
        allOptions.push(option);
      });
      bundleEntriesForSelection(currentSelection).forEach(function(option) {
        allOptions.push(option);
      });
      allSlotOptionsForSelection(currentSelection).forEach(function(option) {
        allOptions.push(option);
      });
      activeColorModalOptions = dedupeOptions(allOptions);
      activeColorModalProductOptions = [];
      if (!activeColorModalOptions.length) activeColorModalOptions = currentSelection && currentSelection.sku ? [currentSelection] : [];
      activeColorModalDraft = activeColorModalOptions.find(function(option) {
        return option && currentSelection.sku && option.sku && normalKey(option.sku) === normalKey(currentSelection.sku);
      }) || activeColorModalOptions.find(function(option) {
        return sameChoice(option, currentSelection) && sameOptionSize(option, optionSizeValue(currentSelection));
      }) || activeColorModalOptions.find(function(option) {
        return sameChoice(option, currentSelection);
      }) || activeColorModalOptions[0] || currentSelection;
      activeColorModalDraft = normalizeColorModalOption(activeColorModalDraft);
      activeColorModalColorKey = modalColorKey(activeColorModalDraft) || modalColorKey(currentSelection);
      colorModalSwatchesExpanded = false;
      renderColorModal();
      colorModal.hidden = false;
      syncEditingSlotState();
      document.documentElement.classList.add('cf-color-modal-open');
      hydrateColorModalOptions(currentSelection, slotIndex);
    }

    function renderColorModalPreview(option) {
      if (!colorModalPreview) return;
      colorModalPreview.innerHTML = '';
      if (!option) return;
      var rendered = false;
      modalGalleryForOption(option).slice(0, 8).forEach(function(imageData) {
        if (appendModalPreviewFrame(imageData, option)) rendered = true;
      });
      if (rendered || !option.shopifyVariantId) return;
      var expectedSku = normalKey(option.sku);
      fetchVariantJson(option.shopifyVariantId).then(function(variantData) {
        if (!colorModalPreview || !colorModalPreview.isConnected) return;
        if (!activeColorModalDraft || normalKey(activeColorModalDraft.sku) !== expectedSku) return;
        var variantUrl = imageFromVariantData(variantData);
        if (!variantUrl) return;
        option.imageUrl = variantUrl;
        option.thumbUrl = variantUrl;
        appendModalPreviewFrame({
          url: variantUrl,
          thumbUrl: variantUrl,
          alt: optionLabel(option),
          kind: 'variant'
        }, option);
      });
    }

    function renderColorModal() {
      if (!colorModalSwatches || !colorModalSizes || activeColorModalSlot == null) return;
      if (!activeColorModalDraft) activeColorModalDraft = activeColorModalOptions[0] || null;
      colorModalSwatches.innerHTML = '';
      colorModalSizes.innerHTML = '';
      if (colorModalColorLabel) colorModalColorLabel.textContent = activeColorModalDraft ? optionLabel(activeColorModalDraft) : 'Choose a color.';
      if (colorModalSizeLabel) colorModalSizeLabel.textContent = optionSizeValue(activeColorModalDraft) || 'Choose a size.';
      renderColorModalPreview(activeColorModalDraft);

      var swatches = colorOptionsForModal();
      var swatchLimit = 9;
      var visibleSwatches = colorModalSwatchesExpanded ? swatches : swatches.slice(0, swatchLimit);
      visibleSwatches.forEach(function(option) {
        var button = document.createElement('button');
	        button.type = 'button';
        var swatchColorKey = modalColorKey(option);
        var swatchActive = swatchColorKey && swatchColorKey === (activeColorModalColorKey || modalColorKey(activeColorModalDraft));
        button.className = 'cf-bundle-product__modal-swatch' + (swatchActive ? ' is-active' : '');
        button.style.setProperty('--cf-swatch', optionSwatchColor(option));
        var swatchImage = cssUrlValue(optionSwatchImage(option));
        if (swatchImage) button.style.setProperty('--cf-swatch-image', swatchImage);
        button.dataset.cfVariantSku = option.sku || '';
        button.dataset.cfColor = swatchColorKey;
        button.setAttribute('aria-label', 'Choose ' + optionLabel(option));
        button.setAttribute('aria-pressed', swatchActive ? 'true' : 'false');
        var labelText = document.createElement('span');
        labelText.className = 'cf-bundle-product__modal-swatch-label';
        labelText.textContent = optionLabel(option);
        button.appendChild(labelText);
	        button.addEventListener('click', function(event) {
	          event.preventDefault();
	          event.stopPropagation();
	          selectColorModalColor(option);
	        });
	        colorModalSwatches.appendChild(button);
	      });

      if (swatches.length > swatchLimit && !colorModalSwatchesExpanded) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'cf-bundle-product__modal-more';
        more.textContent = 'More';
        more.setAttribute('aria-label', 'Show more colours');
        more.addEventListener('click', function() {
          colorModalSwatchesExpanded = true;
          renderColorModal();
        });
        colorModalSwatches.appendChild(more);
      }

      sizeOptionsForModal().forEach(function(item) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'cf-bundle-product__modal-size' + (sameOptionSize(activeColorModalDraft, item.label) ? ' is-active' : '');
        button.textContent = item.label;
	        button.disabled = !modalOptionIsPurchasable(item.option);
	        button.setAttribute('aria-pressed', sameOptionSize(activeColorModalDraft, item.label) ? 'true' : 'false');
	        button.addEventListener('click', function(event) {
	          event.preventDefault();
	          event.stopPropagation();
	          selectColorModalSize(item.option, item.label);
	        });
	        colorModalSizes.appendChild(button);
	      });

      if (colorModalApply) {
        var hasSize = Boolean(optionSizeValue(activeColorModalDraft));
        var canApply = Boolean(activeColorModalDraft && hasSize && modalOptionIsPurchasable(activeColorModalDraft));
        colorModalApply.disabled = !canApply;
        colorModalApply.textContent = hasSize ? (canApply ? 'Update Shirt' : 'Unavailable') : 'Select A Size';
      }
    }

    function applyColorModalDraft() {
      if (activeColorModalSlot == null || !activeColorModalDraft) return;
      var variantId = modalVariantId(activeColorModalDraft);
      if (!variantId || !modalOptionIsPurchasable(activeColorModalDraft)) return;
      var slotIndex = activeColorModalSlot;
      var draft = markSelectionSizeChosen(Object.assign({}, activeColorModalDraft, {
        shopifyVariantId: variantId,
        variantId: activeColorModalDraft.variantId || variantId
      }));
      chooseSlotOption(slotIndex, draft);
    }

    function scrollColorModalPreview(direction) {
      if (!colorModalPreview) return;
      colorModalPreview.scrollBy({
        left: direction * colorModalPreview.clientWidth * 0.78,
        behavior: 'smooth'
      });
    }

    function selectedQuantity() {
      if (singleModeActive()) return 1;
      return selections.length || currentQuantity || Number(config.quantity || fallback.quantity || 0) || 0;
    }

    function missingComponent() {
      if (singleModeActive()) {
        var variant = selectedSingleProductVariant();
        return !selectedSize || !variant || variant.available === false;
      }
      if (bundleAvailabilityPending()) return false;
      if (!hasComponentConfig) return true;
      if (selectedSize && selectedSize.available === false) return true;
      if (!selections.length) return true;
      return selections.some(function(selection) {
        return !selection || !selectionHasChosenSize(selection) || !selection.shopifyVariantId || !selectionIsPurchasable(selection);
      });
    }

    function selectedOptionSoldOut() {
      if (singleModeActive()) {
        if (!selectedSize) return false;
        var variant = selectedSingleProductVariant();
        return !variant || variant.available === false;
      }
      if (bundleAvailabilityPending()) return false;
      if (!hasComponentConfig || hasUnchosenShirtSizes()) return false;
      if (selectedSize && selectedSize.available === false) return true;
      return selections.some(function(selection) {
        return selection && selectionHasChosenSize(selection) && (!selection.shopifyVariantId || !selectionIsPurchasable(selection));
      });
    }

    function hasUnchosenShirtSizes() {
      if (singleModeActive()) return !selectedSize;
      return hasComponentConfig && (!selections.length || selections.some(function(selection) {
        return !selectionHasChosenSize(selection);
      }));
    }

    function selectedBundleSizeLabel() {
      var chosenSizes = selections
        .filter(selectionHasChosenSize)
        .map(optionSizeValue)
        .filter(Boolean);
      var uniqueSizes = chosenSizes.filter(function(size, index) {
        return chosenSizes.findIndex(function(candidate) {
          return normalSize(candidate) === normalSize(size);
        }) === index;
      });
      if (uniqueSizes.length === 1) return uniqueSizes[0];
      if (uniqueSizes.length > 1) return 'Mixed Sizes';
      return selectedSize ? selectedSize.size : '';
    }

    function selectedColorsText() {
      if (isMysteryBoxProduct) return currentProduct.title || 'Mystery Box';
      if (singleModeActive()) {
        var color = singleProductColorByKey(activeSingleColorKey());
        if (!color) return 'Choose a color.';
        return color.label;
      }
      if (!hasComponentConfig && selectedSize && fallback.colors) return fallback.colors;
      var names = selections.map(optionLabel).filter(Boolean);
      var unique = names.filter(function(name, index) { return names.indexOf(name) === index; });
      if (!unique.length) return 'Choose a size to see the pack.';
      if (unique.length <= 2) return unique.join(', ');
      return unique.slice(0, 2).join(', ') + ' +' + (unique.length - 2) + ' More';
    }

    function normaliseGalleryImage(imageData, fallbackAlt) {
      var url = usableImageUrl(imageData && (imageData.url || imageData.src || imageData.imageUrl));
      if (!url) return null;
      var thumbUrl = usableImageUrl(imageData && (imageData.thumbUrl || imageData.thumbnail || imageData.previewUrl)) || url;
      return {
        url: url,
        thumbUrl: thumbUrl,
        alt: imageData && imageData.alt || fallbackAlt || currentProduct.title || '',
        kind: imageData && imageData.kind || 'gallery'
      };
    }

    function dedupeGalleryImages(images) {
      var seen = {};
      var gallery = (Array.isArray(images) ? images : []).map(function(imageData) {
        return normaliseGalleryImage(imageData);
      }).filter(function(imageData) {
        if (!imageData) return false;
        var key = imageKey(imageData.url);
        if (key && seen[key]) return false;
        if (key) seen[key] = true;
        return true;
      });
      var modelImages = gallery.filter(function(imageData) {
        return imageAltLooksLifestyle(imageData.alt);
      });
      var remainingImages = gallery.filter(function(imageData) {
        return !imageAltLooksLifestyle(imageData.alt);
      });
      return modelImages.concat(remainingImages);
    }

    function readDefaultMainGallery() {
      var gallery = [];
      if (thumbsEl) {
        Array.prototype.forEach.call(thumbsEl.querySelectorAll('[data-cf-thumb]'), function(button) {
          var image = button.querySelector('img');
          var imageUrl = usableImageUrl(button.dataset.cfImage);
          if (!imageUrl) return;
          gallery.push({
            url: imageUrl,
            thumbUrl: usableImageUrl(image && (image.currentSrc || image.src)) || imageUrl,
            alt: image && image.alt || currentProduct.title || ''
          });
        });
      }
      if (!gallery.length && mainImage && mainImage.src) {
        gallery.push({
          url: mainImage.src,
          thumbUrl: mainImage.src,
          alt: mainImage.alt || currentProduct.title || ''
        });
      }
      return dedupeGalleryImages(gallery);
    }

    function setMainImage(src, altText) {
      if (!mainImage || !src) return;
      mainImage.src = src;
      if (altText) mainImage.alt = altText;
    }

    function bindGalleryThumb(button) {
      if (!button || button._cfGalleryBound) return;
      button._cfGalleryBound = true;
      button.addEventListener('click', function() {
        root.querySelectorAll('[data-cf-thumb]').forEach(function(item) {
          item.classList.toggle('is-active', item === button);
        });
        setMainImage(button.dataset.cfImage, button.dataset.cfAlt);
      });
    }

    function bindGalleryThumbs() {
      root.querySelectorAll('[data-cf-thumb]').forEach(bindGalleryThumb);
    }

    function renderMainGallery(galleryImages, mode) {
      var images = dedupeGalleryImages(galleryImages);
      if (!images.length) return;
      activeMainGalleryMode = mode || 'custom';
      if (thumbsEl) {
        thumbsEl.innerHTML = '';
        images.forEach(function(imageData, index) {
          var button = document.createElement('button');
          var image = document.createElement('img');
          button.className = 'cf-bundle-product__thumb' + (index === 0 ? ' is-active' : '');
          button.type = 'button';
          button.dataset.cfThumb = String(index);
          button.dataset.cfImage = imageData.url;
          button.dataset.cfAlt = imageData.alt || '';
          button.setAttribute('aria-label', 'View image ' + (index + 1));
          image.src = imageData.thumbUrl || imageData.url;
          image.alt = imageData.alt || currentProduct.title || '';
          image.loading = index === 0 ? 'eager' : 'lazy';
          button.appendChild(image);
          bindGalleryThumb(button);
          thumbsEl.appendChild(button);
        });
      }
      setMainImage(images[0].url, images[0].alt);
    }

    function singleProductFallbackGalleryForColor(color, variant) {
      var gallery = lifestyleGalleryFromImages(
        Array.isArray(fallback.images) ? fallback.images : [],
        { colorName: color && color.label },
        color && color.label
      );
      var seen = {};

      function addImage(imageData, kind) {
        var normalized = normaliseGalleryImage(imageData, color && color.label);
        if (!normalized) return;
        var key = imageKey(normalized.url);
        if (key && seen[key]) return;
        if (key) seen[key] = true;
        normalized.kind = kind || normalized.kind;
        gallery.push(normalized);
      }

      gallery.forEach(function(imageData) {
        var key = imageKey(imageData && imageData.url);
        if (key) seen[key] = true;
      });

      addImage({
        url: variant && (variant.imageUrl || variant.thumbUrl),
        thumbUrl: variant && (variant.thumbUrl || variant.imageUrl),
        alt: color && color.label,
        kind: 'variant'
      }, 'variant');

      return dedupeGalleryImages(gallery);
    }

    function galleryForSingleSelection() {
      if (isMysteryBoxProduct) {
        return dedupeGalleryImages(Array.isArray(fallback.images) ? fallback.images : []);
      }
      var color = singleProductColorByKey(activeSingleColorKey());
      var variant = selectedSingleProductVariant() || singleProductPreviewVariant() || color && color.option;
      var gallery = isSingleProduct
        ? singleProductFallbackGalleryForColor(color, variant)
        : lifestyleGalleryForComponentOption(variant || color && color.option);
      if (!gallery.length) {
        var imageUrl = singleImageForColor(color);
        if (imageUrl) gallery.push({
          url: imageUrl,
          thumbUrl: imageUrl,
          alt: color && color.label || currentProduct.title || '',
          kind: 'variant'
        });
      }
      return gallery;
    }

    function galleryForInlinePack() {
      var packGallery = dedupeGalleryImages(currentProduct && currentProduct.images);
      if (packGallery.length) return packGallery;

      var imageUrl = usableImageUrl(currentProduct && currentProduct.imageUrl);
      var gallery = imageUrl ? [{
        url: imageUrl,
        thumbUrl: imageUrl,
        alt: currentProduct.title || '',
        kind: 'pack'
      }] : [];
      defaultMainGallery.forEach(function(imageData) {
        gallery.push(imageData);
      });
      return gallery.length ? gallery : defaultMainGallery;
    }

    function syncMainGallery() {
      if (singleModeActive()) {
        renderMainGallery(galleryForSingleSelection(), 'single');
      } else if (isSingleProduct && inlineBundleActive) {
        renderMainGallery(galleryForInlinePack(), 'inline-pack');
      } else if (activeMainGalleryMode !== 'default') {
        renderMainGallery(defaultMainGallery, 'default');
      }
    }

    function uniquePackQuantityOptions() {
      var byQuantity = {};
      packOptions.forEach(function(option) {
        var quantity = option.quantity;
        if (!quantity || quantity <= 1) return;
        if (!byQuantity[quantity] || option.active || Number(byQuantity[quantity].active) < Number(option.active)) {
          byQuantity[quantity] = option;
        }
      });
      if (!byQuantity[currentQuantity] && currentQuantity > 1) {
        byQuantity[currentQuantity] = activePack || {
          quantity: currentQuantity,
          title: currentQuantity + '-Pack',
          url: currentProduct.url,
          active: true
        };
      }
      var quantityOptions = Object.keys(byQuantity)
        .map(function(key) {
          var quantity = Number(key);
          var matchingQuantityOptions = railPackOptions.filter(function(option) {
            return Number(option.quantity) === quantity;
          });
          if (!matchingQuantityOptions.length) {
            matchingQuantityOptions = packOptions.filter(function(option) {
              return Number(option.quantity) === quantity;
            });
          }
          var sortedQuantityOptions = sortRailPackOptions(matchingQuantityOptions);
          if (isSingleProduct && !inlineBundleActive) {
            var matchingSinglePack = sortedQuantityOptions.find(packOptionIncludesCurrentSingle);
            if (matchingSinglePack) return matchingSinglePack;
          }
          if (quantity === Number(currentQuantity)) return byQuantity[key];
          return sortedQuantityOptions[0] || byQuantity[key];
        });
      var hasQuantityPriority = quantityOptions.some(function(option) {
        return option && option.priority != null && Number.isFinite(Number(option.priority));
      });
      return quantityOptions.sort(function(first, second) {
        var quantityDifference = Number(second.quantity || 0) - Number(first.quantity || 0);
        if (quantityDifference !== 0) return quantityDifference;
        var merchandisingSort = comparePackMerchandising(first, second, hasQuantityPriority);
        if (merchandisingSort !== 0) return merchandisingSort;
        return packOptionSortLabel(first).localeCompare(packOptionSortLabel(second));
      });
    }

    function inlinePackKey(option) {
      if (!option) return '';
      return String(option.productId || cleanProductHandle(option.handle || option.url) || option.url || option.displayName || option.title || '') + ':' + packQuantity(option);
    }

    function packOptionIncludesCurrentSingle(option) {
      if (!isSingleProduct || !option) return false;
      var singleHandle = cleanProductHandle(baseSingleProductState && baseSingleProductState.currentProduct && baseSingleProductState.currentProduct.handle);
      var singleStems = {};
      singleProductVariants.forEach(function(variant) {
        var stem = componentFamilyKey(variant);
        if (stem) singleStems[stem] = true;
      });

      var sources = [option.componentSkus];
      var packConfig = option.config && typeof option.config === 'object' ? option.config : null;
      if (packConfig) {
        sources.push(packConfig.components, packConfig.componentQuantities);
        (Array.isArray(packConfig.sizes) ? packConfig.sizes : []).forEach(function(size) {
          sources.push(size && size.components, size && size.componentQuantities, size && size.slots, size && size.options);
        });
      }

      return normaliseComponentFallbacks(sources).some(function(component) {
        var componentHandle = cleanProductHandle(component && (component.productHandle || component.product_handle));
        if (singleHandle && componentHandle && singleHandle === componentHandle) return true;
        var componentStem = componentFamilyKey(component);
        return Boolean(componentStem && singleStems[componentStem]);
      });
    }

    function inlinePackOptionIsActive(option) {
      return Boolean(isSingleProduct && inlineBundleActive && inlinePackKey(option) && inlinePackKey(option) === inlinePackKey(activeInlinePackOption));
    }

    function inlinePackOptionByKey(key) {
      var targetKey = String(key || '');
      if (!targetKey) return null;
      return railPackOptions.concat(packOptions).find(function(option) {
        return inlinePackKey(option) === targetKey;
      }) || null;
    }

    function resetReviewRequests() {
      reviewsSummaryLoaded = false;
      reviewsLoaded = false;
      fetchReviewSummary(true);
      if (reviewsModal && !reviewsModal.hidden) fetchReviews(true);
    }

    function activateSingleProductMode() {
      if (!isSingleProduct) return;
      var sizeToKeep = selectedSizeForNavigation();
      inlineBundleActive = false;
      activeInlinePackOption = null;
      config = baseSingleProductState.config;
      currentProduct = Object.assign({}, baseSingleProductState.currentProduct);
      hasComponentConfig = baseSingleProductState.hasComponentConfig;
      sizes = baseSingleProductState.sizes.slice();
      currentQuantity = baseSingleProductState.currentQuantity;
      activePack = baseSingleProductState.activePack;
      componentDetailsByKey = buildComponentDetailsIndex(config);
      selectedSize = sizeOptionForValue(sizes, sizeToKeep) || sizes.find(function(size) { return size && size.available !== false; }) || sizes[0] || null;
      selections = [];
      singlesMode = true;
      customMode = false;
      packRailExpanded = false;
      refresh();
      resetReviewRequests();
    }

    function inlinePackProduct(option) {
      var handle = cleanProductHandle(option && (option.handle || option.url));
      return {
        id: option && option.productId || '',
        handle: handle,
        url: option && option.url || productPageUrl(handle),
        title: option && (option.displayName || option.title) || '',
        imageUrl: usableImageUrl(option && option.imageUrl),
        images: Array.isArray(option && option.images) ? option.images : []
      };
    }

    function ensurePackBundleData(option) {
      var packConfig = option && option.config && typeof option.config === 'object' ? option.config : null;
      if (packConfig && Array.isArray(packConfig.sizes) && packConfig.sizes.length) {
        return Promise.resolve(option);
      }
      if (!option) return Promise.resolve(null);
      if (!option._bundleDataPromise) {
        option._bundleDataLoading = true;
        option._bundleDataPromise = fetchPackBundleData(option).then(function(nextOption) {
          option._bundleDataLoading = false;
          var nextConfig = nextOption && nextOption.config && typeof nextOption.config === 'object'
            ? nextOption.config
            : null;
          return nextConfig && Array.isArray(nextConfig.sizes) && nextConfig.sizes.length
            ? nextOption
            : null;
        }).catch(function() {
          option._bundleDataLoading = false;
          return null;
        });
      }
      return option._bundleDataPromise;
    }

    var bundleSelectorLoadingCount = 0;
    var scheduledPackPrefetches = {};

    function setBundleSelectorLoading(loading) {
      bundleSelectorLoadingCount = Math.max(0, bundleSelectorLoadingCount + (loading ? 1 : -1));
      var isLoading = bundleSelectorLoadingCount > 0;
      if (bundleSelectorEl) {
        bundleSelectorEl.classList.toggle('is-loading', isLoading);
        bundleSelectorEl.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      }
      if (bundleSelectorLoadingEl) bundleSelectorLoadingEl.hidden = !isLoading;
    }

    function withBundleSelectorLoading(callback) {
      setBundleSelectorLoading(true);
      var result;
      try {
        result = callback();
      } catch (error) {
        setBundleSelectorLoading(false);
        return Promise.reject(error);
      }
      return Promise.resolve(result).then(function(value) {
        setBundleSelectorLoading(false);
        return value;
      }, function(error) {
        setBundleSelectorLoading(false);
        throw error;
      });
    }

    function schedulePackBundlePrefetch(option, delay) {
      if (!isSingleProduct || !option || option.config || option._bundleDataPromise) return;
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection && connection.saveData) return;
      var key = inlinePackKey(option);
      if (!key || scheduledPackPrefetches[key]) return;
      scheduledPackPrefetches[key] = true;
      var timeoutId = window.setTimeout(function() {
        ensurePackBundleData(option);
      }, Math.max(0, Number(delay) || 0));
      addCleanup(function() {
        window.clearTimeout(timeoutId);
      });
    }

    function prefetchLikelyPackOption() {
      if (!isSingleProduct) return;
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection && connection.saveData) return;
      var likelyOption = uniquePackQuantityOptions()[0];
      if (!likelyOption || likelyOption.config) return;

      var prefetch = function() {
        ensurePackBundleData(likelyOption);
      };
      if ('requestIdleCallback' in window) {
        var idleId = window.requestIdleCallback(prefetch, { timeout: 1800 });
        addCleanup(function() {
          window.cancelIdleCallback(idleId);
        });
      } else {
        var timeoutId = window.setTimeout(prefetch, 900);
        addCleanup(function() {
          window.clearTimeout(timeoutId);
        });
      }
    }

    function selectInlinePackOption(option) {
      if (!isSingleProduct) return Promise.resolve(false);
      var packConfig = option && option.config && typeof option.config === 'object' ? option.config : null;
      if (!packConfig || !Array.isArray(packConfig.sizes) || !packConfig.sizes.length) {
        if (statusEl) statusEl.textContent = 'Loading this pack.';
        return ensurePackBundleData(option).then(function(nextOption) {
          if (nextOption) return selectInlinePackOption(nextOption);
          if (statusEl) statusEl.textContent = 'Bundle item data has not been synced to Shopify yet.';
          return false;
        });
      }

      var sizeToKeep = selectedSizeForNavigation();
      inlineBundleActive = true;
      activeInlinePackOption = option;
      config = packConfig;
      prepareBundleConfig(config);
      currentProduct = inlinePackProduct(option);
      hasComponentConfig = Array.isArray(config.sizes) && config.sizes.length > 0;
      sizes = sortSizesByFitOrder(hasComponentConfig ? config.sizes : []);
      bundleSizeAvailabilityReady = !hasComponentConfig;
      bundleSizeAvailabilityHydrating = false;
      recalculateBundleSizeAvailability();
      currentQuantity = Number(config.quantity || option.quantity || 0) || 0;
      activePack = option;
      selectedSize = sizeOptionForValue(sizes, sizeToKeep);
      var preview = selectedSize || sizes.find(function(size) { return size && size.available !== false; }) || sizes[0] || null;
      selections = hasComponentConfig && preview
        ? (selectedSize ? remapSelectionsForSize(preview, []).map(markSelectionSizeChosen) : defaultSelections(preview))
        : [];
      singlesMode = false;
      customMode = false;
      packRailExpanded = false;
      refresh();
      hydrateBundleSizeAvailability();
      resetReviewRequests();
      return Promise.resolve(true);
    }

    function setSinglesMode(enabled) {
      var nextMode = Boolean(enabled);
      if (isSingleProduct) {
        if (nextMode) activateSingleProductMode();
        return;
      }
      if (singlesMode === nextMode) return;
      var sizeToKeep = selectedSizeForNavigation();
      singlesMode = nextMode;
      packRailExpanded = false;
      if (singlesMode) {
        refreshBundleSingleOptions();
        selectBundleSingleThumbnailColor();
        hydrateBundleSingles();
        selectedSize = sizeOptionForValue(activeSingleSizeOptions(), sizeToKeep);
        customMode = false;
      } else {
        selectedSize = sizeOptionForValue(sizes, sizeToKeep);
        if (selectedSize && hasComponentConfig) {
          selections = remapSelectionsForSize(selectedSize, selections).map(markSelectionSizeChosen);
        }
        ensurePreviewSelections();
      }
      refresh();
    }

    function setMobileColumnsForCount(element, optionCount) {
      if (!element) return;
      element.setAttribute('data-cf-option-count', String(optionCount));
      element.setAttribute(
        'data-cf-mobile-columns',
        optionCount === 3 || optionCount > 4 ? '3' : '2'
      );
    }

    function renderSinglesPackOption() {
      if (!packOptionsEl || (!isSingleProduct && !hasComponentConfig)) return;
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'cf-bundle-product__bundle-card' + (singleModeActive() ? ' is-active' : '');
      card.setAttribute('role', 'listitem');
      card.setAttribute('data-cf-pack-singles', '');
      card.setAttribute('aria-pressed', singleModeActive() ? 'true' : 'false');

      var title = document.createElement('strong');
      title.textContent = 'Single';
      card.appendChild(title);

      var meta = document.createElement('em');
      if (isSingleProduct) {
        var colourCount = singleProductColors.length;
        meta.textContent = colourCount + ' ' + (colourCount === 1 ? 'colour' : 'colours');
      } else {
        var componentCount = bundleSingleComponents.length;
        meta.textContent = componentCount
          ? componentCount + ' ' + (componentCount === 1 ? 'shirt' : 'shirts')
          : 'Choose one';
      }
      card.appendChild(meta);

      card.addEventListener('click', function() {
        if (isSingleProduct) {
          activateSingleProductMode();
        } else {
          setSinglesMode(true);
        }
      });
      packOptionsEl.appendChild(card);
    }

    function renderPackOptions() {
      if (!packOptionsEl) return;
      packOptionsEl.innerHTML = '';
      var quantitySection = packOptionsEl.closest('.cf-bundle-product__quantity');
      if (quantitySection) quantitySection.hidden = isMysteryBoxProduct;
      if (isMysteryBoxProduct) return;
      uniquePackQuantityOptions().forEach(function(option, index) {
        var isCurrentQuantity = Number(option.quantity) === Number(currentQuantity);
        var isInlineActive = isSingleProduct && inlineBundleActive && isCurrentQuantity;
        var isActive = isSingleProduct ? isInlineActive : (!singlesMode && isCurrentQuantity);
        var switchesBackToBundle = !isSingleProduct && singlesMode && isCurrentQuantity;
        var tagText = index === 0 ? 'BEST DEAL' : '';
        var useButton = isSingleProduct || isActive || switchesBackToBundle;
        var card = document.createElement(useButton ? 'button' : 'a');
        card.className = 'cf-bundle-product__bundle-card' + (isActive ? ' is-active' : '') + (tagText ? ' is-best-deal' : '');
        card.setAttribute('role', 'listitem');
        card.setAttribute('data-cf-pack-option', '');
        card.setAttribute('data-cf-pack-quantity', String(option.quantity));
        if (useButton) {
          card.type = 'button';
          card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          if (isSingleProduct) {
            card.addEventListener('pointerenter', function() {
              ensurePackBundleData(option);
            }, { once: true });
            card.addEventListener('focus', function() {
              ensurePackBundleData(option);
            }, { once: true });
            card.addEventListener('click', function() {
              withBundleSelectorLoading(function() {
                return selectInlinePackOption(option);
              });
            });
          } else if (switchesBackToBundle) {
            card.addEventListener('click', function() {
              setSinglesMode(false);
            });
          }
        } else {
          card.href = bundleUrlWithSelectedSize(option.url || '#') || '#';
        }

        if (tagText) {
          var tag = document.createElement('span');
          tag.textContent = tagText;
          card.appendChild(tag);
        }

        var title = document.createElement('strong');
        title.textContent = packTitle(option);
        card.appendChild(title);

        var saving = document.createElement('em');
        saving.setAttribute('data-cf-pack-save', '');
        saving.hidden = true;
        card.appendChild(saving);

        packOptionsEl.appendChild(card);
      });
      renderSinglesPackOption();
      var optionCount = packOptionsEl.querySelectorAll('[data-cf-pack-option], [data-cf-pack-singles]').length;
      setMobileColumnsForCount(packOptionsEl, optionCount);
    }

    function packActionLabel(option) {
      if (!option || isCurrentPackOption(option)) return 'Customise';
      return 'Customise';
    }

    function appendPackImage(card, imageUrl, altText) {
      var imageWrap = document.createElement('span');
      imageWrap.className = 'cf-bundle-product__pack-image';
      var cleanImageUrl = usableImageUrl(imageUrl);
      if (cleanImageUrl) {
        var image = document.createElement('img');
        image.src = cleanImageUrl;
        image.alt = altText || '';
        image.loading = 'lazy';
        imageWrap.appendChild(image);
      }
      card.appendChild(imageWrap);
      return imageWrap;
    }

    function productImageFromProductData(productData) {
      if (!productData) return '';
      var featured = usableImageUrl(productData.featured_image);
      if (featured) return featured;
      var images = Array.isArray(productData.images) ? productData.images : [];
      for (var index = 0; index < images.length; index += 1) {
        var image = images[index];
        var imageUrl = usableImageUrl(typeof image === 'string' ? image : image && (image.url || image.src || image.thumbUrl));
        if (imageUrl) return imageUrl;
      }
      return '';
    }

    function hydratePackImage(option, imageWrap, altText) {
      if (!option || !imageWrap || imageWrap.querySelector('img')) return;
      var handle = cleanProductHandle(option.handle || option.url);
      if (!handle) return;
      fetchProductJson(handle).then(function(productData) {
        if (!imageWrap.isConnected || imageWrap.querySelector('img')) return;
        var imageUrl = productImageFromProductData(productData);
        if (!imageUrl) return;
        option.imageUrl = imageUrl;
        var image = document.createElement('img');
        image.src = imageUrl;
        image.alt = altText || packTitle(option);
        image.loading = 'lazy';
        imageWrap.appendChild(image);
      });
    }

    function createPackRailCard(option, isCustomPack, isTopSeller) {
      var isInlinePack = isSingleProduct && inlineBundleActive && !isCustomPack;
      var isActive = !isCustomPack && (isInlinePack ? inlinePackOptionIsActive(option) : isCurrentPackOption(option));
      var card = document.createElement('div');
      var select = document.createElement(isActive || isCustomPack || isInlinePack ? 'button' : 'a');
      card.className = 'cf-bundle-product__pack-card' + (isActive ? ' is-active' : '');
      card.setAttribute('role', 'listitem');
      select.className = 'cf-bundle-product__pack-select';
      if (isActive || isCustomPack || isInlinePack) {
        select.type = 'button';
        select.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isInlinePack && !isActive) {
          select.addEventListener('pointerenter', function() {
            ensurePackBundleData(option);
          }, { once: true });
          select.addEventListener('focus', function() {
            ensurePackBundleData(option);
          }, { once: true });
          select.addEventListener('click', function() {
            withBundleSelectorLoading(function() {
              return selectInlinePackOption(option);
            });
          });
        }
      } else {
        select.href = bundleUrlWithSelectedSize(option.url || '#') || '#';
      }
      select.setAttribute('aria-label', isCustomPack ? 'Select custom pack' : 'Select ' + packTitle(option));

      if (!isCustomPack && isTopSeller) {
        var badge = document.createElement('span');
        badge.className = 'cf-bundle-product__pack-badge';
        badge.innerHTML = '<span aria-hidden="true">&#128293;</span><span>Best Seller</span>';
        card.appendChild(badge);
      }

      var imageUrl = isActive ? currentProduct.imageUrl : (isCustomPack ? '' : option.imageUrl);
      var imageWrap = appendPackImage(select, imageUrl, isCustomPack ? 'Custom Pack' : packTitle(option));
      if (!isActive && !isCustomPack) hydratePackImage(option, imageWrap, packTitle(option));
      card.appendChild(select);

      var action = document.createElement('button');
      action.type = 'button';
      action.className = 'cf-bundle-product__pack-action';
      action.setAttribute('data-cf-customize-pack', '');
      action.setAttribute('data-cf-pack-url', bundleUrlWithSelectedSize(option && option.url ? option.url : currentProduct.url) || currentProduct.url);
      if (isInlinePack) action.setAttribute('data-cf-inline-pack-key', inlinePackKey(option));
      action.textContent = isCustomPack ? 'Custom Pack' : packActionLabel(option);
      card.appendChild(action);
      return card;
    }

    function createSingleVariantRailCard(color) {
      var isActive = color && color.key === activeSingleColorKey();
      var card = document.createElement('div');
      var select = document.createElement('button');
      var imageUrl = singleImageForColor(color);
      var label = color && color.label ? color.label : 'Colour';
      card.className = 'cf-bundle-product__pack-card cf-bundle-product__single-colour-card' + (isActive ? ' is-active' : '');
      card.setAttribute('role', 'listitem');
      select.type = 'button';
      select.className = 'cf-bundle-product__pack-select';
      select.setAttribute('aria-label', 'Select ' + label);
      select.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      appendPackImage(select, imageUrl, label);
      select.addEventListener('click', function() {
        setActiveSingleColorKey(color.key);
        refresh();
      });
      card.appendChild(select);
      return card;
    }

    function createSingleComponentRailCard(component) {
      var isActive = component && component.key === selectedBundleSingleComponentKey;
      var card = document.createElement('div');
      var select = document.createElement('button');
      var label = component && component.title ? component.title : 'Shirt';
      var shortLabel = label.split(/\s+-\s+/)[0] || label;
      card.className = 'cf-bundle-product__pack-card cf-bundle-product__single-shirt-card' + (isActive ? ' is-active' : '');
      card.setAttribute('role', 'listitem');
      select.type = 'button';
      select.className = 'cf-bundle-product__pack-select';
      select.setAttribute('aria-label', 'Select ' + label);
      select.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      appendPackImage(select, component && component.imageUrl, label);
      select.addEventListener('click', function() {
        selectBundleSingleComponent(component && component.key);
      });
      card.appendChild(select);

      var action = document.createElement('span');
      action.className = 'cf-bundle-product__pack-action cf-bundle-product__pack-action--static';
      action.textContent = shortLabel;
      action.title = label;
      card.appendChild(action);
      return card;
    }

    function appendSinglePickerGroup(labelText, cards, modifierClass) {
      var group = document.createElement('section');
      var heading = document.createElement('p');
      var options = document.createElement('div');
      group.className = 'cf-bundle-product__single-picker-group' + (modifierClass ? ' ' + modifierClass : '');
      heading.className = 'cf-bundle-product__single-picker-label';
      heading.textContent = labelText;
      options.className = 'cf-bundle-product__single-picker-options';
      options.setAttribute('role', 'list');
      cards.forEach(function(card) {
        options.appendChild(card);
      });
      setMobileColumnsForCount(options, cards.length);
      group.appendChild(heading);
      group.appendChild(options);
      packRailEl.appendChild(group);
    }

    function mysteryBoxOptions() {
      var seen = {};
      return (Array.isArray(fallback.mysteryBoxes) ? fallback.mysteryBoxes : []).filter(function(option) {
        if (!option) return false;
        var key = String(option.productId || cleanProductHandle(option.handle || option.url) || option.url || '');
        if (!key || seen[key]) return false;
        seen[key] = true;
        return true;
      });
    }

    function mysteryBoxIsActive(option) {
      if (!option) return false;
      if (String(option.productId || '') && String(option.productId) === String(currentProduct.id || '')) return true;
      return cleanProductHandle(option.handle || option.url) === cleanProductHandle(currentProduct.handle || currentProduct.url);
    }

    function createMysteryBoxRailCard(option) {
      var isActive = mysteryBoxIsActive(option);
      var card = document.createElement('div');
      var select = document.createElement(isActive ? 'button' : 'a');
      var label = String(option && option.title || 'Mystery Box');
      card.className = 'cf-bundle-product__pack-card cf-bundle-product__mystery-card' + (isActive ? ' is-active' : '') + (option && option.available === false ? ' is-disabled' : '');
      card.setAttribute('role', 'listitem');
      select.className = 'cf-bundle-product__pack-select';
      select.setAttribute('aria-label', (isActive ? 'Selected ' : 'Choose ') + label);
      if (isActive) {
        select.type = 'button';
        select.setAttribute('aria-pressed', 'true');
      } else {
        select.href = bundleUrlWithSelectedSize(option.url || productPageUrl(option.handle)) || '#';
      }
      appendPackImage(select, option && option.imageUrl, label);
      card.appendChild(select);

      var action = document.createElement('span');
      action.className = 'cf-bundle-product__pack-action cf-bundle-product__pack-action--static';
      action.textContent = label;
      action.title = label;
      card.appendChild(action);
      return card;
    }

    function renderRail() {
      if (!packRailEl) return;
      packRailEl.innerHTML = '';
      packRailEl.classList.toggle('is-expanded', packRailExpanded);
      packRailEl.classList.toggle('is-single-mode', singleModeActive());
      packRailEl.classList.toggle('is-bundle-single-mode', singleModeActive() && !isSingleProduct);

      if (isMysteryBoxProduct) {
        var mysteryCards = mysteryBoxOptions().map(createMysteryBoxRailCard);
        packRailEl.classList.add('is-expanded');
        packRailEl.classList.remove('has-more');
        packRailEl.classList.add('is-mystery-box-mode');
        setMobileColumnsForCount(packRailEl, mysteryCards.length);
        mysteryCards.forEach(function(card) {
          packRailEl.appendChild(card);
        });
        return;
      }
      packRailEl.classList.remove('is-mystery-box-mode');

      if (singleModeActive()) {
        if (!isSingleProduct) refreshBundleSingleOptions();
        var colors = activeSingleColors().filter(function(color) {
          return color && color.available !== false;
        });
        if (colors.length && !colors.some(function(color) { return color.key === activeSingleColorKey(); })) {
          setActiveSingleColorKey(colors[0].key);
        }
        var colorCards = colors.map(createSingleVariantRailCard);
        packRailEl.classList.add('is-expanded');
        packRailEl.classList.remove('has-more');
        if (!isSingleProduct) {
          appendSinglePickerGroup(
            'Choose a shirt',
            bundleSingleComponents.map(createSingleComponentRailCard),
            'cf-bundle-product__single-picker-group--shirts'
          );
          appendSinglePickerGroup(
            'Colour: ' + ((singleProductColorByKey(activeSingleColorKey()) || {}).label || 'Choose a colour'),
            colorCards,
            'cf-bundle-product__single-picker-group--colours'
          );
        } else {
          setMobileColumnsForCount(packRailEl, colorCards.length);
          colorCards.forEach(function(card) {
            packRailEl.appendChild(card);
          });
        }
        return;
      }

      var sameQuantityOptions = sortRailPackOptions(railPackOptions
        .filter(function(option) { return Number(option.quantity) === Number(currentQuantity); }));
      var activeOption = sameQuantityOptions.find(isCurrentPackOption) || activePack || {
        quantity: currentQuantity,
        title: currentQuantity === 1 ? 'Singles' : currentQuantity + '-Pack',
        url: currentProduct.url,
        imageUrl: currentProduct.imageUrl,
        active: true
      };
      if (!sameQuantityOptions.length && activeOption) {
        sameQuantityOptions = [activeOption];
      } else if (activeOption && !sameQuantityOptions.some(isCurrentPackOption)) {
        sameQuantityOptions = sortRailPackOptions(sameQuantityOptions.concat(activeOption));
      }
      var railCards = sameQuantityOptions.map(function(option, index) {
        return createPackRailCard(option, false, index === 0);
      });
      setMobileColumnsForCount(packRailEl, railCards.length);

      var collapsedLimit = 4;
      var needsMore = railCards.length > collapsedLimit;
      if (isSingleProduct && inlineBundleActive) {
        sameQuantityOptions
          .filter(function(option) { return !inlinePackOptionIsActive(option); })
          .slice(0, collapsedLimit)
          .forEach(function(option, index) {
            schedulePackBundlePrefetch(option, 350 + (index * 250));
          });
      }
      packRailEl.classList.toggle('has-more', needsMore);
      (packRailExpanded ? railCards : railCards.slice(0, collapsedLimit)).forEach(function(card) {
        packRailEl.appendChild(card);
      });

      if (needsMore) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'cf-bundle-product__pack-more';
        more.textContent = packRailExpanded ? '-' : '+';
        more.setAttribute('aria-label', packRailExpanded ? 'Show fewer packs' : 'Show more packs');
        more.setAttribute('aria-expanded', packRailExpanded ? 'true' : 'false');
        more.addEventListener('click', function() {
          packRailExpanded = !packRailExpanded;
          renderRail();
        });
        packRailEl.appendChild(more);
      }
    }

    function renderSizes() {
      if (!sizeOptions) return;
      sizeOptions.innerHTML = '';
      var sizeList = singleModeActive() ? activeSingleSizeOptions() : sizes;
      sizeList.forEach(function(size) {
        var button = document.createElement('button');
        var matchingSingleVariant = singleModeActive() ? singleVariantForColorAndSize(activeSingleColorKey(), size && size.size) : null;
        var isSelectedSize = selectedSize && normalSize(selectedSize.size) === normalSize(size && size.size);
        var isUnavailable = singleModeActive() ? (!matchingSingleVariant || matchingSingleVariant.available === false) : (!bundleAvailabilityPending() && size.available === false);
        button.type = 'button';
        button.className = 'cf-bundle-product__size';
        button.textContent = size.size;
        button.disabled = isUnavailable;
        button.setAttribute('aria-pressed', isSelectedSize ? 'true' : 'false');
        if (isSelectedSize) button.classList.add('is-active');
        if (isUnavailable) button.classList.add('is-unavailable');
        button.addEventListener('click', function() {
          selectedSize = size;
          if (!singleModeActive()) {
            selections = remapSelectionsForSize(size, selections).map(markSelectionSizeChosen);
          }
          refresh();
        });
        sizeOptions.appendChild(button);
      });
    }

    function renderCustomizeAvailability() {
      root.querySelectorAll('[data-cf-customize-pack]').forEach(function(button) {
        var disabled = !hasComponentConfig;
        button.classList.toggle('is-disabled', disabled);
        button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      });
    }

    function renderCustomizer() {
      var customizerSize = ensurePreviewSelections();
      if (!slotsEl || !customizerSize) return;
      slotsEl.innerHTML = '';
      if (!hasComponentConfig) return;
      selections.forEach(function(selection, index) {
        var options = slotOptions(customizerSize, selection);
        if (!options.length && selection) options = [selection];
        if (selection && selection.sku && !options.some(function(option) { return option.sku === selection.sku; })) {
          options.unshift(selection);
        }
        var row = document.createElement('button');
        var imageWrap = document.createElement('span');
        var image = document.createElement('img');
        var meta = document.createElement('span');
        var title = document.createElement('strong');
        var sizeText = document.createElement('span');
        var editMark = document.createElement('span');
        var selectedImageUrl = slotImageUrl(selection, options);
        var chosenSize = selectionHasChosenSize(selection) ? optionSizeValue(selection) : '';

        row.type = 'button';
        row.className = 'cf-bundle-product__slot';
        row.setAttribute('data-cf-bundle-slot', String(index));
        row.setAttribute('aria-label', 'Customise item ' + (index + 1) + ': ' + optionLabel(selection));
        imageWrap.className = 'cf-bundle-product__slot-image';
        image.alt = optionLabel(selection);
        image.loading = 'lazy';
        applySlotImage(selection, image, imageWrap, selectedImageUrl);
        imageWrap.appendChild(image);
        hydrateSelectionImage(selection, image, imageWrap);
        meta.className = 'cf-bundle-product__slot-meta';
        title.textContent = selection.colorName || optionLabel(selection);
        if (chosenSize) {
          sizeText.className = 'cf-bundle-product__slot-size';
          sizeText.textContent = chosenSize;
        }
        editMark.className = 'cf-bundle-product__slot-edit';
        editMark.setAttribute('aria-hidden', 'true');
        editMark.innerHTML = '&#9998;';

        row.addEventListener('click', function(event) {
          event.preventDefault();
          openColorModal(index, options);
        });
        row.addEventListener('keydown', function(event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          openColorModal(index, options);
        });

        row.appendChild(imageWrap);
        meta.appendChild(title);
        if (chosenSize) meta.appendChild(sizeText);
        row.appendChild(meta);
        row.appendChild(editMark);
        slotsEl.appendChild(row);
      });
      syncEditingSlotState();
    }

    function selectedComponentDetails() {
      for (var index = 0; index < selections.length; index += 1) {
        var details = detailsForEntry(selections[index]);
        if (details) return details;
      }
      if (Array.isArray(config.componentDetails) && config.componentDetails.length) {
        return config.componentDetails[0];
      }
      return null;
    }

    function renderProductDetailsObject(details) {
      if (!productDetailsEl) return;
      var titleText = details.title || details.baseTitle || details.productTitle;
      if (titleText) {
        var title = document.createElement('strong');
        title.className = 'cf-bundle-product__details-title';
        title.textContent = titleText;
        productDetailsEl.appendChild(title);
      }

      var description = details.descriptionHtml || details.shortDescription;
      if (description) {
        var descriptionWrap = document.createElement('div');
        descriptionWrap.innerHTML = description;
        productDetailsEl.appendChild(descriptionWrap);
      }

      if (Array.isArray(details.features) && details.features.length) {
        var list = document.createElement('ul');
        list.className = 'cf-bundle-product__details-list';
        details.features.forEach(function(feature) {
          if (!feature) return;
          var item = document.createElement('li');
          item.textContent = feature;
          list.appendChild(item);
        });
        productDetailsEl.appendChild(list);
      }

      var meta = document.createElement('div');
      meta.className = 'cf-bundle-product__details-meta';
      [
        details.fabricComposition ? ['Fabric', details.fabricComposition] : null,
        details.fit ? ['Fit', details.fit] : null,
        details.care ? ['Care', details.care] : null
      ].forEach(function(row) {
        if (!row) return;
        var line = document.createElement('span');
        line.textContent = row[0] + ': ' + row[1];
        meta.appendChild(line);
      });
      if (meta.childNodes.length) productDetailsEl.appendChild(meta);
    }

    function renderProductDetails() {
      if (!productDetailsEl) return;
      productDetailsEl.innerHTML = '';
      if (themeProductDetails) {
        renderProductDetailsObject(themeProductDetails);
        return;
      }
      if (singleModeActive()) {
        var fallbackDetails = normaliseProductDetails({
          title: fallback.title || currentProduct.title,
          descriptionHtml: fallback.descriptionHtml
        });
        if (fallbackDetails) {
          renderProductDetailsObject(fallbackDetails);
        } else {
          productDetailsEl.textContent = 'Product details are coming soon.';
        }
        return;
      }
      var details = normaliseProductDetails(selectedComponentDetails());
      if (!details) {
        productDetailsEl.textContent = selectedSize
          ? 'Product details will appear once this bundle has component data.'
          : 'Choose a size to view product details.';
        return;
      }
      renderProductDetailsObject(details);
    }

    function refresh(shouldRenderCustomizer) {
      recalculateBundleSizeAvailability();
      renderSizes();
      renderRail();
      renderPackOptions();
      renderCustomizeAvailability();
      if (shouldRenderCustomizer !== false) renderCustomizer();
      renderProductDetails();

      var needsShirtSizes = hasUnchosenShirtSizes();
      var availabilityPending = bundleAvailabilityPending();
      if (sizeLabel) sizeLabel.textContent = selectedSize
        ? selectedSize.size
        : (!needsShirtSizes && selectedBundleSizeLabel() ? selectedBundleSizeLabel() : 'Choose a size.');
      if (quantityEl) quantityEl.textContent = singleModeActive() ? 'Single' : (selectedQuantity() || config.quantity || 0);
      if (colorSummaryLabel) colorSummaryLabel.textContent = isMysteryBoxProduct
        ? 'Mystery Box:'
        : singleModeActive() ? 'Colour:' : 'Colours:';
      if (colorSummary) colorSummary.textContent = selectedColorsText();
      if (customizerCount) {
        var expectedQuantity = currentQuantity || Number(config.quantity || fallback.quantity || selectedQuantity() || 0) || 0;
        customizerCount.textContent = selections.length + ' / ' + expectedQuantity;
      }
      if (customizer) customizer.hidden = !(customMode && hasComponentConfig && !singleModeActive());
      updatePriceDisplay();
      updateStackSaveWidget();
      syncMainGallery();

      if (addButton) {
        var incomplete = missingComponent() || availabilityPending;
        var soldOut = availabilityPending ? false : selectedOptionSoldOut();
        addButton.disabled = incomplete;
        if (singleModeActive()) {
          addButton.textContent = !selectedSize
            ? 'Select A Size'
            : soldOut
              ? 'Sold Out'
              : incomplete
                ? 'Unavailable'
                : 'Add To Cart';
        } else {
	          addButton.textContent = needsShirtSizes
	            ? 'Choose Shirt Sizes'
              : availabilityPending
                ? 'Add To Cart'
	            : incomplete
	              ? soldOut ? 'Sold Out' : hasComponentConfig ? 'Pack Unavailable' : 'Bundle Sync Needed'
	              : 'Add To Cart';
        }
      }

      if (statusEl) {
        if (singleModeActive()) {
          statusEl.textContent = !selectedSize
            ? ''
            : selectedOptionSoldOut()
              ? ''
              : missingComponent()
                ? isMysteryBoxProduct
                  ? 'This mystery box is unavailable in the selected size.'
                  : 'This shirt is unavailable in the selected colour and size.'
                : '';
        } else {
          statusEl.textContent = needsShirtSizes
            ? 'Choose shirt sizes to add this pack.'
            : availabilityPending
              ? ''
            : !hasComponentConfig
              ? 'Bundle item data has not been synced to Shopify yet.'
            : selectedOptionSoldOut()
              ? ''
              : missingComponent()
                ? 'This pack is unavailable in the selected size.'
              : '';
        }
      }
    }

    function renderSideCartFallback(cart) {
      document.body.classList.add('cart-sidebar-show');

      if (window.halo && typeof window.halo.openSidebarCart === 'function') {
        window.halo.openSidebarCart(cart);
        return;
      }

      if (window.halo && typeof window.halo.updateSidebarCart === 'function') {
        window.halo.updateSidebarCart(cart || {});
        return;
      }

      var wrapper = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
      if (!wrapper || !window.fetch) return;

      var rootPath = (window.routes && window.routes.root)
        || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
      rootPath = String(rootPath || '').replace(/\/$/, '');

      fetch(rootPath + '/cart?view=ajax_side_cart', { headers: { 'Accept': 'text/html' }})
        .then(function(response) { return response.ok ? response.text() : ''; })
        .then(function(html) {
          if (html) wrapper.innerHTML = html;
        })
        .catch(function() {});
    }

    function updateCartUi(cart) {
      syncCartState(cart, false);
      renderSideCartFallback(cart);
    }

    function cartJsonUrl() {
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        || (window.routes && window.routes.root)
        || '/';
      rootPath = String(rootPath || '/');
      if (rootPath.charAt(rootPath.length - 1) !== '/') rootPath += '/';
      return rootPath + 'cart.js';
    }

    function syncCartState(cart, shouldRefresh) {
      if (!isCartLike(cart)) return false;
      var itemCount = Number(cart.item_count);
      activeCartItemCount = cartItemCount(cart);
      if (!Number.isFinite(itemCount)) itemCount = activeCartItemCount;
      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = itemCount > 0 ? itemCount : '';
        var bubble = el.closest('.cart-count-bubble');
        if (bubble) {
          bubble.classList.toggle('cart-count-bubble--empty', itemCount === 0);
          bubble.hidden = itemCount === 0;
          bubble.setAttribute('aria-hidden', itemCount === 0 ? 'true' : 'false');
        }
      });
      if (shouldRefresh !== false) refresh(false);
      return true;
    }

    var cartSyncTimer = null;
    var cartSyncRequestId = 0;

    function fetchAndSyncCartState() {
      if (!window.fetch) return;
      var requestId = ++cartSyncRequestId;
      fetch(cartJsonUrl(), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function(response) {
          if (!response.ok) throw new Error('Could not refresh cart.');
          return response.json();
        })
        .then(function(cart) {
          if (requestId === cartSyncRequestId) syncCartState(cart);
        })
        .catch(function() {});
    }

    function scheduleCartStateSync(delay) {
      if (cartSyncTimer) window.clearTimeout(cartSyncTimer);
      cartSyncTimer = window.setTimeout(function() {
        cartSyncTimer = null;
        fetchAndSyncCartState();
      }, delay == null ? 900 : delay);
    }

    function handleExternalCartUpdate(event) {
      var cart = cartFromEventDetail(event && event.detail);
      if (cart) {
        syncCartState(cart);
        return;
      }
      scheduleCartStateSync(150);
    }

    function handleCartDrawerInteraction(event) {
      var target = event && event.target;
      if (!target || !target.closest) return;
      if (!target.closest('#halo-cart-sidebar [data-cart-quantity], #halo-cart-sidebar [data-cart-remove], #halo-cart-sidebar .btn-quantity')) return;
      scheduleCartStateSync(1200);
    }

    function bundleNavigationUrl(value) {
      var url = String(value || '').trim();
      if (!url || url === '#') return '';
      try {
        var parsed = new URL(url, window.location.href);
        if (parsed.origin !== window.location.origin) return '';
        if (!/\/products\//.test(parsed.pathname)) return '';
        return parsed.pathname + parsed.search + parsed.hash;
      } catch (error) {
        return '';
      }
    }

    function selectedSizeForNavigation() {
      return selectedSize && selectedSize.size ? String(selectedSize.size).trim() : '';
    }

    function bundleUrlWithSelectedSize(value, sizeValue) {
      var cleanUrl = bundleNavigationUrl(value);
      if (!cleanUrl) return '';
      var selectedSizeValue = sizeValue != null ? String(sizeValue || '').trim() : selectedSizeForNavigation();
      try {
        var parsed = new URL(cleanUrl, window.location.origin);
        if (selectedSizeValue) {
          parsed.searchParams.set('cf_size', selectedSizeValue);
        } else {
          parsed.searchParams.delete('cf_size');
        }
        return parsed.pathname + parsed.search + parsed.hash;
      } catch (error) {
        return cleanUrl;
      }
    }

    function bundleNavigationLink(target) {
      return target && target.closest
        ? target.closest('a.cf-bundle-product__bundle-card, a.cf-bundle-product__pack-select')
        : null;
    }

    function plainNavigationClick(event) {
      return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
    }

	    function applyFetchedBundlePage(html, url, options) {
      if (!html || typeof DOMParser === 'undefined') {
        window.location.href = url;
        return;
      }

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nextRoot = doc.querySelector('[data-cf-bundle-product]');
      if (!nextRoot) {
        window.location.href = url;
        return;
      }
      if (options && options.customise) {
        nextRoot.setAttribute('data-cf-open-customizer-on-load', 'true');
      }
      if (options && options.expandRail) {
        nextRoot.setAttribute('data-cf-pack-rail-expanded-on-load', 'true');
      }
      if (options && options.selectedSize) {
        nextRoot.setAttribute('data-cf-selected-size-on-load', options.selectedSize);
      }
      cleanupBundleProduct();
	      root.parentNode.replaceChild(nextRoot, root);
	      if (doc.title) document.title = doc.title;
      if ((!options || !options.replace) && window.history && window.history.pushState) {
        window.history.pushState({ classicFitBundleUrl: url }, '', url);
      }
      initBundleProduct(nextRoot);
    }

    function softNavigateBundle(url, options) {
      options = options || {};
      if (!Object.prototype.hasOwnProperty.call(options, 'selectedSize')) options.selectedSize = selectedSizeForNavigation();
      var cleanUrl = bundleUrlWithSelectedSize(url, options.selectedSize);
      if (navigatingBundle) return;
      if (!cleanUrl || !window.fetch || typeof DOMParser === 'undefined') {
        window.location.href = cleanUrl || url;
        return;
      }

	      navigatingBundle = true;
      fetch(cleanUrl, {
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Could not load this pack.');
          return response.text();
        })
        .then(function(html) {
          applyFetchedBundlePage(html, cleanUrl, options || {});
        })
        .catch(function() {
          window.location.href = cleanUrl;
        });
    }

    function handleBundlePopState() {
      softNavigateBundle(window.location.href, { replace: true, selectedSize: selectedSizeFromUrl() });
    }

    if (window.history && window.history.replaceState) {
      window.history.replaceState({ classicFitBundleUrl: window.location.pathname + window.location.search + window.location.hash }, '', window.location.href);
      window.addEventListener('popstate', handleBundlePopState);
      addCleanup(function() {
        window.removeEventListener('popstate', handleBundlePopState);
      });
    }

    bindGalleryThumbs();

      root.addEventListener('click', function(event) {
        var link = bundleNavigationLink(event.target);
        if (!link || !root.contains(link) || !plainNavigationClick(event)) return;
        var url = bundleNavigationUrl(link.getAttribute('href'));
        if (!url) return;
        event.preventDefault();
        softNavigateBundle(url, { expandRail: packRailExpanded, selectedSize: selectedSizeForNavigation() });
      });

    root.addEventListener('click', function(event) {
      var customizeButton = event.target.closest('[data-cf-customize-pack]');
      if (!customizeButton || !root.contains(customizeButton)) return;
      event.preventDefault();
      var inlinePackKeyValue = customizeButton.getAttribute('data-cf-inline-pack-key');
      if (isSingleProduct && inlinePackKeyValue) {
        var inlineOption = inlinePackOptionByKey(inlinePackKeyValue);
        withBundleSelectorLoading(function() {
          return inlineOption ? selectInlinePackOption(inlineOption) : hasComponentConfig;
        }).then(function(isReady) {
          if (!isReady && !hasComponentConfig) {
            if (statusEl) statusEl.textContent = 'Bundle item data has not been synced to Shopify yet.';
            return;
          }
          ensurePreviewSelections();
          customMode = true;
          renderCustomizer();
          refresh(false);
        });
        return;
      }
      var packUrlValue = customizeButton.getAttribute('data-cf-pack-url');
      if (packUrlValue && !isCurrentProductUrl(packUrlValue)) {
        softNavigateBundle(packUrlValue, { customise: true, expandRail: packRailExpanded, selectedSize: selectedSizeForNavigation() });
        return;
      }
      if (!hasComponentConfig) {
        if (statusEl) statusEl.textContent = 'Bundle item data has not been synced to Shopify yet.';
        return;
      }
      ensurePreviewSelections();
      customMode = true;
      renderCustomizer();
      refresh(false);
    });

	    root.querySelectorAll('[data-cf-color-modal-close]').forEach(function(button) {
	      button.addEventListener('click', closeColorModal);
	    });
	    Array.prototype.forEach.call(sizeGuideTriggers, function(button) {
	      button.addEventListener('click', function(event) {
	        event.preventDefault();
	        openSizeGuideModal();
	      });
	    });
	    Array.prototype.forEach.call(detailsTriggers, function(button) {
	      button.addEventListener('click', function(event) {
	        event.preventDefault();
	        openDetailsModal();
	      });
	    });
	    Array.prototype.forEach.call(reviewsTriggers, function(button) {
	      button.addEventListener('click', function(event) {
	        event.preventDefault();
	        openReviewsModal();
	      });
	      button.addEventListener('keydown', function(event) {
	        if (event.key !== 'Enter' && event.key !== ' ') return;
	        event.preventDefault();
	        openReviewsModal();
	      });
	    });
	    root.querySelectorAll('[data-cf-size-guide-close]').forEach(function(button) {
	      button.addEventListener('click', closeSizeGuideModal);
	    });
	    if (sizeGuideModal) {
	      sizeGuideModal.addEventListener('click', handleSizeGuideModalClick);
	      addCleanup(function() {
	        sizeGuideModal.removeEventListener('click', handleSizeGuideModalClick);
	      });
	    }
	    root.querySelectorAll('[data-cf-details-close]').forEach(function(button) {
	      button.addEventListener('click', closeDetailsModal);
	    });
	    if (detailsModal) {
	      detailsModal.addEventListener('click', handleDetailsModalClick);
	      addCleanup(function() {
	        detailsModal.removeEventListener('click', handleDetailsModalClick);
	      });
	    }
		    root.querySelectorAll('[data-cf-reviews-close]').forEach(function(button) {
		      button.addEventListener('click', closeReviewsModal);
		    });
		    if (reviewsModal) {
		      reviewsModal.addEventListener('click', handleReviewsModalClick);
		      addCleanup(function() {
		        reviewsModal.removeEventListener('click', handleReviewsModalClick);
		      });
		    }
		    Array.prototype.forEach.call(sizeGuideUnitButtons, function(button) {
	      button.addEventListener('click', function() {
	        setSizeGuideUnit(button.dataset.cfSizeGuideUnit);
	      });
	    });
	    if (colorModalApply) {
	      colorModalApply.addEventListener('click', applyColorModalDraft);
	    }
    if (colorModalPrev) {
      colorModalPrev.addEventListener('click', function() {
        scrollColorModalPreview(-1);
      });
    }
    if (colorModalNext) {
      colorModalNext.addEventListener('click', function() {
        scrollColorModalPreview(1);
      });
	    }
	    function handleColorModalKeydown(event) {
	      if (event.key !== 'Escape') return;
	      if (sizeGuideModal && !sizeGuideModal.hidden) {
	        closeSizeGuideModal();
	        return;
	      }
	      if (reviewsModal && !reviewsModal.hidden) {
	        closeReviewsModal();
	        return;
	      }
	      if (detailsModal && !detailsModal.hidden) {
	        closeDetailsModal();
	        return;
	      }
	      if (colorModal && !colorModal.hidden) closeColorModal();
	    }
	    document.addEventListener('keydown', handleColorModalKeydown);
	    addCleanup(function() {
	      document.removeEventListener('keydown', handleColorModalKeydown);
	      document.documentElement.classList.remove('cf-size-guide-modal-open');
	      document.documentElement.classList.remove('cf-details-modal-open');
	      document.documentElement.classList.remove('cf-reviews-modal-open');
	    });

    if (addButton) {
      addButton.addEventListener('click', function(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        var shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (singleModeActive()) {
          var selectedVariant = selectedSingleProductVariant();
          var selectedVariantId = selectedVariant && (selectedVariant.id || selectedVariant.shopifyVariantId || selectedVariant.variantId);
          if (!selectedVariantId || missingComponent()) return;
          addButton.disabled = true;
          addButton.textContent = 'Adding...';
          if (statusEl) statusEl.textContent = isMysteryBoxProduct
            ? 'Adding your mystery box to cart.'
            : 'Adding your shirt to cart.';
          fetch(shopifyRoot + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: selectedVariantId,
                quantity: 1
              }]
            })
          })
            .then(function(response) {
              if (!response.ok) return response.json().then(function(data) {
                throw new Error(data && data.description ? data.description : (isMysteryBoxProduct ? 'Could not add this mystery box.' : 'Could not add this shirt.'));
              });
              return response.json();
            })
            .then(function() {
              return fetch(shopifyRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
            })
            .then(function(response) { return response.json(); })
            .then(function(cart) {
              if (statusEl) statusEl.textContent = 'Added to cart.';
              updateCartUi(cart);
              refresh();
            })
            .catch(function(error) {
              if (statusEl) statusEl.textContent = error.message || (isMysteryBoxProduct ? 'Could not add this mystery box.' : 'Could not add this shirt.');
              refresh();
            });
          return;
        }
        if (!hasComponentConfig || bundleAvailabilityPending() || missingComponent()) return;
        var groupId = 'gtb-' + (currentProduct.id || currentProduct.handle || 'bundle') + '-' + Date.now();
        var bundleName = config.displayName || currentProduct.title;
        var bundleSizeLabel = selectedBundleSizeLabel();
        var items = selections.map(function(selection, index) {
          var componentImage = componentVariantImageForOption(selection);
          var componentImageUrl = usableImageUrl(componentImage && (componentImage.thumbUrl || componentImage.url)) ||
            usableImageUrl(selection && (selection.thumbUrl || selection.imageUrl));
          return {
            id: selection.shopifyVariantId,
            quantity: 1,
            properties: {
              '_gymtier_bundle': 'true',
              '_bundle_id': groupId,
              '_bundle_name': bundleName,
              '_bundle_code': config.bundleCode || currentProduct.handle,
              '_bundle_parent_handle': currentProduct.handle,
              '_bundle_source_product_id': currentProduct.id,
              '_bundle_url': currentProduct.url,
              '_bundle_image': currentProduct.imageUrl,
              '_bundle_quantity': String(currentQuantity || selections.length || ''),
              '_bundle_size': bundleSizeLabel,
              '_bundle_slot': String(index + 1),
              '_bundle_component_sku': selection.sku || '',
              '_bundle_component_product': selection.productTitle || '',
              '_bundle_component_variant': selection.variantTitle || '',
              '_bundle_component_color': selection.colorName || '',
              '_bundle_component_size': optionSizeValue(selection) || bundleSizeLabel || '',
              '_bundle_component_image': componentImageUrl || ''
            }
          };
        });

        addButton.disabled = true;
	        addButton.textContent = 'Adding...';
        if (statusEl) statusEl.textContent = 'Adding your pack to cart.';

        fetch(shopifyRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function(response) {
            if (!response.ok) return response.json().then(function(data) {
              throw new Error(data && data.description ? data.description : 'Could not add this pack.');
            });
            return response.json();
          })
          .then(function() {
            return fetch(shopifyRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
          })
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            if (statusEl) statusEl.textContent = 'Added to cart.';
            updateCartUi(cart);
            refresh();
          })
          .catch(function(error) {
            if (statusEl) statusEl.textContent = error.message || 'Could not add this pack.';
            refresh();
          });
      });
    }

    document.addEventListener('cart-update', handleExternalCartUpdate);
    document.body.addEventListener('cart:updated', handleExternalCartUpdate);
    document.addEventListener('click', handleCartDrawerInteraction);
    document.addEventListener('change', handleCartDrawerInteraction);
    addCleanup(function() {
      document.removeEventListener('cart-update', handleExternalCartUpdate);
      document.body.removeEventListener('cart:updated', handleExternalCartUpdate);
      document.removeEventListener('click', handleCartDrawerInteraction);
      document.removeEventListener('change', handleCartDrawerInteraction);
      if (cartSyncTimer) {
        window.clearTimeout(cartSyncTimer);
        cartSyncTimer = null;
      }
      cartSyncRequestId += 1;
    });

    refresh();
    prefetchLikelyPackOption();
    fetchReviewSummary(false);
    hydrateBundleSizeAvailability();
  }

  function initAllBundleProducts() {
    document.querySelectorAll('[data-cf-bundle-product]').forEach(initBundleProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBundleProducts);
  } else {
    initAllBundleProducts();
  }
}());
